/* eslint-disable */
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */
/** @typedef {{}} Agents_Agent_LabelInputs */
/** @typedef {{ name: NonNullable<unknown>, title: NonNullable<unknown> }} Agents_Answer_By_ParentInputs */
/** @typedef {{}} Agents_Answer_Raised_FromInputs */
/** @typedef {{}} Agents_ArchiveInputs */
/** @typedef {{}} Agents_Archived_EmptyInputs */
/** @typedef {{}} Agents_AttachInputs */
/** @typedef {{ name: NonNullable<unknown>, reason: NonNullable<unknown> }} Agents_Attachment_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Attachment_RemoveInputs */
/** @typedef {{}} Agents_AttachmentsInputs */
/** @typedef {{}} Agents_Bookmark_AddInputs */
/** @typedef {{}} Agents_Bookmark_RemoveInputs */
/** @typedef {{}} Agents_Browser_Read_OnlyInputs */
/** @typedef {{}} Agents_CancelInputs */
/** @typedef {{}} Agents_Case_ChatInputs */
/** @typedef {{}} Agents_Case_Chat_FailedInputs */
/** @typedef {{}} Agents_Change_ActionInputs */
/** @typedef {{}} Agents_Change_Agent_BodyInputs */
/** @typedef {{ agent: NonNullable<unknown> }} Agents_Change_Agent_TitleInputs */
/** @typedef {{}} Agents_Change_CompletedInputs */
/** @typedef {{}} Agents_Change_CreatedInputs */
/** @typedef {{}} Agents_Change_DelegatedInputs */
/** @typedef {{}} Agents_Change_DeletedInputs */
/** @typedef {{}} Agents_Change_DroppedInputs */
/** @typedef {{}} Agents_Change_Next_ReplyInputs */
/** @typedef {{}} Agents_Change_Obj_ActionInputs */
/** @typedef {{}} Agents_Change_Obj_CaseInputs */
/** @typedef {{}} Agents_Change_Obj_ChatInputs */
/** @typedef {{}} Agents_Change_Obj_OtherInputs */
/** @typedef {{}} Agents_Change_Obj_PageInputs */
/** @typedef {{}} Agents_Change_Obj_PersonInputs */
/** @typedef {{}} Agents_Change_Obj_WaitingInputs */
/** @typedef {{}} Agents_Change_PostedInputs */
/** @typedef {{}} Agents_Change_ReopenedInputs */
/** @typedef {{}} Agents_Change_UpdatedInputs */
/** @typedef {{}} Agents_ChangesInputs */
/** @typedef {{}} Agents_Child_QueuedInputs */
/** @typedef {{}} Agents_Child_RunningInputs */
/** @typedef {{}} Agents_Child_WaitingInputs */
/** @typedef {{}} Agents_ChildrenInputs */
/** @typedef {{}} Agents_Col_AgentInputs */
/** @typedef {{}} Agents_Col_CaseInputs */
/** @typedef {{}} Agents_Col_CostInputs */
/** @typedef {{}} Agents_Col_CreatedInputs */
/** @typedef {{}} Agents_Col_NameInputs */
/** @typedef {{}} Agents_Col_UpdatedInputs */
/** @typedef {{}} Agents_Composer_ShrinkInputs */
/** @typedef {{}} Agents_Conditions_CloseInputs */
/** @typedef {{}} Agents_Conditions_DrawerInputs */
/** @typedef {{}} Agents_Conditions_OpenInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Conditions_Open_DeviceInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Conditions_Open_Device_WarningInputs */
/** @typedef {{}} Agents_Conditions_Open_WarningInputs */
/** @typedef {{}} Agents_CopiedInputs */
/** @typedef {{}} Agents_CopyInputs */
/** @typedef {{}} Agents_Cwd_LabelInputs */
/** @typedef {{ value: NonNullable<unknown> }} Agents_Cwd_MissingInputs */
/** @typedef {{}} Agents_Cwd_Missing_NoteInputs */
/** @typedef {{}} Agents_Cwd_NoneInputs */
/** @typedef {{}} Agents_Cwd_None_NoteInputs */
/** @typedef {{}} Agents_Cwd_OtherInputs */
/** @typedef {{}} Agents_Cwd_OutsideInputs */
/** @typedef {{}} Agents_Delegate_StepInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Delegate_Step_FailedInputs */
/** @typedef {{}} Agents_Delegate_Step_OpenInputs */
/** @typedef {{}} Agents_DeleteInputs */
/** @typedef {{}} Agents_Delete_BodyInputs */
/** @typedef {{ names: NonNullable<unknown> }} Agents_Delete_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Agents_Delete_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Delete_TitleInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_AwayInputs */
/** @typedef {{}} Agents_Device_Away_ShortInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_ComingInputs */
/** @typedef {{}} Agents_Device_LabelInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_OfflineInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Device_Offline_PickInputs */
/** @typedef {{}} Agents_Device_ReadyInputs */
/** @typedef {{ self: NonNullable<unknown>, device: NonNullable<unknown> }} Agents_Device_Unreachable_LineInputs */
/** @typedef {{}} Agents_Devices_AddInputs */
/** @typedef {{}} Agents_Devices_Never_SeenInputs */
/** @typedef {{}} Agents_Draft_Ask_In_ChatInputs */
/** @typedef {{}} Agents_Draft_Copy_OriginalInputs */
/** @typedef {{}} Agents_Draft_Copy_SubjectInputs */
/** @typedef {{}} Agents_Draft_OpenInputs */
/** @typedef {{}} Agents_Draft_Open_OriginalInputs */
/** @typedef {{}} Agents_Draft_OriginalInputs */
/** @typedef {{}} Agents_Draft_Reason_PlaceholderInputs */
/** @typedef {{}} Agents_Draft_Reply_ToInputs */
/** @typedef {{}} Agents_Draft_Save_FailedInputs */
/** @typedef {{}} Agents_Draft_SideInputs */
/** @typedef {{}} Agents_Draft_Side_SourceInputs */
/** @typedef {{ lang: NonNullable<unknown> }} Agents_Draft_Side_TextInputs */
/** @typedef {{}} Agents_Draft_SlackInputs */
/** @typedef {{}} Agents_Draft_Slack_AgainInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Draft_Slack_FailedInputs */
/** @typedef {{}} Agents_Draft_Slack_PlacedInputs */
/** @typedef {{}} Agents_Draft_Slack_PlacingInputs */
/** @typedef {{}} Agents_Draft_Slack_Request_FailedInputs */
/** @typedef {{}} Agents_Draft_Slack_StaleInputs */
/** @typedef {{}} Agents_Draft_StaleInputs */
/** @typedef {{}} Agents_Draft_SubjectInputs */
/** @typedef {{}} Agents_Draft_TextInputs */
/** @typedef {{}} Agents_Draft_ThreadInputs */
/** @typedef {{}} Agents_Draft_To_UnknownInputs */
/** @typedef {{}} Agents_Draft_TranslationInputs */
/** @typedef {{}} Agents_Effort_LabelInputs */
/** @typedef {{}} Agents_EmptyInputs */
/** @typedef {{}} Agents_Empty_ActiveInputs */
/** @typedef {{}} Agents_FilterInputs */
/** @typedef {{}} Agents_Filter_ActiveInputs */
/** @typedef {{}} Agents_Filter_AllInputs */
/** @typedef {{}} Agents_Filter_ArchivedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_From_ParentInputs */
/** @typedef {{}} Agents_GoInputs */
/** @typedef {{ h: NonNullable<unknown>, m: NonNullable<unknown> }} Agents_Hours_MinutesInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Image_NInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Limit_DaysInputs */
/** @typedef {{ error: NonNullable<unknown>, at: NonNullable<unknown> }} Agents_Limit_ErrorInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Limit_HoursInputs */
/** @typedef {{ model: NonNullable<unknown> }} Agents_Limit_ModelInputs */
/** @typedef {{}} Agents_Limit_NoneInputs */
/** @typedef {{}} Agents_Limit_OffInputs */
/** @typedef {{ when: NonNullable<unknown> }} Agents_Limit_ResetsInputs */
/** @typedef {{}} Agents_Limit_TitleInputs */
/** @typedef {{}} Agents_Limit_WeekInputs */
/** @typedef {{}} Agents_ListInputs */
/** @typedef {{}} Agents_Load_FailedInputs */
/** @typedef {{}} Agents_Loading_OlderInputs */
/** @typedef {{}} Agents_Mark_CompactedInputs */
/** @typedef {{}} Agents_Mark_ReadInputs */
/** @typedef {{}} Agents_Mark_RewoundInputs */
/** @typedef {{}} Agents_Mark_StoppedInputs */
/** @typedef {{}} Agents_Mark_WithdrawnInputs */
/** @typedef {{}} Agents_MenuInputs */
/** @typedef {{}} Agents_Message_EditedInputs */
/** @typedef {{}} Agents_Message_RemovedInputs */
/** @typedef {{ m: NonNullable<unknown>, s: NonNullable<unknown> }} Agents_Minutes_SecondsInputs */
/** @typedef {{}} Agents_Model_Cli_DefaultInputs */
/** @typedef {{}} Agents_Model_LabelInputs */
/** @typedef {{}} Agents_More_ConditionsInputs */
/** @typedef {{}} Agents_NavInputs */
/** @typedef {{}} Agents_NewInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_New_HintInputs */
/** @typedef {{}} Agents_No_Agent_YetInputs */
/** @typedef {{}} Agents_No_DeviceInputs */
/** @typedef {{}} Agents_Not_FoundInputs */
/** @typedef {{}} Agents_Notice_AnsweredInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_AskedInputs */
/** @typedef {{}} Agents_Notice_EndedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Notice_FailedInputs */
/** @typedef {{}} Agents_Notice_InstructedInputs */
/** @typedef {{}} Agents_Notice_OtherInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_RaisedInputs */
/** @typedef {{}} Agents_Notice_ReadInputs */
/** @typedef {{}} Agents_Notice_RetriedInputs */
/** @typedef {{}} Agents_Notice_StartedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_Step_ClosedInputs */
/** @typedef {{}} Agents_Notice_StoppedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Notice_Turn_AddedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Notices_CountInputs */
/** @typedef {{}} Agents_Open_SettingsInputs */
/** @typedef {{}} Agents_Other_McpInputs */
/** @typedef {{}} Agents_Other_Mcp_ShortInputs */
/** @typedef {{}} Agents_Other_Mcp_WarningInputs */
/** @typedef {{}} Agents_OutlineInputs */
/** @typedef {{}} Agents_Outline_SideInputs */
/** @typedef {{}} Agents_Parent_ChatInputs */
/** @typedef {{}} Agents_Pc_AgentsInputs */
/** @typedef {{}} Agents_Pc_Auth_OkInputs */
/** @typedef {{ account: NonNullable<unknown> }} Agents_Pc_Auth_Ok_AccountInputs */
/** @typedef {{}} Agents_Pc_Auth_OutInputs */
/** @typedef {{}} Agents_Pc_Auth_UnknownInputs */
/** @typedef {{ agent: NonNullable<unknown> }} Agents_Pc_CompactInputs */
/** @typedef {{}} Agents_Pc_Compact_NoteInputs */
/** @typedef {{}} Agents_Pc_ConcurrencyInputs */
/** @typedef {{}} Agents_Pc_Concurrency_NoteInputs */
/** @typedef {{}} Agents_Pc_Default_AgentInputs */
/** @typedef {{}} Agents_Pc_Default_CwdInputs */
/** @typedef {{}} Agents_Pc_Default_Cwd_NoteInputs */
/** @typedef {{}} Agents_Pc_Default_ModelInputs */
/** @typedef {{}} Agents_Pc_DefaultsInputs */
/** @typedef {{}} Agents_Pc_DescriptionInputs */
/** @typedef {{}} Agents_Pc_LoginInputs */
/** @typedef {{}} Agents_Pc_Login_AgainInputs */
/** @typedef {{}} Agents_Pc_Login_CodeInputs */
/** @typedef {{}} Agents_Pc_Login_Code_HintInputs */
/** @typedef {{ error: NonNullable<unknown> }} Agents_Pc_Login_ErrorInputs */
/** @typedef {{}} Agents_Pc_Login_FailedInputs */
/** @typedef {{}} Agents_Pc_Login_OpenInputs */
/** @typedef {{}} Agents_Pc_Login_Open_CopyInputs */
/** @typedef {{}} Agents_Pc_Login_Paste_HintInputs */
/** @typedef {{}} Agents_Pc_Login_PreparingInputs */
/** @typedef {{}} Agents_Pc_Login_SentInputs */
/** @typedef {{}} Agents_Pc_Login_VerifyingInputs */
/** @typedef {{}} Agents_Pc_NameInputs */
/** @typedef {{}} Agents_Pc_Other_McpInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_AllInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_NoneInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_NoteInputs */
/** @typedef {{}} Agents_Pc_Other_Mcp_ReadInputs */
/** @typedef {{}} Agents_Pc_ParallelInputs */
/** @typedef {{}} Agents_Pc_QuietInputs */
/** @typedef {{}} Agents_Pc_Quiet_NoteInputs */
/** @typedef {{}} Agents_Pc_SerialInputs */
/** @typedef {{}} Agents_Pc_TitleInputs */
/** @typedef {{}} Agents_Pc_Usage_LimitsInputs */
/** @typedef {{}} Agents_Pc_Usage_Limits_NoteInputs */
/** @typedef {{}} Agents_Pc_WorkdirsInputs */
/** @typedef {{}} Agents_Pc_Workdirs_NoneInputs */
/** @typedef {{}} Agents_Pc_Workdirs_NoteInputs */
/** @typedef {{}} Agents_Pending_AfterInputs */
/** @typedef {{}} Agents_Pending_NextInputs */
/** @typedef {{}} Agents_Pending_Reading_NowInputs */
/** @typedef {{}} Agents_Pending_WithdrawingInputs */
/** @typedef {{}} Agents_Post_LabelInputs */
/** @typedef {{}} Agents_Post_PlaceholderInputs */
/** @typedef {{}} Agents_Post_Placeholder_RunningInputs */
/** @typedef {{}} Agents_Reach_No_SignerInputs */
/** @typedef {{ device: NonNullable<unknown>, self: NonNullable<unknown> }} Agents_Reach_Not_TrustedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Reach_Not_Trusted_UnnamedInputs */
/** @typedef {{ self: NonNullable<unknown>, device: NonNullable<unknown> }} Agents_Reach_Own_OnlyInputs */
/** @typedef {{ device: NonNullable<unknown> }} Agents_Reach_Self_OnlyInputs */
/** @typedef {{}} Agents_Read_NowInputs */
/** @typedef {{}} Agents_Related_ChangedInputs */
/** @typedef {{}} Agents_RenameInputs */
/** @typedef {{}} Agents_Rename_ActionInputs */
/** @typedef {{}} Agents_Request_FailedInputs */
/** @typedef {{}} Agents_RetryInputs */
/** @typedef {{}} Agents_Rewind_ActionInputs */
/** @typedef {{}} Agents_Rewind_CheckingInputs */
/** @typedef {{}} Agents_Rewind_ConversationInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Conversation_NInputs */
/** @typedef {{}} Agents_Rewind_Conversation_OneInputs */
/** @typedef {{}} Agents_Rewind_FailedInputs */
/** @typedef {{}} Agents_Rewind_FilesInputs */
/** @typedef {{}} Agents_Rewind_Files_BashInputs */
/** @typedef {{}} Agents_Rewind_Files_CodexInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Files_NInputs */
/** @typedef {{}} Agents_Rewind_Files_NoneInputs */
/** @typedef {{}} Agents_Rewind_Files_OffInputs */
/** @typedef {{}} Agents_Rewind_HereInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_MoreInputs */
/** @typedef {{}} Agents_Rewind_TitleInputs */
/** @typedef {{}} Agents_Rewind_TrameriaInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Rewind_Trameria_NInputs */
/** @typedef {{}} Agents_Rewind_Trameria_NoneInputs */
/** @typedef {{}} Agents_Row_AskingInputs */
/** @typedef {{}} Agents_Row_DelegatingInputs */
/** @typedef {{}} Agents_Row_QueuedInputs */
/** @typedef {{}} Agents_Row_UnreadInputs */
/** @typedef {{}} Agents_Row_WorkingInputs */
/** @typedef {{}} Agents_Save_FailedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_SecondsInputs */
/** @typedef {{}} Agents_SendInputs */
/** @typedef {{}} Agents_Send_FailedInputs */
/** @typedef {{}} Agents_Send_Hint_EnterInputs */
/** @typedef {{ mod: NonNullable<unknown> }} Agents_Send_Hint_ModInputs */
/** @typedef {{}} Agents_SendingInputs */
/** @typedef {{}} Agents_Side_CloseInputs */
/** @typedef {{}} Agents_Side_Composer_PlaceholderInputs */
/** @typedef {{}} Agents_Side_FromInputs */
/** @typedef {{}} Agents_Side_LabelInputs */
/** @typedef {{}} Agents_Side_NewInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Side_OpenInputs */
/** @typedef {{}} Agents_Side_Open_PageInputs */
/** @typedef {{}} Agents_Side_PlaceholderInputs */
/** @typedef {{}} Agents_Side_Reply_GoneInputs */
/** @typedef {{}} Agents_Side_StartInputs */
/** @typedef {{}} Agents_Signal_Slack_DraftInputs */
/** @typedef {{ caseTitle: NonNullable<unknown>, steps: NonNullable<unknown> }} Agents_Signal_Step_ReadyInputs */
/** @typedef {{}} Agents_Signal_Turn_AwaitingInputs */
/** @typedef {{}} Agents_Signal_Turn_DeclinedInputs */
/** @typedef {{}} Agents_Signal_Turn_WithdrawnInputs */
/** @typedef {{ caseTitle: NonNullable<unknown>, title: NonNullable<unknown> }} Agents_Signal_Wait_TargetInputs */
/** @typedef {{}} Agents_SomeoneInputs */
/** @typedef {{}} Agents_StartInputs */
/** @typedef {{}} Agents_Status_CompactingInputs */
/** @typedef {{}} Agents_Status_StartingInputs */
/** @typedef {{}} Agents_Status_StoppingInputs */
/** @typedef {{}} Agents_Status_ThinkingInputs */
/** @typedef {{}} Agents_Status_WaitingInputs */
/** @typedef {{}} Agents_Status_WritingInputs */
/** @typedef {{}} Agents_StopInputs */
/** @typedef {{}} Agents_Stop_FailedInputs */
/** @typedef {{}} Agents_Suggest_LoadingInputs */
/** @typedef {{}} Agents_Tap_To_WithdrawInputs */
/** @typedef {{}} Agents_This_Pc_NameInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Agents_Time_RangeInputs */
/** @typedef {{}} Agents_TitleInputs */
/** @typedef {{}} Agents_Title_LabelInputs */
/** @typedef {{}} Agents_Title_PlaceholderInputs */
/** @typedef {{}} Agents_To_EndInputs */
/** @typedef {{}} Agents_Turn_AfterInputs */
/** @typedef {{}} Agents_Turn_AnswerInputs */
/** @typedef {{}} Agents_Turn_Answer_FailedInputs */
/** @typedef {{}} Agents_Turn_BeforeInputs */
/** @typedef {{}} Agents_Turn_Browser_Read_OnlyInputs */
/** @typedef {{}} Agents_Turn_Cause_ApprovedInputs */
/** @typedef {{}} Agents_Turn_Cause_ConversationInputs */
/** @typedef {{}} Agents_Turn_Cause_HumanInputs */
/** @typedef {{}} Agents_Turn_ChangedInputs */
/** @typedef {{}} Agents_Turn_Check_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_Choice_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_ChosenInputs */
/** @typedef {{}} Agents_Turn_CloseInputs */
/** @typedef {{}} Agents_Turn_Closed_AlreadyInputs */
/** @typedef {{}} Agents_Turn_CommentInputs */
/** @typedef {{}} Agents_Turn_Comment_PlaceholderInputs */
/** @typedef {{ count: NonNullable<unknown> }} Agents_Turn_CountInputs */
/** @typedef {{}} Agents_Turn_Current_AboveInputs */
/** @typedef {{}} Agents_Turn_Date_ClearInputs */
/** @typedef {{}} Agents_Turn_Date_PickInputs */
/** @typedef {{}} Agents_Turn_Edited_By_YouInputs */
/** @typedef {{}} Agents_Turn_FoldInputs */
/** @typedef {{}} Agents_Turn_Form_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Turn_FromInputs */
/** @typedef {{}} Agents_Turn_Hand_OverInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_Turn_Held_ByInputs */
/** @typedef {{}} Agents_Turn_HistoryInputs */
/** @typedef {{}} Agents_Turn_Kind_CheckInputs */
/** @typedef {{}} Agents_Turn_Kind_Draft_EmailInputs */
/** @typedef {{}} Agents_Turn_Kind_Draft_SlackInputs */
/** @typedef {{}} Agents_Turn_Kind_OperateInputs */
/** @typedef {{}} Agents_Turn_Kind_ProvideInputs */
/** @typedef {{}} Agents_Turn_LabelInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Turn_Line_DoneInputs */
/** @typedef {{ title: NonNullable<unknown> }} Agents_Turn_Line_WithdrawnInputs */
/** @typedef {{}} Agents_Turn_LinksInputs */
/** @typedef {{}} Agents_Turn_MultiInputs */
/** @typedef {{}} Agents_Turn_Need_FixInputs */
/** @typedef {{}} Agents_Turn_Need_ReasonInputs */
/** @typedef {{}} Agents_Turn_NoInputs */
/** @typedef {{}} Agents_Turn_Operate_PlaceholderInputs */
/** @typedef {{ at: NonNullable<unknown>, count: NonNullable<unknown> }} Agents_Turn_PlaceInputs */
/** @typedef {{}} Agents_Turn_ProposalInputs */
/** @typedef {{}} Agents_Turn_Proposal_AcceptInputs */
/** @typedef {{}} Agents_Turn_Proposal_CurrentInputs */
/** @typedef {{}} Agents_Turn_Proposal_KeepInputs */
/** @typedef {{}} Agents_Turn_Provide_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_RecommendedInputs */
/** @typedef {{}} Agents_Turn_Result_DoneInputs */
/** @typedef {{}} Agents_Turn_Result_FailedInputs */
/** @typedef {{}} Agents_Turn_Result_FixInputs */
/** @typedef {{}} Agents_Turn_Result_OkInputs */
/** @typedef {{}} Agents_Turn_Result_SentInputs */
/** @typedef {{}} Agents_Turn_Result_UnsentInputs */
/** @typedef {{}} Agents_Turn_RewrittenInputs */
/** @typedef {{}} Agents_Turn_Text_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_Ui_ConfirmInputs */
/** @typedef {{}} Agents_Turn_Ui_PlaceholderInputs */
/** @typedef {{}} Agents_Turn_View_DraftInputs */
/** @typedef {{}} Agents_Turn_View_QuestionInputs */
/** @typedef {{}} Agents_Turn_View_RequestInputs */
/** @typedef {{}} Agents_Turn_YesInputs */
/** @typedef {{}} Agents_UnarchiveInputs */
/** @typedef {{}} Agents_UndoInputs */
/** @typedef {{}} Agents_Undo_AllInputs */
/** @typedef {{ n: NonNullable<unknown> }} Agents_Undo_All_TitleInputs */
/** @typedef {{}} Agents_Undo_ConflictInputs */
/** @typedef {{}} Agents_Undo_CreatedInputs */
/** @typedef {{}} Agents_Undo_DoneInputs */
/** @typedef {{}} Agents_Undo_FailedInputs */
/** @typedef {{ title: NonNullable<unknown>, op: NonNullable<unknown> }} Agents_Undo_TitleInputs */
/** @typedef {{}} Agents_Undo_UpdatedInputs */
/** @typedef {{}} Agents_Undo_WorkingInputs */
/** @typedef {{}} Agents_Unread_From_HereInputs */
/** @typedef {{}} Agents_UntitledInputs */
/** @typedef {{}} Agents_Usage_Cache_ReadInputs */
/** @typedef {{}} Agents_Usage_Cache_WriteInputs */
/** @typedef {{}} Agents_Usage_CompactInputs */
/** @typedef {{}} Agents_Usage_Compact_FailedInputs */
/** @typedef {{}} Agents_Usage_ContextInputs */
/** @typedef {{}} Agents_Usage_CostInputs */
/** @typedef {{}} Agents_Usage_EmptyInputs */
/** @typedef {{}} Agents_Usage_InputInputs */
/** @typedef {{}} Agents_Usage_LabelInputs */
/** @typedef {{}} Agents_Usage_OutputInputs */
/** @typedef {{}} Agents_Usage_SessionInputs */
/** @typedef {{ value: NonNullable<unknown> }} Agents_Value_MissingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Agents_ViaInputs */
/** @typedef {{}} Agents_View_LabelInputs */
/** @typedef {{}} Agents_Wait_Turn_ClosedInputs */
/** @typedef {{}} Agents_Wait_Turn_OpenInputs */
/** @typedef {{}} Agents_WithdrawInputs */
/** @typedef {{}} Agents_Withdraw_FailedInputs */
/** @typedef {{}} Agents_Withdraw_Too_LateInputs */
/** @typedef {{}} Blocks_Callout_BlueInputs */
/** @typedef {{ color: NonNullable<unknown> }} Blocks_Callout_Change_ColorInputs */
/** @typedef {{}} Blocks_Callout_ColorInputs */
/** @typedef {{}} Blocks_Callout_GreenInputs */
/** @typedef {{}} Blocks_Callout_PurpleInputs */
/** @typedef {{}} Blocks_Callout_RedInputs */
/** @typedef {{}} Blocks_Callout_Title_PlaceholderInputs */
/** @typedef {{}} Blocks_Callout_YellowInputs */
/** @typedef {{}} Blocks_CloseInputs */
/** @typedef {{}} Blocks_Code_CopyInputs */
/** @typedef {{}} Blocks_CopiedInputs */
/** @typedef {{}} Blocks_Copy_FailedInputs */
/** @typedef {{}} Blocks_Fence_CancelInputs */
/** @typedef {{}} Blocks_Fence_Edit_SourceInputs */
/** @typedef {{}} Blocks_Fence_SaveInputs */
/** @typedef {{}} Blocks_Fence_SourceInputs */
/** @typedef {{}} Blocks_File_ActionsInputs */
/** @typedef {{}} Blocks_File_Copy_LinkInputs */
/** @typedef {{}} Blocks_File_DeleteInputs */
/** @typedef {{}} Blocks_File_DownloadInputs */
/** @typedef {{}} Blocks_File_EnlargeInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_File_Enlarge_NamedInputs */
/** @typedef {{}} Blocks_File_Reset_WidthInputs */
/** @typedef {{}} Blocks_File_ResizeInputs */
/** @typedef {{ heading: NonNullable<unknown> }} Blocks_Footnote_BodyInputs */
/** @typedef {{ label: NonNullable<unknown> }} Blocks_Footnote_CreateInputs */
/** @typedef {{}} Blocks_Footnote_GoneInputs */
/** @typedef {{ heading: NonNullable<unknown> }} Blocks_Footnote_HeadingInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Footnote_NamedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Footnote_To_DefInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Footnote_To_RefInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Footnote_UnreferencedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Blocks_Mermaid_FailedInputs */
/** @typedef {{}} Blocks_Table_Add_AboveInputs */
/** @typedef {{}} Blocks_Table_Add_BelowInputs */
/** @typedef {{}} Blocks_Table_Add_ColInputs */
/** @typedef {{}} Blocks_Table_Add_LeftInputs */
/** @typedef {{}} Blocks_Table_Add_RightInputs */
/** @typedef {{}} Blocks_Table_Add_RowInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Col_ActionsInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Col_ResizeInputs */
/** @typedef {{}} Blocks_Table_Delete_ColInputs */
/** @typedef {{}} Blocks_Table_Delete_RowInputs */
/** @typedef {{}} Blocks_Table_Freeze_HereInputs */
/** @typedef {{ n: NonNullable<unknown> }} Blocks_Table_Row_ActionsInputs */
/** @typedef {{}} Blocks_Table_UnfreezeInputs */
/** @typedef {{}} Blocks_Toggle_CloseInputs */
/** @typedef {{}} Blocks_Toggle_OpenInputs */
/** @typedef {{}} Blocks_Upload_AbortedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Blocks_Upload_CancelInputs */
/** @typedef {{}} Blocks_Upload_FailedInputs */
/** @typedef {{}} Blocks_Upload_Failed_NetworkInputs */
/** @typedef {{ status: NonNullable<unknown> }} Blocks_Upload_Failed_StatusInputs */
/** @typedef {{}} Blocks_Upload_Too_LargeInputs */
/** @typedef {{}} Blocks_UploadsInputs */
/** @typedef {{}} Cases_Action_TitleInputs */
/** @typedef {{}} Cases_Action_Title_PlaceholderInputs */
/** @typedef {{}} Cases_AddInputs */
/** @typedef {{}} Cases_Add_ActionInputs */
/** @typedef {{}} Cases_Add_Action_ButtonInputs */
/** @typedef {{}} Cases_Add_Step_Needs_TitleInputs */
/** @typedef {{}} Cases_Add_WaitingInputs */
/** @typedef {{}} Cases_Add_Waiting_ButtonInputs */
/** @typedef {{}} Cases_Agent_MemoInputs */
/** @typedef {{}} Cases_BodyInputs */
/** @typedef {{}} Cases_Body_PlaceholderInputs */
/** @typedef {{}} Cases_Body_Write_PlaceholderInputs */
/** @typedef {{}} Cases_Case_TitleInputs */
/** @typedef {{}} Cases_ChainInputs */
/** @typedef {{}} Cases_Chain_DoneInputs */
/** @typedef {{}} Cases_Chain_EmptyInputs */
/** @typedef {{}} Cases_Chain_GraphInputs */
/** @typedef {{}} Cases_Chain_LaterInputs */
/** @typedef {{}} Cases_Chain_NowInputs */
/** @typedef {{}} Cases_Change_DueInputs */
/** @typedef {{}} Cases_Change_PlanInputs */
/** @typedef {{}} Cases_Change_Wait_UntilInputs */
/** @typedef {{}} Cases_Closed_EmptyInputs */
/** @typedef {{}} Cases_Col_CaseInputs */
/** @typedef {{}} Cases_Col_DueInputs */
/** @typedef {{}} Cases_Col_NameInputs */
/** @typedef {{}} Cases_Col_PlanInputs */
/** @typedef {{}} Cases_Col_UpdatedInputs */
/** @typedef {{}} Cases_Col_WaitInputs */
/** @typedef {{}} Cases_ContextInputs */
/** @typedef {{}} Cases_Context_PlaceholderInputs */
/** @typedef {{}} Cases_CreateInputs */
/** @typedef {{}} Cases_Create_Failed_KeptInputs */
/** @typedef {{}} Cases_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Delete_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Delete_TitleInputs */
/** @typedef {{}} Cases_DoneInputs */
/** @typedef {{}} Cases_DropInputs */
/** @typedef {{}} Cases_DueInputs */
/** @typedef {{}} Cases_Due_ClearInputs */
/** @typedef {{}} Cases_EmptyInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_BytesInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_KbInputs */
/** @typedef {{ n: NonNullable<unknown> }} Cases_File_MbInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_File_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_File_Remove_FailedInputs */
/** @typedef {{}} Cases_FilesInputs */
/** @typedef {{}} Cases_GoInputs */
/** @typedef {{}} Cases_Graph_DelegatedInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Cases_Graph_ProgressInputs */
/** @typedef {{}} Cases_Kind_ActionInputs */
/** @typedef {{}} Cases_Kind_WaitingInputs */
/** @typedef {{}} Cases_LabelInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Label_ChangeInputs */
/** @typedef {{}} Cases_Label_FailedInputs */
/** @typedef {{}} Cases_Label_SetInputs */
/** @typedef {{}} Cases_ListInputs */
/** @typedef {{}} Cases_Load_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_MenuInputs */
/** @typedef {{}} Cases_NewInputs */
/** @typedef {{}} Cases_Not_FoundInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_OverdueInputs */
/** @typedef {{}} Cases_Panel_CloseInputs */
/** @typedef {{}} Cases_PlanInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Plan_CarriedInputs */
/** @typedef {{}} Cases_Plan_ClearInputs */
/** @typedef {{}} Cases_Plan_Pick_DateInputs */
/** @typedef {{}} Cases_Plan_SomedayInputs */
/** @typedef {{}} Cases_Plan_This_WeekInputs */
/** @typedef {{}} Cases_Plan_TodayInputs */
/** @typedef {{}} Cases_Plan_TomorrowInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Plan_Week_OfInputs */
/** @typedef {{}} Cases_RelatedInputs */
/** @typedef {{}} Cases_Related_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_Add_FailedInputs */
/** @typedef {{}} Cases_Related_CandidatesInputs */
/** @typedef {{}} Cases_Related_NoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_RemoveInputs */
/** @typedef {{ name: NonNullable<unknown> }} Cases_Related_Remove_FailedInputs */
/** @typedef {{}} Cases_Related_SearchInputs */
/** @typedef {{}} Cases_Related_Search_PlaceholderInputs */
/** @typedef {{}} Cases_RenameInputs */
/** @typedef {{}} Cases_ReopenInputs */
/** @typedef {{}} Cases_ResultInputs */
/** @typedef {{}} Cases_Result_PlaceholderInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_BodyInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_ResultInputs */
/** @typedef {{ kind: NonNullable<unknown>, title: NonNullable<unknown> }} Cases_Source_Step_WaitInputs */
/** @typedef {{}} Cases_Status_DoneInputs */
/** @typedef {{}} Cases_Status_DroppedInputs */
/** @typedef {{}} Cases_Status_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Add_FailedInputs */
/** @typedef {{}} Cases_Step_Auto_ClosedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Close_FailedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Step_CreatedInputs */
/** @typedef {{}} Cases_Step_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Delete_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Delete_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_DoneInputs */
/** @typedef {{ date: NonNullable<unknown> }} Cases_Step_DueInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Due_FailedInputs */
/** @typedef {{}} Cases_Step_KindInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_MenuInputs */
/** @typedef {{ label: NonNullable<unknown> }} Cases_Step_PlanInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Plan_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Rename_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_Reopen_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Cases_Step_ResolveInputs */
/** @typedef {{}} Cases_Step_TitleInputs */
/** @typedef {{}} Cases_Step_UnplacedInputs */
/** @typedef {{}} Cases_Step_Unplaced_HintInputs */
/** @typedef {{}} Cases_Step_Wait_Target_DroppedInputs */
/** @typedef {{}} Cases_Tab_ClosedInputs */
/** @typedef {{}} Cases_Tab_NextInputs */
/** @typedef {{}} Cases_Tab_ReadyInputs */
/** @typedef {{}} Cases_Tab_WaitingInputs */
/** @typedef {{}} Cases_TabsInputs */
/** @typedef {{}} Cases_TitleInputs */
/** @typedef {{}} Cases_Title_FailedInputs */
/** @typedef {{}} Cases_Title_PlaceholderInputs */
/** @typedef {{}} Cases_Wait_UntilInputs */
/** @typedef {{}} Cases_Waiting_TitleInputs */
/** @typedef {{}} Cases_Waiting_Title_PlaceholderInputs */
/** @typedef {{}} Common_CancelInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Days_AgoInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Days_LaterInputs */
/** @typedef {{}} Common_DeleteInputs */
/** @typedef {{ lead: NonNullable<unknown>, message: NonNullable<unknown> }} Common_Error_With_LeadInputs */
/** @typedef {{}} Common_ForbiddenInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Hours_AgoInputs */
/** @typedef {{}} Common_Just_NowInputs */
/** @typedef {{}} Common_Load_More_FailedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Common_Minutes_AgoInputs */
/** @typedef {{}} Common_Picture_ApplyInputs */
/** @typedef {{}} Common_Picture_ChooseInputs */
/** @typedef {{}} Common_Picture_Crop_HintInputs */
/** @typedef {{}} Common_Picture_FailedInputs */
/** @typedef {{}} Common_Picture_RemoveInputs */
/** @typedef {{}} Common_Picture_StageInputs */
/** @typedef {{}} Common_Picture_UnreadableInputs */
/** @typedef {{}} Common_Picture_ZoomInputs */
/** @typedef {{}} Common_RetryInputs */
/** @typedef {{}} Common_SaveInputs */
/** @typedef {{}} Common_TodayInputs */
/** @typedef {{}} Common_TomorrowInputs */
/** @typedef {{}} Common_YesterdayInputs */
/** @typedef {{}} Datasets_Add_RowInputs */
/** @typedef {{}} Datasets_Col_FieldInputs */
/** @typedef {{}} Datasets_Col_FilledInputs */
/** @typedef {{}} Datasets_Date_ClearInputs */
/** @typedef {{}} Datasets_Date_PickInputs */
/** @typedef {{}} Datasets_Delete_RowInputs */
/** @typedef {{}} Datasets_Delete_Row_BodyInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_DistributionInputs */
/** @typedef {{}} Datasets_Distribution_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Distribution_TopInputs */
/** @typedef {{}} Datasets_Edit_RowInputs */
/** @typedef {{}} Datasets_FieldsInputs */
/** @typedef {{}} Datasets_Fields_GuessedInputs */
/** @typedef {{}} Datasets_Fields_NoneInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Json_InvalidInputs */
/** @typedef {{}} Datasets_KeyInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Key_MissingInputs */
/** @typedef {{}} Datasets_LatestInputs */
/** @typedef {{ shown: NonNullable<unknown>, count: NonNullable<unknown> }} Datasets_Latest_NoteInputs */
/** @typedef {{}} Datasets_ListInputs */
/** @typedef {{}} Datasets_List_BackInputs */
/** @typedef {{}} Datasets_List_EmptyInputs */
/** @typedef {{}} Datasets_List_Load_FailedInputs */
/** @typedef {{}} Datasets_List_NewInputs */
/** @typedef {{}} Datasets_List_None_MatchInputs */
/** @typedef {{}} Datasets_Load_FailedInputs */
/** @typedef {{}} Datasets_New_CreateInputs */
/** @typedef {{}} Datasets_New_FailedInputs */
/** @typedef {{}} Datasets_New_NoteInputs */
/** @typedef {{}} Datasets_New_TitleInputs */
/** @typedef {{}} Datasets_No_RowsInputs */
/** @typedef {{}} Datasets_Not_FoundInputs */
/** @typedef {{ field: NonNullable<unknown> }} Datasets_Number_InvalidInputs */
/** @typedef {{ days: NonNullable<unknown> }} Datasets_RetentionInputs */
/** @typedef {{}} Datasets_Row_ActionsInputs */
/** @typedef {{}} Datasets_Row_JsonInputs */
/** @typedef {{}} Datasets_Row_Json_InvalidInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_RowsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Stat_DistinctInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MaxInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MeanInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_MinInputs */
/** @typedef {{ count: NonNullable<unknown> }} Datasets_Stat_OnInputs */
/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown> }} Datasets_Stat_RangeInputs */
/** @typedef {{ value: NonNullable<unknown> }} Datasets_Stat_SumInputs */
/** @typedef {{}} Datasets_Token_CloseInputs */
/** @typedef {{ date: NonNullable<unknown> }} Datasets_Token_CreatedInputs */
/** @typedef {{}} Datasets_Token_EndpointInputs */
/** @typedef {{}} Datasets_Token_FailedInputs */
/** @typedef {{}} Datasets_Token_IssueInputs */
/** @typedef {{}} Datasets_Token_Issue_ActionInputs */
/** @typedef {{}} Datasets_Token_NameInputs */
/** @typedef {{}} Datasets_Token_Name_PlaceholderInputs */
/** @typedef {{}} Datasets_Token_RevokeInputs */
/** @typedef {{}} Datasets_Token_Revoke_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Datasets_Token_Revoke_LabelInputs */
/** @typedef {{}} Datasets_Token_Shown_OnceInputs */
/** @typedef {{}} Datasets_Token_UnusedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Datasets_Token_UsedInputs */
/** @typedef {{}} Datasets_TokensInputs */
/** @typedef {{}} Datasets_Tokens_FailedInputs */
/** @typedef {{}} Datasets_Tokens_LeftInputs */
/** @typedef {{}} Datasets_Tokens_Left_NextInputs */
/** @typedef {{}} Datasets_Tokens_NoneInputs */
/** @typedef {{}} Datasets_Tokens_NoteInputs */
/** @typedef {{}} Datasets_Tokens_VaultInputs */
/** @typedef {{}} Datasets_Type_BooleanInputs */
/** @typedef {{}} Datasets_Type_DateInputs */
/** @typedef {{}} Datasets_Type_DatetimeInputs */
/** @typedef {{}} Datasets_Type_JsonInputs */
/** @typedef {{}} Datasets_Type_NumberInputs */
/** @typedef {{}} Datasets_Type_StringInputs */
/** @typedef {{ time: NonNullable<unknown> }} Datasets_UpdatedInputs */
/** @typedef {{}} Datasets_Viewer_CloseInputs */
/** @typedef {{}} Datasets_Viewer_OpenInputs */
/** @typedef {{}} Datasets_Write_FailedInputs */
/** @typedef {{}} Datasets_Written_AtInputs */
/** @typedef {{}} Desktop_Action_StartInputs */
/** @typedef {{}} Desktop_Action_StopInputs */
/** @typedef {{ version: NonNullable<unknown> }} Desktop_Advanced_Agent_BundledInputs */
/** @typedef {{}} Desktop_App_Update_AvailableInputs */
/** @typedef {{ version: NonNullable<unknown> }} Desktop_App_Update_VersionInputs */
/** @typedef {{}} Desktop_Check_FlagsInputs */
/** @typedef {{}} Desktop_Check_Foreign_McpInputs */
/** @typedef {{}} Desktop_Check_LiveInputs */
/** @typedef {{ at: NonNullable<unknown>, version: NonNullable<unknown> }} Desktop_Check_Live_AtInputs */
/** @typedef {{ at: NonNullable<unknown>, version: NonNullable<unknown>, current: NonNullable<unknown> }} Desktop_Check_Live_At_StaleInputs */
/** @typedef {{}} Desktop_Check_Live_Not_RunInputs */
/** @typedef {{}} Desktop_Device_Add_HintInputs */
/** @typedef {{}} Desktop_Device_Needs_LoginInputs */
/** @typedef {{}} Desktop_Device_Not_RegisteredInputs */
/** @typedef {{}} Desktop_Device_RegisteredInputs */
/** @typedef {{}} Desktop_Device_Remove_HintInputs */
/** @typedef {{}} Desktop_Device_Removed_ElsewhereInputs */
/** @typedef {{}} Desktop_Find_CloseInputs */
/** @typedef {{}} Desktop_Find_NextInputs */
/** @typedef {{}} Desktop_Find_PlaceholderInputs */
/** @typedef {{}} Desktop_Find_PreviousInputs */
/** @typedef {{}} Desktop_Menubar_Agent_ToggleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Desktop_Menubar_Block_NextInputs */
/** @typedef {{}} Desktop_Notifications_BlockedInputs */
/** @typedef {{}} Desktop_Notifications_Blocked_NoteInputs */
/** @typedef {{}} Desktop_Notifications_Need_Signed_BuildInputs */
/** @typedef {{}} Desktop_Notifications_Open_SettingsInputs */
/** @typedef {{}} Desktop_Open_MainInputs */
/** @typedef {{}} Desktop_QuitInputs */
/** @typedef {{}} Desktop_Status_ConnectedInputs */
/** @typedef {{}} Desktop_Status_ErrorInputs */
/** @typedef {{}} Desktop_Status_ReconnectingInputs */
/** @typedef {{}} Desktop_Status_StartingInputs */
/** @typedef {{}} Desktop_Status_StoppedInputs */
/** @typedef {{}} Desktop_Status_StoppingInputs */
/** @typedef {{}} Desktop_Token_UnavailableInputs */
/** @typedef {{}} Desktop_Usage_LoadingInputs */
/** @typedef {{}} Desktop_Usage_Not_InstalledInputs */
/** @typedef {{}} Desktop_Usage_OffInputs */
/** @typedef {{}} Desktop_Usage_RefreshInputs */
/** @typedef {{}} Desktop_Usage_SettingsInputs */
/** @typedef {{ error: NonNullable<unknown> }} Desktop_Usage_Stale_ErrorInputs */
/** @typedef {{}} Desktop_Usage_TitleInputs */
/** @typedef {{ time: NonNullable<unknown> }} Desktop_Usage_Updated_AtInputs */
/** @typedef {{ n: NonNullable<unknown> }} Desktop_Usage_Updated_Minutes_AgoInputs */
/** @typedef {{}} Documents_Agent_MemoInputs */
/** @typedef {{}} Documents_ArchiveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Archive_FailedInputs */
/** @typedef {{}} Documents_Block_Bullet_ListInputs */
/** @typedef {{}} Documents_Block_CalloutInputs */
/** @typedef {{}} Documents_Block_CodeInputs */
/** @typedef {{}} Documents_Block_CopiedInputs */
/** @typedef {{}} Documents_Block_Copy_FailedInputs */
/** @typedef {{}} Documents_Block_Copy_MarkdownInputs */
/** @typedef {{}} Documents_Block_DeleteInputs */
/** @typedef {{}} Documents_Block_DividerInputs */
/** @typedef {{}} Documents_Block_DuplicateInputs */
/** @typedef {{}} Documents_Block_FileInputs */
/** @typedef {{}} Documents_Block_File_HintInputs */
/** @typedef {{}} Documents_Block_FootnoteInputs */
/** @typedef {{}} Documents_Block_Heading1Inputs */
/** @typedef {{}} Documents_Block_Heading2Inputs */
/** @typedef {{}} Documents_Block_Heading3Inputs */
/** @typedef {{}} Documents_Block_InsertInputs */
/** @typedef {{}} Documents_Block_Lift_OutInputs */
/** @typedef {{}} Documents_Block_MenuInputs */
/** @typedef {{}} Documents_Block_Menu_Section_BlockInputs */
/** @typedef {{}} Documents_Block_Menu_Section_TypeInputs */
/** @typedef {{}} Documents_Block_MermaidInputs */
/** @typedef {{}} Documents_Block_Numbered_ListInputs */
/** @typedef {{}} Documents_Block_ParagraphInputs */
/** @typedef {{}} Documents_Block_QuoteInputs */
/** @typedef {{}} Documents_Block_TableInputs */
/** @typedef {{}} Documents_Block_Task_ListInputs */
/** @typedef {{}} Documents_Block_ToggleInputs */
/** @typedef {{}} Documents_Block_Unwrap_ListInputs */
/** @typedef {{}} Documents_Block_Unwrap_QuoteInputs */
/** @typedef {{}} Documents_BodyInputs */
/** @typedef {{}} Documents_Body_PlaceholderInputs */
/** @typedef {{}} Documents_CloseInputs */
/** @typedef {{}} Documents_Col_CreatedInputs */
/** @typedef {{}} Documents_Col_NameInputs */
/** @typedef {{}} Documents_Col_UpdatedInputs */
/** @typedef {{}} Documents_Copied_To_OwnInputs */
/** @typedef {{}} Documents_CopyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Copy_FailedInputs */
/** @typedef {{}} Documents_Copy_To_OwnInputs */
/** @typedef {{}} Documents_CreateInputs */
/** @typedef {{}} Documents_Create_FailedInputs */
/** @typedef {{}} Documents_DeleteInputs */
/** @typedef {{}} Documents_Delete_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Delete_FailedInputs */
/** @typedef {{ names: NonNullable<unknown> }} Documents_Delete_Many_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_Delete_Many_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Delete_TitleInputs */
/** @typedef {{}} Documents_EmptyInputs */
/** @typedef {{}} Documents_Empty_ArchivedInputs */
/** @typedef {{}} Documents_HistoryInputs */
/** @typedef {{ name: NonNullable<unknown>, connection: NonNullable<unknown> }} Documents_History_Actor_ViaInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_Change_CountInputs */
/** @typedef {{}} Documents_History_ChangesInputs */
/** @typedef {{}} Documents_History_EmptyInputs */
/** @typedef {{}} Documents_History_FailedInputs */
/** @typedef {{}} Documents_History_Is_LatestInputs */
/** @typedef {{}} Documents_History_LatestInputs */
/** @typedef {{}} Documents_History_No_BodyInputs */
/** @typedef {{}} Documents_History_No_ChangesInputs */
/** @typedef {{}} Documents_History_RestoredInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_SavesInputs */
/** @typedef {{}} Documents_History_SystemInputs */
/** @typedef {{ count: NonNullable<unknown> }} Documents_History_UnchangedInputs */
/** @typedef {{}} Documents_History_VersionsInputs */
/** @typedef {{}} Documents_Index_AddInputs */
/** @typedef {{}} Documents_Index_Add_ExistingInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Add_FailedInputs */
/** @typedef {{}} Documents_Index_Add_NewInputs */
/** @typedef {{}} Documents_Index_ArchivedInputs */
/** @typedef {{}} Documents_Index_ButtonInputs */
/** @typedef {{}} Documents_Index_Create_FailedInputs */
/** @typedef {{}} Documents_Index_Create_WithInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Default_TitleInputs */
/** @typedef {{}} Documents_Index_Delete_BodyInputs */
/** @typedef {{}} Documents_Index_DetachInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Detach_FailedInputs */
/** @typedef {{}} Documents_Index_EmptyInputs */
/** @typedef {{}} Documents_Index_Existing_UnderInputs */
/** @typedef {{}} Documents_Index_FoldInputs */
/** @typedef {{}} Documents_Index_InInputs */
/** @typedef {{}} Documents_Index_In_NoneInputs */
/** @typedef {{}} Documents_Index_IndentInputs */
/** @typedef {{}} Documents_Index_Load_FailedInputs */
/** @typedef {{}} Documents_Index_MenuInputs */
/** @typedef {{}} Documents_Index_Move_DownInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Move_FailedInputs */
/** @typedef {{}} Documents_Index_Move_UpInputs */
/** @typedef {{}} Documents_Index_New_HintInputs */
/** @typedef {{}} Documents_Index_New_UnderInputs */
/** @typedef {{}} Documents_Index_OpenInputs */
/** @typedef {{}} Documents_Index_OutdentInputs */
/** @typedef {{}} Documents_Index_PickInputs */
/** @typedef {{}} Documents_Index_Pick_NoneInputs */
/** @typedef {{}} Documents_Index_Pick_SearchInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Put_FailedInputs */
/** @typedef {{}} Documents_Index_Put_InInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Index_Remove_FromInputs */
/** @typedef {{}} Documents_Index_TitleInputs */
/** @typedef {{}} Documents_Index_Title_PlaceholderInputs */
/** @typedef {{}} Documents_Index_UnfoldInputs */
/** @typedef {{}} Documents_Kind_HtmlInputs */
/** @typedef {{}} Documents_Kind_IndexInputs */
/** @typedef {{}} Documents_Kind_MarkdownInputs */
/** @typedef {{}} Documents_Kind_SlideInputs */
/** @typedef {{}} Documents_Link_SuggestInputs */
/** @typedef {{}} Documents_List_FailedInputs */
/** @typedef {{}} Documents_Load_FailedInputs */
/** @typedef {{}} Documents_MenuInputs */
/** @typedef {{}} Documents_Mermaid_Default_PayloadInputs */
/** @typedef {{}} Documents_MissingInputs */
/** @typedef {{}} Documents_MoreInputs */
/** @typedef {{}} Documents_NavInputs */
/** @typedef {{}} Documents_NewInputs */
/** @typedef {{}} Documents_New_DocumentInputs */
/** @typedef {{}} Documents_New_IndexInputs */
/** @typedef {{}} Documents_New_Index_ItemInputs */
/** @typedef {{}} Documents_New_MenuInputs */
/** @typedef {{}} Documents_OfflineInputs */
/** @typedef {{}} Documents_OutlineInputs */
/** @typedef {{}} Documents_Outline_HeadingsInputs */
/** @typedef {{}} Documents_Read_Only_ArchivedInputs */
/** @typedef {{}} Documents_Read_Only_NewerInputs */
/** @typedef {{}} Documents_Read_Only_Not_WritableInputs */
/** @typedef {{}} Documents_ReloadInputs */
/** @typedef {{}} Documents_Reload_NeededInputs */
/** @typedef {{}} Documents_Rename_FailedInputs */
/** @typedef {{}} Documents_RestoreInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Restore_BodyInputs */
/** @typedef {{}} Documents_Restore_FailedInputs */
/** @typedef {{ time: NonNullable<unknown> }} Documents_Restore_TitleInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Row_MenuInputs */
/** @typedef {{}} Documents_Save_PdfInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_BoldInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_CodeInputs */
/** @typedef {{}} Documents_Selection_Edit_LinkInputs */
/** @typedef {{}} Documents_Selection_FormatInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_ItalicInputs */
/** @typedef {{}} Documents_Selection_LinkInputs */
/** @typedef {{}} Documents_Selection_Link_UrlInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_Open_LinkInputs */
/** @typedef {{}} Documents_Selection_Paste_UrlInputs */
/** @typedef {{ key: NonNullable<unknown> }} Documents_Selection_StrikeInputs */
/** @typedef {{}} Documents_Selection_UnlinkInputs */
/** @typedef {{}} Documents_ShowInputs */
/** @typedef {{}} Documents_Show_ActiveInputs */
/** @typedef {{}} Documents_Show_ArchivedInputs */
/** @typedef {{}} Documents_Slide_NextInputs */
/** @typedef {{}} Documents_Slide_PreviousInputs */
/** @typedef {{}} Documents_SourceInputs */
/** @typedef {{}} Documents_Source_CloseInputs */
/** @typedef {{}} Documents_Source_ConflictInputs */
/** @typedef {{}} Documents_Source_EditInputs */
/** @typedef {{}} Documents_Source_QueryInputs */
/** @typedef {{}} Documents_Source_Query_FailedInputs */
/** @typedef {{}} Documents_Source_SaveInputs */
/** @typedef {{}} Documents_Source_Save_FailedInputs */
/** @typedef {{}} Documents_Source_SavedInputs */
/** @typedef {{}} Documents_Suggest_EmptyInputs */
/** @typedef {{}} Documents_TitleInputs */
/** @typedef {{}} Documents_Title_PlaceholderInputs */
/** @typedef {{}} Documents_UnarchiveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Documents_Unarchive_FailedInputs */
/** @typedef {{}} Documents_UntitledInputs */
/** @typedef {{ live: NonNullable<unknown>, candidate: NonNullable<unknown> }} Editor_Diff_Block_CountInputs */
/** @typedef {{}} Editor_Excerpt_CalloutInputs */
/** @typedef {{}} Editor_Excerpt_CodeInputs */
/** @typedef {{}} Editor_Excerpt_EmptyInputs */
/** @typedef {{}} Editor_Excerpt_HtmlInputs */
/** @typedef {{}} Editor_Excerpt_MermaidInputs */
/** @typedef {{}} Editor_Excerpt_RuleInputs */
/** @typedef {{}} Editor_Excerpt_TableInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Shape_Attr_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Block_Count_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Child_Count_DiffersInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Editor_Shape_Type_DiffersInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_Fix_RangeInputs */
/** @typedef {{}} Editor_Table_Option_ShapeInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_TwiceInputs */
/** @typedef {{ key: NonNullable<unknown> }} Editor_Table_Option_Unknown_KeyInputs */
/** @typedef {{}} Editor_Table_Option_WidthsInputs */
/** @typedef {{}} Editor_Toggle_Body_PlaceholderInputs */
/** @typedef {{}} Editor_Toggle_Summary_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Inbox_Answered_By_ParentInputs */
/** @typedef {{}} Inbox_CaseInputs */
/** @typedef {{}} Inbox_Case_AllInputs */
/** @typedef {{}} Inbox_ChatInputs */
/** @typedef {{}} Inbox_Chat_AllInputs */
/** @typedef {{}} Inbox_DoneInputs */
/** @typedef {{}} Inbox_Done_By_AgentInputs */
/** @typedef {{}} Inbox_Done_EmptyInputs */
/** @typedef {{}} Inbox_DotInputs */
/** @typedef {{ name: NonNullable<unknown> }} Inbox_FromInputs */
/** @typedef {{}} Inbox_GoInputs */
/** @typedef {{}} Inbox_Kind_DmInputs */
/** @typedef {{}} Inbox_Kind_MentionInputs */
/** @typedef {{}} Inbox_Kind_QuestionInputs */
/** @typedef {{}} Inbox_Kind_ReplyInputs */
/** @typedef {{}} Inbox_Load_FailedInputs */
/** @typedef {{}} Inbox_NarrowInputs */
/** @typedef {{}} Inbox_Narrow_PlaceholderInputs */
/** @typedef {{}} Inbox_NavInputs */
/** @typedef {{}} Inbox_No_MatchInputs */
/** @typedef {{}} Inbox_NowInputs */
/** @typedef {{}} Inbox_Now_EmptyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Inbox_UnreadInputs */
/** @typedef {{}} Inbox_WithdrawnInputs */
/** @typedef {{}} Inbox_Workspace_UnreachableInputs */
/** @typedef {{}} Inbox_Workspace_Unreachable_EmptyInputs */
/** @typedef {{}} Inbox_Workspace_Unreachable_WhyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_CustomInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Color_OfInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Create_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Create_NamedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_DeleteInputs */
/** @typedef {{}} Labels_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Delete_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Delete_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Move_DownInputs */
/** @typedef {{}} Labels_Move_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Move_UpInputs */
/** @typedef {{}} Labels_NameInputs */
/** @typedef {{}} Labels_NewInputs */
/** @typedef {{}} Labels_Pick_EmptyInputs */
/** @typedef {{}} Labels_Pick_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Labels_Rename_FailedInputs */
/** @typedef {{}} Labels_Settings_DescriptionInputs */
/** @typedef {{}} Labels_TitleInputs */
/** @typedef {{}} Local_Agent_DiagramInputs */
/** @typedef {{}} Local_Agent_Diagram_BrowserInputs */
/** @typedef {{}} Local_Agent_Diagram_CarrierInputs */
/** @typedef {{}} Local_Agent_Diagram_Carrier_NoteInputs */
/** @typedef {{}} Local_Agent_Diagram_DevicesInputs */
/** @typedef {{}} Local_Agent_Diagram_In_ListInputs */
/** @typedef {{}} Local_Agent_Diagram_RefusedInputs */
/** @typedef {{}} Local_Agent_Diagram_SignedInputs */
/** @typedef {{}} Local_Agent_Diagram_This_AppInputs */
/** @typedef {{}} Local_Agent_Help_BrowserInputs */
/** @typedef {{}} Local_Agent_Help_SignedInputs */
/** @typedef {{}} Local_Agent_Help_TitleInputs */
/** @typedef {{}} Local_Agent_OthersInputs */
/** @typedef {{}} Local_Agent_Others_NoteInputs */
/** @typedef {{}} Local_Agent_Others_Off_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Agent_Others_Vault_Off_NoteInputs */
/** @typedef {{}} Local_Agent_UseInputs */
/** @typedef {{}} Local_Agent_Use_NoteInputs */
/** @typedef {{}} Local_BackupInputs */
/** @typedef {{}} Local_Backup_ChooseInputs */
/** @typedef {{}} Local_Backup_DefaultInputs */
/** @typedef {{}} Local_Backup_DescriptionInputs */
/** @typedef {{}} Local_Backup_Error_FailedInputs */
/** @typedef {{}} Local_Backup_Error_Inside_DataInputs */
/** @typedef {{}} Local_Backup_Error_Not_AbsoluteInputs */
/** @typedef {{}} Local_Backup_Error_Not_WritableInputs */
/** @typedef {{}} Local_Backup_FailedInputs */
/** @typedef {{}} Local_Backup_FolderInputs */
/** @typedef {{}} Local_Backup_Folder_NoteInputs */
/** @typedef {{}} Local_Backup_LastInputs */
/** @typedef {{}} Local_Backup_MissingInputs */
/** @typedef {{}} Local_Backup_NoneInputs */
/** @typedef {{}} Local_Backup_Not_WritableInputs */
/** @typedef {{}} Local_Backup_PathInputs */
/** @typedef {{}} Local_Backup_ResetInputs */
/** @typedef {{}} Local_Backup_UseInputs */
/** @typedef {{}} Local_CloudInputs */
/** @typedef {{}} Local_Cloud_AccountInputs */
/** @typedef {{}} Local_Cloud_Account_SettingsInputs */
/** @typedef {{}} Local_Cloud_Account_Settings_DescriptionInputs */
/** @typedef {{}} Local_Cloud_Again_DoneInputs */
/** @typedef {{}} Local_Cloud_Agent_FailedInputs */
/** @typedef {{}} Local_Cloud_Agent_RemovedInputs */
/** @typedef {{}} Local_Cloud_Code_NoteInputs */
/** @typedef {{}} Local_Cloud_DeniedInputs */
/** @typedef {{}} Local_Cloud_DescriptionInputs */
/** @typedef {{}} Local_Cloud_DeviceInputs */
/** @typedef {{}} Local_Cloud_Device_DoneInputs */
/** @typedef {{}} Local_Cloud_Device_Hub_Not_TiedInputs */
/** @typedef {{}} Local_Cloud_Device_Hub_UnreachableInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Device_InInputs */
/** @typedef {{ hub: NonNullable<unknown>, mine: NonNullable<unknown> }} Local_Cloud_Device_MismatchInputs */
/** @typedef {{}} Local_Cloud_Device_Needs_HubInputs */
/** @typedef {{}} Local_Cloud_Device_NoneInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Cloud_Device_OtherInputs */
/** @typedef {{}} Local_Cloud_ExpiredInputs */
/** @typedef {{}} Local_Cloud_FrameInputs */
/** @typedef {{}} Local_Cloud_Frame_Signed_Out_BodyInputs */
/** @typedef {{ from: NonNullable<unknown> }} Local_Cloud_From_LoginInputs */
/** @typedef {{}} Local_Cloud_Hub_AwayInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Cloud_Hub_RowInputs */
/** @typedef {{}} Local_Cloud_Hub_TokenInputs */
/** @typedef {{}} Local_Cloud_LinkedInputs */
/** @typedef {{}} Local_Cloud_LoginInputs */
/** @typedef {{}} Local_Cloud_Login_AgainInputs */
/** @typedef {{}} Local_Cloud_LogoutInputs */
/** @typedef {{}} Local_Cloud_Logout_BodyInputs */
/** @typedef {{}} Local_Cloud_Logout_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Logout_TitleInputs */
/** @typedef {{}} Local_Cloud_NoneInputs */
/** @typedef {{}} Local_Cloud_OpenInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Cloud_OtherInputs */
/** @typedef {{}} Local_Cloud_RestartingInputs */
/** @typedef {{}} Local_Cloud_RetryInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_BodyInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_OpenInputs */
/** @typedef {{}} Local_Cloud_Signed_Out_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_TiedInputs */
/** @typedef {{}} Local_Cloud_UnlinkInputs */
/** @typedef {{}} Local_Cloud_Unlink_BodyInputs */
/** @typedef {{}} Local_Cloud_Unlink_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Cloud_Unlink_TitleInputs */
/** @typedef {{}} Local_Cloud_UnreachableInputs */
/** @typedef {{}} Local_Cloud_Unreached_BodyInputs */
/** @typedef {{}} Local_Cloud_Unreached_TitleInputs */
/** @typedef {{}} Local_Cloud_WaitingInputs */
/** @typedef {{}} Local_DmsInputs */
/** @typedef {{}} Local_Dms_UnreadInputs */
/** @typedef {{ dir: NonNullable<unknown> }} Local_Headless_Backup_DirInputs */
/** @typedef {{ dir: NonNullable<unknown>, reason: NonNullable<unknown> }} Local_Headless_Backup_Dir_RefusedInputs */
/** @typedef {{ addresses: NonNullable<unknown> }} Local_Headless_Connect_ToInputs */
/** @typedef {{ app: NonNullable<unknown>, error: NonNullable<unknown> }} Local_Headless_Could_Not_StartInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_LinkedInputs */
/** @typedef {{ account: NonNullable<unknown> }} Local_Headless_Login_AgainInputs */
/** @typedef {{ account: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_BoundInputs */
/** @typedef {{}} Local_Headless_Login_DeniedInputs */
/** @typedef {{}} Local_Headless_Login_ExpiredInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Headless_Login_FailedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_LinkedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Login_Not_RunningInputs */
/** @typedef {{ url: NonNullable<unknown>, code: NonNullable<unknown>, minutes: NonNullable<unknown> }} Local_Headless_Login_OpenInputs */
/** @typedef {{ account: NonNullable<unknown>, tied: NonNullable<unknown> }} Local_Headless_Login_OtherInputs */
/** @typedef {{}} Local_Headless_Login_WaitingInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Others_Not_RunningInputs */
/** @typedef {{}} Local_Headless_Others_OffInputs */
/** @typedef {{}} Local_Headless_Others_OnInputs */
/** @typedef {{}} Local_Headless_Others_UsageInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Headless_Pair_FailedInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_No_PairingInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_Not_RunningInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown>, port: NonNullable<unknown> }} Local_Headless_Pair_Port_In_UseInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Pair_Remote_OffInputs */
/** @typedef {{ minutes: NonNullable<unknown>, code: NonNullable<unknown> }} Local_Headless_Pairing_CodeInputs */
/** @typedef {{ port: NonNullable<unknown> }} Local_Headless_PortInputs */
/** @typedef {{ port: NonNullable<unknown>, error: NonNullable<unknown> }} Local_Headless_Port_In_UseInputs */
/** @typedef {{ time: NonNullable<unknown> }} Local_Headless_RestoredInputs */
/** @typedef {{ app: NonNullable<unknown>, dir: NonNullable<unknown> }} Local_Headless_RunningInputs */
/** @typedef {{ account: NonNullable<unknown> }} Local_Headless_Unlink_DoneInputs */
/** @typedef {{}} Local_Headless_Unlink_NoneInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Headless_Unlink_Not_RunningInputs */
/** @typedef {{}} Local_Link_ConnectedInputs */
/** @typedef {{}} Local_Link_Connected_CloudInputs */
/** @typedef {{ where: NonNullable<unknown> }} Local_Link_Connected_ViaInputs */
/** @typedef {{}} Local_Link_ConnectingInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Hub_DoorInputs */
/** @typedef {{}} Local_Link_Hub_Door_AwayInputs */
/** @typedef {{}} Local_Link_Hub_Door_Not_TiedInputs */
/** @typedef {{}} Local_Link_Hub_Door_NoteInputs */
/** @typedef {{}} Local_Link_Hub_Door_Via_CloudInputs */
/** @typedef {{}} Local_Link_Invalid_CodeInputs */
/** @typedef {{}} Local_Link_Is_HubInputs */
/** @typedef {{}} Local_Link_JoinInputs */
/** @typedef {{}} Local_Link_Join_ButtonInputs */
/** @typedef {{}} Local_Link_Join_NoteInputs */
/** @typedef {{}} Local_Link_LeaveInputs */
/** @typedef {{}} Local_Link_Leave_BodyInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Leave_TitleInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_MainInputs */
/** @typedef {{}} Local_Link_Network_SettingsInputs */
/** @typedef {{}} Local_Link_Open_SettingsInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_ReconnectingInputs */
/** @typedef {{}} Local_Link_Reconnecting_Not_ListeningInputs */
/** @typedef {{}} Local_Link_Reconnecting_Sign_InInputs */
/** @typedef {{}} Local_Link_RefusedInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_RemovedInputs */
/** @typedef {{}} Local_Link_Removed_ShortInputs */
/** @typedef {{}} Local_Link_RoutesInputs */
/** @typedef {{}} Local_Link_Routes_Cloud_HomeInputs */
/** @typedef {{}} Local_Link_Routes_No_Sign_InInputs */
/** @typedef {{}} Local_Link_Routes_NoteInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Screen_App_OutdatedInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Screen_Hub_OutdatedInputs */
/** @typedef {{}} Local_Link_UnreachableInputs */
/** @typedef {{}} Local_Link_Unreachable_MacInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Unreachable_NowInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Link_Write_FailedInputs */
/** @typedef {{}} Local_McpInputs */
/** @typedef {{}} Local_Mcp_Claude_Code_NoteInputs */
/** @typedef {{}} Local_Mcp_Claude_Desktop_NoteInputs */
/** @typedef {{}} Local_Mcp_Codex_NoteInputs */
/** @typedef {{}} Local_Mcp_CopiedInputs */
/** @typedef {{}} Local_Mcp_CopyInputs */
/** @typedef {{}} Local_Mcp_Copy_FailedInputs */
/** @typedef {{}} Local_Mcp_DescriptionInputs */
/** @typedef {{}} Local_Mcp_Load_FailedInputs */
/** @typedef {{}} Local_Mcp_RetryInputs */
/** @typedef {{}} Local_Mcp_UnavailableInputs */
/** @typedef {{}} Local_Me_CancelInputs */
/** @typedef {{}} Local_Me_Cancel_BodyInputs */
/** @typedef {{}} Local_Me_Cancel_TitleInputs */
/** @typedef {{}} Local_Me_CancelledInputs */
/** @typedef {{}} Local_Me_ChangesInputs */
/** @typedef {{}} Local_Me_Check_Far_NoteInputs */
/** @typedef {{}} Local_Me_Check_Far_TitleInputs */
/** @typedef {{}} Local_Me_Check_Google_NoteInputs */
/** @typedef {{}} Local_Me_Check_Google_TitleInputs */
/** @typedef {{}} Local_Me_Check_Hub_Agents_NoteInputs */
/** @typedef {{}} Local_Me_Check_Hub_Agents_TitleInputs */
/** @typedef {{}} Local_Me_Check_Phone_NoteInputs */
/** @typedef {{}} Local_Me_Check_Phone_TitleInputs */
/** @typedef {{}} Local_Me_Check_Published_NoteInputs */
/** @typedef {{}} Local_Me_Check_Published_TitleInputs */
/** @typedef {{}} Local_Me_Check_Sandbox_NoteInputs */
/** @typedef {{}} Local_Me_Check_Sandbox_TitleInputs */
/** @typedef {{}} Local_Me_Check_Web_GetsInputs */
/** @typedef {{}} Local_Me_Check_Web_LosesInputs */
/** @typedef {{}} Local_Me_Check_Web_TitleInputs */
/** @typedef {{}} Local_Me_Elsewhere_BodyInputs */
/** @typedef {{}} Local_Me_Elsewhere_TitleInputs */
/** @typedef {{ length: NonNullable<unknown> }} Local_Me_EstimateInputs */
/** @typedef {{}} Local_Me_Estimate_LongInputs */
/** @typedef {{}} Local_Me_Estimate_MinuteInputs */
/** @typedef {{}} Local_Me_Estimate_MinutesInputs */
/** @typedef {{}} Local_Me_Estimate_SecondsInputs */
/** @typedef {{ message: NonNullable<unknown> }} Local_Me_FailedInputs */
/** @typedef {{}} Local_Me_Failed_ChangedInputs */
/** @typedef {{}} Local_Me_Failed_LimitInputs */
/** @typedef {{}} Local_Me_Failed_UnreachableInputs */
/** @typedef {{ time: NonNullable<unknown>, place: NonNullable<unknown> }} Local_Me_FinishedInputs */
/** @typedef {{ time: NonNullable<unknown>, what: NonNullable<unknown>, place: NonNullable<unknown> }} Local_Me_Finished_MergeInputs */
/** @typedef {{}} Local_Me_Finished_Place_CloudInputs */
/** @typedef {{}} Local_Me_Finished_Place_HubInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Local_Me_Finished_WhatInputs */
/** @typedef {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} Local_Me_Finished_What_MoreInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Me_Item_CreatedInputs */
/** @typedef {{}} Local_Me_MergeInputs */
/** @typedef {{}} Local_Me_Merge_BodyInputs */
/** @typedef {{}} Local_Me_Merge_From_CloudInputs */
/** @typedef {{}} Local_Me_Merge_From_HubInputs */
/** @typedef {{}} Local_Me_Merge_KeptInputs */
/** @typedef {{}} Local_Me_Merge_LabelsInputs */
/** @typedef {{}} Local_Me_Merge_NoneInputs */
/** @typedef {{}} Local_Me_Merge_PersonsInputs */
/** @typedef {{}} Local_Me_Merge_Persons_NoteInputs */
/** @typedef {{}} Local_Me_Merge_To_CloudInputs */
/** @typedef {{}} Local_Me_Merge_To_Cloud_TitleInputs */
/** @typedef {{}} Local_Me_Merge_To_HubInputs */
/** @typedef {{}} Local_Me_Merge_To_Hub_TitleInputs */
/** @typedef {{}} Local_Me_Move_BodyInputs */
/** @typedef {{}} Local_Me_MovesInputs */
/** @typedef {{}} Local_Me_Moving_DigestInputs */
/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Local_Me_Moving_Digest_OfInputs */
/** @typedef {{}} Local_Me_Moving_FilesInputs */
/** @typedef {{}} Local_Me_Moving_MergeInputs */
/** @typedef {{}} Local_Me_Moving_NoteInputs */
/** @typedef {{}} Local_Me_Moving_SendInputs */
/** @typedef {{}} Local_Me_Moving_VerifyInputs */
/** @typedef {{}} Local_Me_PlaceInputs */
/** @typedef {{}} Local_Me_Place_Both_NowInputs */
/** @typedef {{}} Local_Me_Place_CloudInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Me_Place_Cloud_CopyInputs */
/** @typedef {{}} Local_Me_Place_Cloud_OnlyInputs */
/** @typedef {{}} Local_Me_Place_HubInputs */
/** @typedef {{}} Local_Me_Place_Other_HubInputs */
/** @typedef {{}} Local_Me_Place_UnreachableInputs */
/** @typedef {{}} Local_Me_Place_UpdateInputs */
/** @typedef {{}} Local_Me_Queue_CancelInputs */
/** @typedef {{ ahead: NonNullable<unknown>, minutes: NonNullable<unknown> }} Local_Me_QueuedInputs */
/** @typedef {{}} Local_Me_Queued_NoteInputs */
/** @typedef {{ ahead: NonNullable<unknown> }} Local_Me_Queued_SoonInputs */
/** @typedef {{}} Local_Me_RetryInputs */
/** @typedef {{}} Local_Me_Side_CloudInputs */
/** @typedef {{}} Local_Me_Side_HubInputs */
/** @typedef {{}} Local_Me_StoppedInputs */
/** @typedef {{ minutes: NonNullable<unknown>, seconds: NonNullable<unknown> }} Local_Me_Time_MinutesInputs */
/** @typedef {{ seconds: NonNullable<unknown> }} Local_Me_Time_SecondsInputs */
/** @typedef {{}} Local_Me_To_CloudInputs */
/** @typedef {{}} Local_Me_To_Cloud_TitleInputs */
/** @typedef {{}} Local_Me_To_HubInputs */
/** @typedef {{}} Local_Me_To_Hub_TitleInputs */
/** @typedef {{}} Local_Me_UntitledInputs */
/** @typedef {{}} Local_MenubarInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Menubar_AgentInputs */
/** @typedef {{}} Local_Menubar_Agent_Cloud_OffInputs */
/** @typedef {{}} Local_Menubar_Agent_Cloud_OnInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Agent_Hub_OnInputs */
/** @typedef {{}} Local_Menubar_Agent_UnusedInputs */
/** @typedef {{}} Local_Menubar_Cloud_Signed_InInputs */
/** @typedef {{}} Local_Menubar_DescriptionInputs */
/** @typedef {{ count: NonNullable<unknown> }} Local_Menubar_Hub_DevicesInputs */
/** @typedef {{}} Local_Menubar_Hub_ListeningInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_OffInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_OnInputs */
/** @typedef {{ main: NonNullable<unknown> }} Local_Menubar_Hub_On_CloudInputs */
/** @typedef {{ main: NonNullable<unknown>, where: NonNullable<unknown> }} Local_Menubar_Hub_On_WhereInputs */
/** @typedef {{}} Local_Menubar_Hub_Port_In_UseInputs */
/** @typedef {{}} Local_Menubar_IconInputs */
/** @typedef {{}} Local_Menubar_Icon_LogoInputs */
/** @typedef {{}} Local_Menubar_Icon_NoteInputs */
/** @typedef {{}} Local_Menubar_Icon_UsageInputs */
/** @typedef {{}} Local_Menubar_ProviderInputs */
/** @typedef {{}} Local_Menubar_Provider_NoteInputs */
/** @typedef {{}} Local_Menubar_Provider_Note_UnusedInputs */
/** @typedef {{}} Local_Menubar_ShowInputs */
/** @typedef {{}} Local_Menubar_Show_NoteInputs */
/** @typedef {{}} Local_Notice_Cloud_LoginInputs */
/** @typedef {{ from: NonNullable<unknown>, name: NonNullable<unknown> }} Local_Notice_Cloud_Login_BodyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_FailedInputs */
/** @typedef {{}} Local_Notice_Failed_BodyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_ReplyInputs */
/** @typedef {{ chat: NonNullable<unknown> }} Local_Notice_TurnInputs */
/** @typedef {{}} Local_Open_In_New_WindowInputs */
/** @typedef {{}} Local_RailInputs */
/** @typedef {{}} Local_Rail_NewInputs */
/** @typedef {{}} Local_ReleaseInputs */
/** @typedef {{}} Local_Release_ActionInputs */
/** @typedef {{}} Local_Release_BodyInputs */
/** @typedef {{ title: NonNullable<unknown> }} Local_Release_FailedInputs */
/** @typedef {{}} Local_Release_No_SpaceInputs */
/** @typedef {{}} Local_Release_NoneInputs */
/** @typedef {{}} Local_Release_SpaceInputs */
/** @typedef {{ title: NonNullable<unknown> }} Local_Release_TitleInputs */
/** @typedef {{}} Local_Release_UnavailableInputs */
/** @typedef {{}} Local_Release_WorkspaceInputs */
/** @typedef {{ title: NonNullable<unknown>, workspace: NonNullable<unknown> }} Local_ReleasedInputs */
/** @typedef {{}} Local_RemoteInputs */
/** @typedef {{}} Local_Remote_AddInputs */
/** @typedef {{}} Local_Remote_Add_NoteInputs */
/** @typedef {{}} Local_Remote_CloudInputs */
/** @typedef {{}} Local_Remote_Cloud_ConnectingInputs */
/** @typedef {{}} Local_Remote_Cloud_Needs_TieInputs */
/** @typedef {{}} Local_Remote_Cloud_NoteInputs */
/** @typedef {{}} Local_Remote_Cloud_OpenInputs */
/** @typedef {{}} Local_Remote_Cloud_RefusedInputs */
/** @typedef {{}} Local_Remote_CodeInputs */
/** @typedef {{}} Local_Remote_ConnectedInputs */
/** @typedef {{ where: NonNullable<unknown> }} Local_Remote_Connected_FromInputs */
/** @typedef {{}} Local_Remote_DescriptionInputs */
/** @typedef {{}} Local_Remote_DevicesInputs */
/** @typedef {{}} Local_Remote_Devices_NoneInputs */
/** @typedef {{}} Local_Remote_FailedInputs */
/** @typedef {{}} Local_Remote_LinkedInputs */
/** @typedef {{}} Local_Remote_ListenInputs */
/** @typedef {{}} Local_Remote_Listen_NoteInputs */
/** @typedef {{ port: NonNullable<unknown> }} Local_Remote_Port_In_UseInputs */
/** @typedef {{}} Local_Remote_RemoveInputs */
/** @typedef {{}} Local_Remote_Remove_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Remote_Remove_TitleInputs */
/** @typedef {{}} Local_Remote_RetryInputs */
/** @typedef {{}} Local_Route_AnywhereInputs */
/** @typedef {{}} Local_Route_Client_Cloud_HomeInputs */
/** @typedef {{}} Local_Route_Client_DiagramInputs */
/** @typedef {{}} Local_Route_Client_NeedsInputs */
/** @typedef {{}} Local_Route_Client_TitleInputs */
/** @typedef {{}} Local_Route_DevicesInputs */
/** @typedef {{}} Local_Route_DirectInputs */
/** @typedef {{}} Local_Route_Direct_FirstInputs */
/** @typedef {{}} Local_Route_HelpInputs */
/** @typedef {{}} Local_Route_Help_CloseInputs */
/** @typedef {{}} Local_Route_HubInputs */
/** @typedef {{}} Local_Route_Hub_Cloud_HomeInputs */
/** @typedef {{}} Local_Route_Hub_CopyInputs */
/** @typedef {{}} Local_Route_Hub_DiagramInputs */
/** @typedef {{}} Local_Route_Hub_First_DirectInputs */
/** @typedef {{}} Local_Route_Hub_Paired_OnlyInputs */
/** @typedef {{}} Local_Route_Hub_TitleInputs */
/** @typedef {{}} Local_Route_NetworkInputs */
/** @typedef {{}} Local_Route_Network_NoteInputs */
/** @typedef {{}} Local_Route_OffInputs */
/** @typedef {{}} Local_Route_OutsideInputs */
/** @typedef {{}} Local_Route_Personal_DataInputs */
/** @typedef {{}} Local_Route_RelayInputs */
/** @typedef {{}} Local_Route_Relay_NoteInputs */
/** @typedef {{}} Local_Route_SealedInputs */
/** @typedef {{}} Local_Route_This_AgentInputs */
/** @typedef {{}} Local_Route_This_HubInputs */
/** @typedef {{}} Local_Route_This_Hub_NoteInputs */
/** @typedef {{}} Local_Route_This_PcInputs */
/** @typedef {{}} Local_Setting_Change_FailedInputs */
/** @typedef {{}} Local_TrustInputs */
/** @typedef {{}} Local_Trust_AcceptInputs */
/** @typedef {{ name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Accept_BodyInputs */
/** @typedef {{}} Local_Trust_Accept_ButtonInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Accept_FirstInputs */
/** @typedef {{}} Local_Trust_Accept_NoteInputs */
/** @typedef {{}} Local_Trust_Accept_TitleInputs */
/** @typedef {{}} Local_Trust_AddInputs */
/** @typedef {{}} Local_Trust_Add_AnotherInputs */
/** @typedef {{}} Local_Trust_Add_ButtonInputs */
/** @typedef {{}} Local_Trust_Add_NoteInputs */
/** @typedef {{}} Local_Trust_Agent_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Agent_SettingsInputs */
/** @typedef {{}} Local_Trust_Already_MemberInputs */
/** @typedef {{}} Local_Trust_Approve_AddingInputs */
/** @typedef {{}} Local_Trust_Approve_ButtonInputs */
/** @typedef {{}} Local_Trust_Approve_CompareInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Approve_DoneInputs */
/** @typedef {{}} Local_Trust_Approve_FindingInputs */
/** @typedef {{}} Local_Trust_CandidatesInputs */
/** @typedef {{}} Local_Trust_Candidates_NoteInputs */
/** @typedef {{}} Local_Trust_Cli_AcceptedInputs */
/** @typedef {{}} Local_Trust_Cli_Agent_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Approve_DoneInputs */
/** @typedef {{}} Local_Trust_Cli_Approve_FindingInputs */
/** @typedef {{ name: NonNullable<unknown>, kind: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Cli_Approve_PeerInputs */
/** @typedef {{ list: NonNullable<unknown>, name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Cli_AvailableInputs */
/** @typedef {{ fingerprint: NonNullable<unknown> }} Local_Trust_Cli_CompareInputs */
/** @typedef {{}} Local_Trust_Cli_CreatedInputs */
/** @typedef {{ error: NonNullable<unknown> }} Local_Trust_Cli_FailedInputs */
/** @typedef {{ fingerprint: NonNullable<unknown> }} Local_Trust_Cli_FingerprintInputs */
/** @typedef {{ minutes: NonNullable<unknown>, code: NonNullable<unknown> }} Local_Trust_Cli_InviteInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_ApprovedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_DeclinedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_ExpiredInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Invite_ProvedInputs */
/** @typedef {{}} Local_Trust_Cli_Invite_RefusedInputs */
/** @typedef {{}} Local_Trust_Cli_Keys_MadeInputs */
/** @typedef {{ n: NonNullable<unknown> }} Local_Trust_Cli_ListInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Trust_Cli_MadeInputs */
/** @typedef {{}} Local_Trust_Cli_No_ListInputs */
/** @typedef {{}} Local_Trust_Cli_No_ListsInputs */
/** @typedef {{ what: NonNullable<unknown> }} Local_Trust_Cli_Not_FoundInputs */
/** @typedef {{ dir: NonNullable<unknown>, app: NonNullable<unknown> }} Local_Trust_Cli_Not_RunningInputs */
/** @typedef {{ app: NonNullable<unknown> }} Local_Trust_Cli_OthersInputs */
/** @typedef {{}} Local_Trust_Cli_Pair_NoteInputs */
/** @typedef {{}} Local_Trust_Cli_PassphraseInputs */
/** @typedef {{}} Local_Trust_Cli_Passphrase_AgainInputs */
/** @typedef {{}} Local_Trust_Cli_Passphrase_MismatchInputs */
/** @typedef {{ min: NonNullable<unknown> }} Local_Trust_Cli_Passphrase_NewInputs */
/** @typedef {{ place: NonNullable<unknown> }} Local_Trust_Cli_ProblemInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cli_Remove_DoneInputs */
/** @typedef {{}} Local_Trust_Cli_SwitchInputs */
/** @typedef {{}} Local_Trust_Cli_SwitchedInputs */
/** @typedef {{ app: NonNullable<unknown> }} Local_Trust_Cli_UsageInputs */
/** @typedef {{}} Local_Trust_Cli_WaitingInputs */
/** @typedef {{}} Local_Trust_Cli_Wrong_PassphraseInputs */
/** @typedef {{}} Local_Trust_CloudInputs */
/** @typedef {{}} Local_Trust_Cloud_AddInputs */
/** @typedef {{}} Local_Trust_Cloud_Add_When_ReadyInputs */
/** @typedef {{}} Local_Trust_Cloud_AddingInputs */
/** @typedef {{}} Local_Trust_Cloud_CreateInputs */
/** @typedef {{}} Local_Trust_Cloud_Create_LimitInputs */
/** @typedef {{}} Local_Trust_Cloud_DeleteInputs */
/** @typedef {{}} Local_Trust_Cloud_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Delete_TitleInputs */
/** @typedef {{}} Local_Trust_Cloud_FailedInputs */
/** @typedef {{}} Local_Trust_Cloud_Name_DevInputs */
/** @typedef {{}} Local_Trust_Cloud_Name_GeneralInputs */
/** @typedef {{}} Local_Trust_Cloud_NoneInputs */
/** @typedef {{}} Local_Trust_Cloud_NoteInputs */
/** @typedef {{}} Local_Trust_Cloud_Other_ListInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_AsleepInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_DeletingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_ErrorInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_PreparingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_QueuedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Local_Trust_Cloud_Phase_Queued_AtInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_RemakingInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_RunningInputs */
/** @typedef {{}} Local_Trust_Cloud_Phase_StartingInputs */
/** @typedef {{}} Local_Trust_Cloud_RemakeInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Remake_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Cloud_Remake_TitleInputs */
/** @typedef {{}} Local_Trust_Cloud_UnlistedInputs */
/** @typedef {{}} Local_Trust_Cloud_Update_ClisInputs */
/** @typedef {{}} Local_Trust_Cloud_UpdatingInputs */
/** @typedef {{}} Local_Trust_Cloud_WakeInputs */
/** @typedef {{}} Local_Trust_Cloud_Wake_To_AddInputs */
/** @typedef {{}} Local_Trust_CodeInputs */
/** @typedef {{}} Local_Trust_Code_ExpiredInputs */
/** @typedef {{}} Local_Trust_CreateInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Create_Again_BodyInputs */
/** @typedef {{}} Local_Trust_Create_Again_NoteInputs */
/** @typedef {{}} Local_Trust_Create_Again_TitleInputs */
/** @typedef {{}} Local_Trust_Create_ButtonInputs */
/** @typedef {{}} Local_Trust_Create_NoteInputs */
/** @typedef {{}} Local_Trust_DeclineInputs */
/** @typedef {{}} Local_Trust_DescriptionInputs */
/** @typedef {{}} Local_Trust_Device_Not_FoundInputs */
/** @typedef {{}} Local_Trust_FailedInputs */
/** @typedef {{}} Local_Trust_GuideInputs */
/** @typedef {{}} Local_Trust_Guide_AddInputs */
/** @typedef {{}} Local_Trust_Guide_Add_ThisInputs */
/** @typedef {{}} Local_Trust_Guide_AgentInputs */
/** @typedef {{}} Local_Trust_Guide_Agent_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_By_VaultInputs */
/** @typedef {{}} Local_Trust_Guide_By_Vault_LinkedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_By_Vault_SelfInputs */
/** @typedef {{}} Local_Trust_Guide_Code_GoesInputs */
/** @typedef {{}} Local_Trust_Guide_Create_MadeInputs */
/** @typedef {{}} Local_Trust_Guide_Create_NextInputs */
/** @typedef {{}} Local_Trust_Guide_Create_OnceInputs */
/** @typedef {{}} Local_Trust_Guide_Create_PassphraseInputs */
/** @typedef {{}} Local_Trust_Guide_Create_PressInputs */
/** @typedef {{}} Local_Trust_Guide_Example_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Example_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_CheckInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_FromInputs */
/** @typedef {{}} Local_Trust_Guide_Flow_ResultInputs */
/** @typedef {{}} Local_Trust_Guide_FoundInputs */
/** @typedef {{}} Local_Trust_Guide_Found_TrustInputs */
/** @typedef {{}} Local_Trust_Guide_HereInputs */
/** @typedef {{}} Local_Trust_Guide_Here_NameInputs */
/** @typedef {{}} Local_Trust_Guide_In_ListInputs */
/** @typedef {{}} Local_Trust_Guide_Join_FirstInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Headless_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Pc_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_Phone_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Kind_QuestionInputs */
/** @typedef {{}} Local_Trust_Guide_Member_ScreenInputs */
/** @typedef {{}} Local_Trust_Guide_More_AddInputs */
/** @typedef {{}} Local_Trust_Guide_More_Add_ThisInputs */
/** @typedef {{}} Local_Trust_Guide_More_StartInputs */
/** @typedef {{}} Local_Trust_Guide_New_PcInputs */
/** @typedef {{}} Local_Trust_Guide_New_PhoneInputs */
/** @typedef {{}} Local_Trust_Guide_OthersInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_CloudInputs */
/** @typedef {{}} Local_Trust_Guide_Reach_NoneInputs */
/** @typedef {{}} Local_Trust_Guide_Reach_OutsideInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_SelfInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_Self_CloudInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_VaultInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Reach_Vault_CloudInputs */
/** @typedef {{}} Local_Trust_Guide_RefusedInputs */
/** @typedef {{}} Local_Trust_Guide_RunsInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Screen_OfInputs */
/** @typedef {{}} Local_Trust_Guide_StartInputs */
/** @typedef {{}} Local_Trust_Guide_Start_CreateInputs */
/** @typedef {{}} Local_Trust_Guide_Start_Create_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Start_JoinInputs */
/** @typedef {{}} Local_Trust_Guide_Start_Join_NoteInputs */
/** @typedef {{}} Local_Trust_Guide_Start_NoneInputs */
/** @typedef {{}} Local_Trust_Guide_Start_QuestionInputs */
/** @typedef {{}} Local_Trust_Guide_Start_UnreachedInputs */
/** @typedef {{}} Local_Trust_Guide_Step_AddInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_CompareInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_Compare_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Compare_MemberInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Guide_Step_EnterInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Enter_MemberInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_HeadlessInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_HereInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_PcInputs */
/** @typedef {{}} Local_Trust_Guide_Step_Show_PhoneInputs */
/** @typedef {{ code: NonNullable<unknown> }} Local_Trust_Guide_Term_CodeInputs */
/** @typedef {{}} Local_Trust_Guide_WhatInputs */
/** @typedef {{}} Local_Trust_Guide_What_BodyInputs */
/** @typedef {{}} Local_Trust_Guide_WhereInputs */
/** @typedef {{}} Local_Trust_Invalid_CodeInputs */
/** @typedef {{}} Local_Trust_InviteInputs */
/** @typedef {{}} Local_Trust_Invite_ApprovedInputs */
/** @typedef {{}} Local_Trust_Invite_ButtonInputs */
/** @typedef {{}} Local_Trust_Invite_DeclinedInputs */
/** @typedef {{}} Local_Trust_Invite_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Invite_ProvedInputs */
/** @typedef {{}} Local_Trust_Invite_RefusedInputs */
/** @typedef {{}} Local_Trust_Invite_WaitingInputs */
/** @typedef {{}} Local_Trust_Kind_CloudInputs */
/** @typedef {{}} Local_Trust_Kind_PcInputs */
/** @typedef {{}} Local_Trust_Kind_PhoneInputs */
/** @typedef {{}} Local_Trust_Last_ApproverInputs */
/** @typedef {{}} Local_Trust_LeftInputs */
/** @typedef {{ date: NonNullable<unknown> }} Local_Trust_List_MadeInputs */
/** @typedef {{}} Local_Trust_MembersInputs */
/** @typedef {{}} Local_Trust_Members_NoteInputs */
/** @typedef {{}} Local_Trust_Members_Note_OutsideInputs */
/** @typedef {{}} Local_Trust_Members_Note_ReceiverInputs */
/** @typedef {{}} Local_Trust_No_KeysInputs */
/** @typedef {{}} Local_Trust_No_PlaceInputs */
/** @typedef {{}} Local_Trust_No_Place_FailedInputs */
/** @typedef {{}} Local_Trust_OutsideInputs */
/** @typedef {{}} Local_Trust_Outside_Not_TakingInputs */
/** @typedef {{}} Local_Trust_Outside_NoteInputs */
/** @typedef {{}} Local_Trust_Outside_Page_NoteInputs */
/** @typedef {{}} Local_Trust_PassphraseInputs */
/** @typedef {{}} Local_Trust_Passphrase_AgainInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_BodyInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_ButtonInputs */
/** @typedef {{}} Local_Trust_Passphrase_Ask_TitleInputs */
/** @typedef {{}} Local_Trust_Passphrase_MismatchInputs */
/** @typedef {{}} Local_Trust_Passphrase_New_NoteInputs */
/** @typedef {{}} Local_Trust_Passphrase_Set_TitleInputs */
/** @typedef {{}} Local_Trust_Passphrase_ShortInputs */
/** @typedef {{}} Local_Trust_ProblemInputs */
/** @typedef {{}} Local_Trust_Receiver_MarkInputs */
/** @typedef {{}} Local_Trust_RemoveInputs */
/** @typedef {{}} Local_Trust_Remove_BodyInputs */
/** @typedef {{}} Local_Trust_Remove_Self_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Local_Trust_Remove_TitleInputs */
/** @typedef {{}} Local_Trust_SwitchInputs */
/** @typedef {{ name: NonNullable<unknown>, fingerprint: NonNullable<unknown> }} Local_Trust_Switch_BodyInputs */
/** @typedef {{}} Local_Trust_Switch_ButtonInputs */
/** @typedef {{}} Local_Trust_Switch_NoteInputs */
/** @typedef {{}} Local_Trust_Switch_TitleInputs */
/** @typedef {{}} Local_Trust_This_DeviceInputs */
/** @typedef {{}} Local_Trust_This_Device_MarkInputs */
/** @typedef {{}} Local_Trust_This_Device_NoteInputs */
/** @typedef {{}} Local_Trust_UnreachableInputs */
/** @typedef {{}} Local_Trust_Wrong_PassphraseInputs */
/** @typedef {{}} Local_Trust_Wrong_ProofInputs */
/** @typedef {{}} Local_Via_Cloud_RefusedInputs */
/** @typedef {{}} Local_Where_CloudInputs */
/** @typedef {{}} Media_CloseInputs */
/** @typedef {{}} Media_DownloadInputs */
/** @typedef {{}} Media_Image_ActionsInputs */
/** @typedef {{}} Media_Image_NextInputs */
/** @typedef {{ count: NonNullable<unknown>, n: NonNullable<unknown> }} Media_Image_PositionInputs */
/** @typedef {{}} Media_Image_PreviousInputs */
/** @typedef {{}} Media_More_ActionsInputs */
/** @typedef {{}} Media_Open_In_TabInputs */
/** @typedef {{}} Media_Video_Exit_FullscreenInputs */
/** @typedef {{}} Media_Video_FullscreenInputs */
/** @typedef {{ name: NonNullable<unknown> }} Media_Video_LabelInputs */
/** @typedef {{}} Media_Video_MuteInputs */
/** @typedef {{}} Media_Video_Native_FullscreenInputs */
/** @typedef {{}} Media_Video_PauseInputs */
/** @typedef {{}} Media_Video_PlayInputs */
/** @typedef {{ name: NonNullable<unknown> }} Media_Video_Play_NamedInputs */
/** @typedef {{ n: NonNullable<unknown> }} Media_Video_SecondsInputs */
/** @typedef {{}} Media_Video_SeekInputs */
/** @typedef {{}} Media_Video_SpeedInputs */
/** @typedef {{}} Media_Video_Speed_NormalInputs */
/** @typedef {{}} Media_Video_UnmuteInputs */
/** @typedef {{}} Media_Video_UnplayableInputs */
/** @typedef {{}} Media_Video_VolumeInputs */
/** @typedef {{}} Media_Zoom_InInputs */
/** @typedef {{}} Media_Zoom_OutInputs */
/** @typedef {{}} Memos_CloseInputs */
/** @typedef {{}} Memos_HandoverInputs */
/** @typedef {{}} Memos_Handover_PlaceholderInputs */
/** @typedef {{}} Memos_Load_FailedInputs */
/** @typedef {{}} Memos_LogInputs */
/** @typedef {{}} Memos_Log_DeleteInputs */
/** @typedef {{}} Memos_Log_Delete_FailedInputs */
/** @typedef {{}} Memos_Log_EmptyInputs */
/** @typedef {{}} Memos_Log_MoreInputs */
/** @typedef {{}} Memos_Save_FailedInputs */
/** @typedef {{}} Memos_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Notices_Agent_TitleInputs */
/** @typedef {{ device: NonNullable<unknown> }} Notices_App_DeniedInputs */
/** @typedef {{}} Notices_App_DestinationsInputs */
/** @typedef {{}} Notices_App_FailedInputs */
/** @typedef {{ device: NonNullable<unknown> }} Notices_App_LabelInputs */
/** @typedef {{}} Notices_App_Open_SettingsInputs */
/** @typedef {{}} Notices_App_ReceiveInputs */
/** @typedef {{}} Notices_App_This_DeviceInputs */
/** @typedef {{}} Notices_App_UntiedInputs */
/** @typedef {{}} Notices_File_OnlyInputs */
/** @typedef {{}} Notices_Settings_DeniedInputs */
/** @typedef {{}} Notices_Settings_DescriptionInputs */
/** @typedef {{}} Notices_Settings_OsInputs */
/** @typedef {{}} Notices_Settings_Os_BlockedInputs */
/** @typedef {{}} Notices_Settings_Os_DescriptionInputs */
/** @typedef {{}} Notices_Settings_Os_Open_SettingsInputs */
/** @typedef {{}} Notices_Settings_Os_UnsignedInputs */
/** @typedef {{}} Notices_Settings_TitleInputs */
/** @typedef {{}} Notices_Settings_UnsupportedInputs */
/** @typedef {{}} Notices_Test_BodyInputs */
/** @typedef {{}} Notices_Test_TitleInputs */
/** @typedef {{ name: NonNullable<unknown> }} Notices_Trust_Added_BodyInputs */
/** @typedef {{}} Notices_Trust_Added_TitleInputs */
/** @typedef {{}} Notices_Turn_Edited_PrefixInputs */
/** @typedef {{}} Notices_Turn_Proposal_PrefixInputs */
/** @typedef {{}} Persons_Agent_MemoInputs */
/** @typedef {{}} Persons_Alias_AddInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_Add_FailedInputs */
/** @typedef {{}} Persons_Alias_PlaceholderInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_RemoveInputs */
/** @typedef {{ alias: NonNullable<unknown> }} Persons_Alias_Remove_FailedInputs */
/** @typedef {{}} Persons_AliasesInputs */
/** @typedef {{}} Persons_Aliases_IdsInputs */
/** @typedef {{}} Persons_ContextInputs */
/** @typedef {{}} Persons_Context_PlaceholderInputs */
/** @typedef {{}} Persons_CreateInputs */
/** @typedef {{}} Persons_Create_FailedInputs */
/** @typedef {{}} Persons_Create_Failed_KeptInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Create_NamedInputs */
/** @typedef {{}} Persons_CreatingInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Delete_TitleInputs */
/** @typedef {{}} Persons_EmptyInputs */
/** @typedef {{}} Persons_External_IdsInputs */
/** @typedef {{}} Persons_GoInputs */
/** @typedef {{}} Persons_HistoryInputs */
/** @typedef {{}} Persons_Id_AddInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_Add_FailedInputs */
/** @typedef {{}} Persons_Id_KindInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_RemoveInputs */
/** @typedef {{ value: NonNullable<unknown> }} Persons_Id_Remove_FailedInputs */
/** @typedef {{}} Persons_Id_ValueInputs */
/** @typedef {{}} Persons_Id_Value_PlaceholderInputs */
/** @typedef {{}} Persons_Kind_EmailInputs */
/** @typedef {{}} Persons_Kind_GithubInputs */
/** @typedef {{}} Persons_Kind_PhoneInputs */
/** @typedef {{}} Persons_Kind_SlackInputs */
/** @typedef {{}} Persons_Kind_UrlInputs */
/** @typedef {{}} Persons_Link_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Link_FailedInputs */
/** @typedef {{}} Persons_Link_LabelInputs */
/** @typedef {{}} Persons_Link_MenuInputs */
/** @typedef {{}} Persons_Link_SearchInputs */
/** @typedef {{}} Persons_Link_Search_PlaceholderInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Link_TitleInputs */
/** @typedef {{}} Persons_Linked_FormerInputs */
/** @typedef {{}} Persons_ListInputs */
/** @typedef {{}} Persons_Load_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_MenuInputs */
/** @typedef {{}} Persons_Merge_ActionInputs */
/** @typedef {{ keep: NonNullable<unknown>, from: NonNullable<unknown> }} Persons_Merge_BodyInputs */
/** @typedef {{ from: NonNullable<unknown>, keep: NonNullable<unknown> }} Persons_Merge_FailedInputs */
/** @typedef {{}} Persons_Merge_LabelInputs */
/** @typedef {{}} Persons_Merge_MenuInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Merge_NoteInputs */
/** @typedef {{ name: NonNullable<unknown> }} Persons_Merge_Pick_TitleInputs */
/** @typedef {{}} Persons_Merge_SearchInputs */
/** @typedef {{ from: NonNullable<unknown>, keep: NonNullable<unknown> }} Persons_Merge_TitleInputs */
/** @typedef {{}} Persons_NameInputs */
/** @typedef {{}} Persons_Name_FailedInputs */
/** @typedef {{}} Persons_NarrowInputs */
/** @typedef {{}} Persons_Narrow_PlaceholderInputs */
/** @typedef {{}} Persons_NewInputs */
/** @typedef {{}} Persons_No_MatchInputs */
/** @typedef {{}} Persons_Not_FoundInputs */
/** @typedef {{}} Persons_NowInputs */
/** @typedef {{}} Persons_Now_EmptyInputs */
/** @typedef {{}} Persons_Open_EmailInputs */
/** @typedef {{}} Persons_Open_GithubInputs */
/** @typedef {{}} Persons_Open_PhoneInputs */
/** @typedef {{}} Persons_Open_SlackInputs */
/** @typedef {{}} Persons_Open_UrlInputs */
/** @typedef {{}} Persons_Pick_ActionInputs */
/** @typedef {{}} Persons_Pick_CandidatesInputs */
/** @typedef {{}} Persons_Pick_ClearInputs */
/** @typedef {{}} Persons_Pick_NoneInputs */
/** @typedef {{}} Persons_Pick_PlaceholderInputs */
/** @typedef {{}} Persons_Pick_SearchInputs */
/** @typedef {{}} Persons_Pick_Search_Or_CreateInputs */
/** @typedef {{}} Persons_Pick_Search_PlaceholderInputs */
/** @typedef {{}} Persons_Slack_WorkspaceInputs */
/** @typedef {{}} Persons_Slack_Workspace_PlaceholderInputs */
/** @typedef {{}} Persons_SummaryInputs */
/** @typedef {{}} Persons_Summary_FailedInputs */
/** @typedef {{}} Persons_Summary_PlaceholderInputs */
/** @typedef {{}} Persons_TitleInputs */
/** @typedef {{}} Persons_UnlinkInputs */
/** @typedef {{}} Persons_Unlink_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Persons_Waiting_CountInputs */
/** @typedef {{}} Phone_Doc_RedoInputs */
/** @typedef {{}} Phone_Doc_UndoInputs */
/** @typedef {{}} Phone_Dock_SettingsInputs */
/** @typedef {{}} Phone_Dock_Settings_CutoffInputs */
/** @typedef {{}} Phone_Dock_Settings_DescriptionInputs */
/** @typedef {{}} Phone_Dock_Settings_MeInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Dock_Settings_MoveInputs */
/** @typedef {{}} Phone_Dock_Settings_No_PlaceInputs */
/** @typedef {{}} Phone_Dock_Settings_NoteInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Dock_Settings_ShowInputs */
/** @typedef {{}} Phone_MenuInputs */
/** @typedef {{}} Phone_Menu_AllInputs */
/** @typedef {{}} Phone_Menu_ArrangeInputs */
/** @typedef {{}} Phone_Menu_OpenInputs */
/** @typedef {{}} Phone_MoreInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_More_CurrentInputs */
/** @typedef {{ name: NonNullable<unknown> }} Phone_Place_MenuInputs */
/** @typedef {{ label: NonNullable<unknown> }} Phone_Unread_NamedInputs */
/** @typedef {{}} Publishing_ActionInputs */
/** @typedef {{}} Publishing_BuildingInputs */
/** @typedef {{}} Publishing_CloseInputs */
/** @typedef {{}} Publishing_CopiedInputs */
/** @typedef {{}} Publishing_CopyInputs */
/** @typedef {{}} Publishing_Copy_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Dataset_More_FieldsInputs */
/** @typedef {{}} Publishing_Dataset_Not_AllowedInputs */
/** @typedef {{}} Publishing_Dataset_Not_WritableInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Dataset_RowsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_BlockedInputs */
/** @typedef {{}} Publishing_Datasets_Confirm_BodyInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_Confirm_TitleInputs */
/** @typedef {{}} Publishing_Datasets_FailedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Datasets_HiddenInputs */
/** @typedef {{}} Publishing_Datasets_IntroInputs */
/** @typedef {{}} Publishing_Datasets_PendingInputs */
/** @typedef {{}} Publishing_Datasets_PublishInputs */
/** @typedef {{}} Publishing_Datasets_PublishedInputs */
/** @typedef {{}} Publishing_Datasets_TitleInputs */
/** @typedef {{}} Publishing_FailedInputs */
/** @typedef {{}} Publishing_FailingInputs */
/** @typedef {{}} Publishing_Html_ScriptsInputs */
/** @typedef {{}} Publishing_IntroInputs */
/** @typedef {{}} Publishing_MenuInputs */
/** @typedef {{}} Publishing_OpenInputs */
/** @typedef {{}} Publishing_PreviewInputs */
/** @typedef {{}} Publishing_Preview_FailedInputs */
/** @typedef {{}} Publishing_PublishedInputs */
/** @typedef {{ date: NonNullable<unknown> }} Publishing_Published_AtInputs */
/** @typedef {{}} Publishing_Published_PendingInputs */
/** @typedef {{}} Publishing_StopInputs */
/** @typedef {{}} Publishing_Stop_BodyInputs */
/** @typedef {{}} Publishing_Stop_FailedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Publishing_Stop_TitleInputs */
/** @typedef {{}} Publishing_TitleInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Unpublished_LinksInputs */
/** @typedef {{ count: NonNullable<unknown> }} Publishing_Unpublished_RefsInputs */
/** @typedef {{}} Publishing_UrlInputs */
/** @typedef {{}} Refs_Cannot_Open_HereInputs */
/** @typedef {{}} Refs_In_CloudInputs */
/** @typedef {{ label: NonNullable<unknown>, why: NonNullable<unknown> }} Refs_Missing_LabelInputs */
/** @typedef {{}} Refs_Not_FoundInputs */
/** @typedef {{}} Refs_Note_ConflictInputs */
/** @typedef {{}} Refs_Note_Conflict_DropInputs */
/** @typedef {{}} Refs_Note_Conflict_Use_MineInputs */
/** @typedef {{}} Refs_Note_Conflict_YoursInputs */
/** @typedef {{}} Refs_Save_Failed_KeptInputs */
/** @typedef {{}} Refs_UnreachableInputs */
/** @typedef {{}} Settings_App_OpenInputs */
/** @typedef {{}} Settings_App_Open_DescriptionInputs */
/** @typedef {{}} Settings_App_Open_Description_DeviceInputs */
/** @typedef {{}} Settings_App_Window_DescriptionInputs */
/** @typedef {{}} Settings_AppearanceInputs */
/** @typedef {{}} Settings_Appearance_DescriptionInputs */
/** @typedef {{}} Settings_Back_To_IndexInputs */
/** @typedef {{}} Settings_GeneralInputs */
/** @typedef {{}} Settings_General_DescriptionInputs */
/** @typedef {{}} Settings_General_Description_AccountInputs */
/** @typedef {{}} Settings_Group_AppInputs */
/** @typedef {{}} Settings_InputInputs */
/** @typedef {{}} Settings_Input_DescriptionInputs */
/** @typedef {{}} Settings_LanguageInputs */
/** @typedef {{}} Settings_Language_BrowserInputs */
/** @typedef {{}} Settings_Language_NoteInputs */
/** @typedef {{}} Settings_NameInputs */
/** @typedef {{}} Settings_PictureInputs */
/** @typedef {{}} Settings_Save_FailedInputs */
/** @typedef {{}} Settings_Send_KeyInputs */
/** @typedef {{}} Settings_Send_Key_EnterInputs */
/** @typedef {{}} Settings_Send_Key_ModInputs */
/** @typedef {{}} Settings_Send_Key_NoteInputs */
/** @typedef {{}} Settings_ThemeInputs */
/** @typedef {{}} Settings_Theme_AutoInputs */
/** @typedef {{}} Settings_Theme_DarkInputs */
/** @typedef {{}} Settings_Theme_LightInputs */
/** @typedef {{}} Settings_Theme_NoteInputs */
/** @typedef {{}} Settings_Time_ZoneInputs */
/** @typedef {{ zone: NonNullable<unknown> }} Settings_Time_Zone_BrowserInputs */
/** @typedef {{}} Settings_Time_Zone_NoteInputs */
/** @typedef {{}} Shell_Account_MenuInputs */
/** @typedef {{}} Shell_BackInputs */
/** @typedef {{}} Shell_Back_To_ListInputs */
/** @typedef {{}} Shell_Clear_PicksInputs */
/** @typedef {{}} Shell_CopiedInputs */
/** @typedef {{}} Shell_Copy_FailedInputs */
/** @typedef {{}} Shell_Copy_LinkInputs */
/** @typedef {{}} Shell_Error_BodyInputs */
/** @typedef {{}} Shell_Error_ReloadInputs */
/** @typedef {{}} Shell_Error_TitleInputs */
/** @typedef {{}} Shell_FavoritesInputs */
/** @typedef {{}} Shell_Favorites_AddInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Favorites_Add_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Create_Folder_FailedInputs */
/** @typedef {{}} Shell_Favorites_Delete_FolderInputs */
/** @typedef {{}} Shell_Favorites_Delete_Folder_BodyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Delete_Folder_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Delete_Folder_TitleInputs */
/** @typedef {{}} Shell_Favorites_EmptyInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Folder_MenuInputs */
/** @typedef {{}} Shell_Favorites_Folder_NameInputs */
/** @typedef {{}} Shell_Favorites_Move_FailedInputs */
/** @typedef {{}} Shell_Favorites_New_FolderInputs */
/** @typedef {{}} Shell_Favorites_RemoveInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Favorites_Remove_FailedInputs */
/** @typedef {{}} Shell_Favorites_RenameInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Favorites_Rename_FailedInputs */
/** @typedef {{}} Shell_Fold_SidebarInputs */
/** @typedef {{}} Shell_Hub_AwayInputs */
/** @typedef {{}} Shell_Keep_Sidebar_OpenInputs */
/** @typedef {{}} Shell_Language_AutoInputs */
/** @typedef {{}} Shell_List_FoldInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shell_List_Fold_RestInputs */
/** @typedef {{}} Shell_List_NarrowInputs */
/** @typedef {{}} Shell_List_Narrow_TitleInputs */
/** @typedef {{}} Shell_List_No_MatchInputs */
/** @typedef {{}} Shell_MeInputs */
/** @typedef {{}} Shell_Me_Away_SettingsInputs */
/** @typedef {{}} Shell_Me_EmptyInputs */
/** @typedef {{}} Shell_Me_Moving_AlmostInputs */
/** @typedef {{ percent: NonNullable<unknown>, left: NonNullable<unknown> }} Shell_Me_Moving_DoneInputs */
/** @typedef {{}} Shell_Me_Moving_MeasuringInputs */
/** @typedef {{ minutes: NonNullable<unknown> }} Shell_Me_Moving_MinutesInputs */
/** @typedef {{}} Shell_Me_Moving_ProgressInputs */
/** @typedef {{}} Shell_Me_Moving_Under_MinuteInputs */
/** @typedef {{}} Shell_Not_Found_BodyInputs */
/** @typedef {{}} Shell_Not_Found_TitleInputs */
/** @typedef {{}} Shell_Open_SidebarInputs */
/** @typedef {{}} Shell_Personal_Data_Not_WorkspaceInputs */
/** @typedef {{}} Shell_Personal_DocumentsInputs */
/** @typedef {{}} Shell_Personal_In_CloudInputs */
/** @typedef {{}} Shell_Personal_In_VaultInputs */
/** @typedef {{}} Shell_Personal_OnlyInputs */
/** @typedef {{}} Shell_Pick_ActionsInputs */
/** @typedef {{ base: NonNullable<unknown>, n: NonNullable<unknown> }} Shell_Pick_Count_LabelInputs */
/** @typedef {{}} Shell_Pick_Names_JoinInputs */
/** @typedef {{ head: NonNullable<unknown>, rest: NonNullable<unknown> }} Shell_Pick_Names_MoreInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Pick_QuotedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Shell_Pick_RowInputs */
/** @typedef {{}} Shell_Picked_ActionsInputs */
/** @typedef {{ count: NonNullable<unknown> }} Shell_Picked_CountInputs */
/** @typedef {{}} Shell_Rail_PersonalInputs */
/** @typedef {{}} Shell_Resize_SidebarInputs */
/** @typedef {{}} Shell_Route_PendingInputs */
/** @typedef {{}} Shell_SettingsInputs */
/** @typedef {{}} Shell_Settings_BackInputs */
/** @typedef {{}} Shell_Settings_DescriptionInputs */
/** @typedef {{}} Shell_Settings_No_MatchInputs */
/** @typedef {{}} Shell_Settings_SearchInputs */
/** @typedef {{}} Shell_ShortcutsInputs */
/** @typedef {{}} Shell_Shortcuts_Group_CreateInputs */
/** @typedef {{}} Shell_Shortcuts_Group_GeneralInputs */
/** @typedef {{}} Shell_Shortcuts_Group_NavigateInputs */
/** @typedef {{}} Shell_Shortcuts_Group_ViewInputs */
/** @typedef {{}} Shell_Side_CloseInputs */
/** @typedef {{}} Shell_Side_Open_FullInputs */
/** @typedef {{}} Shell_Toggle_SidebarInputs */
/** @typedef {{}} Shell_Unreachable_Cannot_OpenInputs */
/** @typedef {{}} Shell_WideInputs */
/** @typedef {{}} Shell_Wide_OffInputs */
/** @typedef {{}} Shell_Wide_ToggleInputs */
/** @typedef {{}} Shell_Window_CloseInputs */
/** @typedef {{}} Shell_Window_MaximizeInputs */
/** @typedef {{}} Shell_Window_MinimizeInputs */
/** @typedef {{}} Shell_Window_RestoreInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Workspace_ChangeInputs */
/** @typedef {{ names: NonNullable<unknown> }} Shell_Workspace_Change_ManyInputs */
/** @typedef {{}} Shell_Workspace_ColInputs */
/** @typedef {{}} Shell_Workspace_FailedInputs */
/** @typedef {{ name: NonNullable<unknown> }} Shell_Workspace_LeftInputs */
/** @typedef {{}} Shell_Workspace_OfflineInputs */
/** @typedef {{}} Shell_Workspace_RemoveInputs */
/** @typedef {{}} Shell_Workspace_SetInputs */
/** @typedef {{}} Timeblocker_AccountsInputs */
/** @typedef {{}} Timeblocker_Activity_Agent_RunInputs */
/** @typedef {{}} Timeblocker_Activity_Case_ClosedInputs */
/** @typedef {{}} Timeblocker_Activity_Step_ClosedInputs */
/** @typedef {{}} Timeblocker_Add_BlockInputs */
/** @typedef {{}} Timeblocker_Add_LaneInputs */
/** @typedef {{}} Timeblocker_All_DayInputs */
/** @typedef {{}} Timeblocker_Block_EndedInputs */
/** @typedef {{ title: NonNullable<unknown>, start: NonNullable<unknown>, end: NonNullable<unknown> }} Timeblocker_Block_LabelInputs */
/** @typedef {{}} Timeblocker_Block_RemoveInputs */
/** @typedef {{}} Timeblocker_CalendarInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Calendar_ErrorInputs */
/** @typedef {{}} Timeblocker_Calendar_SettingsInputs */
/** @typedef {{}} Timeblocker_CalendarsInputs */
/** @typedef {{}} Timeblocker_CancelInputs */
/** @typedef {{}} Timeblocker_Case_Add_WholeInputs */
/** @typedef {{}} Timeblocker_Case_WholeInputs */
/** @typedef {{}} Timeblocker_CasesInputs */
/** @typedef {{}} Timeblocker_Change_DeferredInputs */
/** @typedef {{}} Timeblocker_Change_MovedInputs */
/** @typedef {{}} Timeblocker_CloseInputs */
/** @typedef {{}} Timeblocker_ColorInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Color_OfInputs */
/** @typedef {{}} Timeblocker_Connect_DescriptionInputs */
/** @typedef {{}} Timeblocker_Connect_FailedInputs */
/** @typedef {{}} Timeblocker_Connect_GoogleInputs */
/** @typedef {{}} Timeblocker_Connect_MoreInputs */
/** @typedef {{}} Timeblocker_Create_EventInputs */
/** @typedef {{}} Timeblocker_DateInputs */
/** @typedef {{}} Timeblocker_Delete_EventInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Delete_Event_ConfirmInputs */
/** @typedef {{}} Timeblocker_Delete_LaneInputs */
/** @typedef {{}} Timeblocker_DetailInputs */
/** @typedef {{}} Timeblocker_Did_ActivityInputs */
/** @typedef {{}} Timeblocker_Did_NoneInputs */
/** @typedef {{}} Timeblocker_Did_StartedInputs */
/** @typedef {{}} Timeblocker_Did_UpcomingInputs */
/** @typedef {{}} Timeblocker_DisconnectInputs */
/** @typedef {{}} Timeblocker_Disconnect_BodyInputs */
/** @typedef {{ email: NonNullable<unknown> }} Timeblocker_Disconnect_FailedInputs */
/** @typedef {{ email: NonNullable<unknown> }} Timeblocker_Disconnect_TitleInputs */
/** @typedef {{}} Timeblocker_DoneInputs */
/** @typedef {{}} Timeblocker_Empty_DoneInputs */
/** @typedef {{}} Timeblocker_Empty_TodoInputs */
/** @typedef {{}} Timeblocker_EndInputs */
/** @typedef {{}} Timeblocker_End_BlockInputs */
/** @typedef {{}} Timeblocker_End_DateInputs */
/** @typedef {{}} Timeblocker_Event_Bad_DatesInputs */
/** @typedef {{}} Timeblocker_Event_ConflictInputs */
/** @typedef {{}} Timeblocker_Event_DetailInputs */
/** @typedef {{}} Timeblocker_Event_TitleInputs */
/** @typedef {{}} Timeblocker_Event_Too_ShortInputs */
/** @typedef {{}} Timeblocker_GoInputs */
/** @typedef {{}} Timeblocker_Go_TodayInputs */
/** @typedef {{}} Timeblocker_Google_ConnectedInputs */
/** @typedef {{}} Timeblocker_Google_DeniedInputs */
/** @typedef {{}} Timeblocker_Google_FailedInputs */
/** @typedef {{}} Timeblocker_Google_Not_GrantedInputs */
/** @typedef {{}} Timeblocker_Google_UnavailableInputs */
/** @typedef {{}} Timeblocker_Google_Wrong_AccountInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_Group_AfterInputs */
/** @typedef {{}} Timeblocker_Group_After_TodayInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_Group_BeforeInputs */
/** @typedef {{}} Timeblocker_Group_Before_TodayInputs */
/** @typedef {{}} Timeblocker_Group_TodayInputs */
/** @typedef {{}} Timeblocker_Group_UndatedInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Item_StartInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Item_StopInputs */
/** @typedef {{}} Timeblocker_Item_WorkingInputs */
/** @typedef {{}} Timeblocker_Join_HereInputs */
/** @typedef {{}} Timeblocker_Join_MeetingInputs */
/** @typedef {{}} Timeblocker_Kind_ActionInputs */
/** @typedef {{}} Timeblocker_Kind_CaseInputs */
/** @typedef {{}} Timeblocker_Lane_MeInputs */
/** @typedef {{}} Timeblocker_Lane_NameInputs */
/** @typedef {{}} Timeblocker_Lane_NoneInputs */
/** @typedef {{ name: NonNullable<unknown> }} Timeblocker_Lane_OfInputs */
/** @typedef {{}} Timeblocker_LanesInputs */
/** @typedef {{}} Timeblocker_Lanes_NoteInputs */
/** @typedef {{}} Timeblocker_Link_EmptyInputs */
/** @typedef {{}} Timeblocker_Link_SearchInputs */
/** @typedef {{}} Timeblocker_ListsInputs */
/** @typedef {{}} Timeblocker_Load_FailedInputs */
/** @typedef {{}} Timeblocker_Mark_DoneInputs */
/** @typedef {{ title: NonNullable<unknown> }} Timeblocker_Mark_Done_OfInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_MoreInputs */
/** @typedef {{}} Timeblocker_New_EventInputs */
/** @typedef {{}} Timeblocker_Next_DayInputs */
/** @typedef {{}} Timeblocker_Next_WeekInputs */
/** @typedef {{}} Timeblocker_No_AccountsInputs */
/** @typedef {{}} Timeblocker_No_ActionsInputs */
/** @typedef {{}} Timeblocker_No_WritableInputs */
/** @typedef {{}} Timeblocker_Open_CaseInputs */
/** @typedef {{}} Timeblocker_Open_GoogleInputs */
/** @typedef {{}} Timeblocker_Pick_ActionInputs */
/** @typedef {{}} Timeblocker_Pick_DateInputs */
/** @typedef {{}} Timeblocker_PlanInputs */
/** @typedef {{}} Timeblocker_Prev_DayInputs */
/** @typedef {{}} Timeblocker_Prev_WeekInputs */
/** @typedef {{}} Timeblocker_Read_OnlyInputs */
/** @typedef {{}} Timeblocker_Recurring_OneInputs */
/** @typedef {{}} Timeblocker_RedoInputs */
/** @typedef {{}} Timeblocker_Redo_FailedInputs */
/** @typedef {{}} Timeblocker_ReopenInputs */
/** @typedef {{}} Timeblocker_Reset_ColorInputs */
/** @typedef {{}} Timeblocker_Resume_BlockInputs */
/** @typedef {{}} Timeblocker_ResyncInputs */
/** @typedef {{}} Timeblocker_ReviewInputs */
/** @typedef {{}} Timeblocker_Review_ActualInputs */
/** @typedef {{}} Timeblocker_Review_ChangesInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_DeferredInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_MovedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_Changes_ShortenedInputs */
/** @typedef {{ day: NonNullable<unknown>, time: NonNullable<unknown> }} Timeblocker_Review_Deferred_FromInputs */
/** @typedef {{ day: NonNullable<unknown>, time: NonNullable<unknown> }} Timeblocker_Review_Deferred_ToInputs */
/** @typedef {{}} Timeblocker_Review_DoneInputs */
/** @typedef {{}} Timeblocker_Review_Done_OfInputs */
/** @typedef {{}} Timeblocker_Review_EmptyInputs */
/** @typedef {{}} Timeblocker_Review_LinkInputs */
/** @typedef {{}} Timeblocker_Review_LinkedInputs */
/** @typedef {{ count: NonNullable<unknown> }} Timeblocker_Review_MovedInputs */
/** @typedef {{ time: NonNullable<unknown> }} Timeblocker_Review_Moved_ToInputs */
/** @typedef {{ range: NonNullable<unknown> }} Timeblocker_Review_OfInputs */
/** @typedef {{}} Timeblocker_Review_PlannedInputs */
/** @typedef {{}} Timeblocker_Review_Planned_CommittedInputs */
/** @typedef {{}} Timeblocker_Review_Planned_OfInputs */
/** @typedef {{}} Timeblocker_Review_RateInputs */
/** @typedef {{ did: NonNullable<unknown>, all: NonNullable<unknown> }} Timeblocker_Review_Rate_OfInputs */
/** @typedef {{}} Timeblocker_Review_RatioInputs */
/** @typedef {{ planned: NonNullable<unknown> }} Timeblocker_Review_Ratio_OfInputs */
/** @typedef {{}} Timeblocker_Review_Unlinked_BlockInputs */
/** @typedef {{}} Timeblocker_Review_Untitled_ChatInputs */
/** @typedef {{}} Timeblocker_Save_FailedInputs */
/** @typedef {{}} Timeblocker_Settings_DescriptionInputs */
/** @typedef {{}} Timeblocker_Settings_TitleInputs */
/** @typedef {{}} Timeblocker_Show_ActionsInputs */
/** @typedef {{}} Timeblocker_StartInputs */
/** @typedef {{}} Timeblocker_Start_BlockInputs */
/** @typedef {{}} Timeblocker_Start_DateInputs */
/** @typedef {{}} Timeblocker_TabsInputs */
/** @typedef {{}} Timeblocker_This_WeekInputs */
/** @typedef {{}} Timeblocker_TimeInputs */
/** @typedef {{ date: NonNullable<unknown> }} Timeblocker_TimelineInputs */
/** @typedef {{}} Timeblocker_TitleInputs */
/** @typedef {{}} Timeblocker_Title_LabelInputs */
/** @typedef {{}} Timeblocker_TodoInputs */
/** @typedef {{}} Timeblocker_Undated_DropInputs */
/** @typedef {{}} Timeblocker_UndoInputs */
/** @typedef {{}} Timeblocker_Undo_FailedInputs */
/** @typedef {{}} Timeblocker_UnlinkInputs */
/** @typedef {{}} Timeblocker_UntitledInputs */
/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown> }} Timeblocker_Week_RangeInputs */
/** @typedef {{}} Timeblocker_Work_LabelInputs */
/** @typedef {{}} Timeblocker_Work_LogInputs */
/** @typedef {{}} Timeblocker_Work_Log_DeleteInputs */
/** @typedef {{ start: NonNullable<unknown>, end: NonNullable<unknown> }} Timeblocker_Work_Log_LabelInputs */
/** @typedef {{}} Timeblocker_Work_Log_NowInputs */
/** @typedef {{ elapsed: NonNullable<unknown> }} Timeblocker_Work_RunningInputs */
/** @typedef {{ title: NonNullable<unknown>, elapsed: NonNullable<unknown> }} Timeblocker_Work_Running_OfInputs */
/** @typedef {{}} Timeblocker_Work_StartInputs */
/** @typedef {{}} Timeblocker_Work_Start_ShortInputs */
/** @typedef {{}} Timeblocker_Work_StopInputs */
/** @typedef {{}} Timeblocker_Work_Stop_ShortInputs */
/** @typedef {{ total: NonNullable<unknown> }} Timeblocker_Work_TotalInputs */
/** @typedef {{}} Uifence_AnswerInputs */
/** @typedef {{}} Uifence_Answer_DetailInputs */
/** @typedef {{}} Uifence_Answer_TitleInputs */
/** @typedef {{}} Uifence_BuildingInputs */
/** @typedef {{}} Uifence_Calendar_Next_MonthInputs */
/** @typedef {{}} Uifence_Calendar_PickInputs */
/** @typedef {{}} Uifence_Calendar_Prev_MonthInputs */
/** @typedef {{}} Uifence_Calendar_TodayInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Chart_OthersInputs */
/** @typedef {{}} Uifence_ChooseInputs */
/** @typedef {{}} Uifence_Copy_SourceInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Count_LeftInputs */
/** @typedef {{ count: NonNullable<unknown> }} Uifence_Count_RightInputs */
/** @typedef {{}} Uifence_Data_All_RowsInputs */
/** @typedef {{}} Uifence_Data_ButtonInputs */
/** @typedef {{}} Uifence_Data_Not_FoundInputs */
/** @typedef {{}} Uifence_Data_Not_Found_DetailInputs */
/** @typedef {{}} Uifence_Data_QueryInputs */
/** @typedef {{}} Uifence_DateInputs */
/** @typedef {{}} Uifence_EndInputs */
/** @typedef {{}} Uifence_FailedInputs */
/** @typedef {{}} Uifence_Funnel_From_FirstInputs */
/** @typedef {{}} Uifence_Funnel_From_PreviousInputs */
/** @typedef {{}} Uifence_HeatmapInputs */
/** @typedef {{}} Uifence_Hide_SourceInputs */
/** @typedef {{}} Uifence_InsertInputs */
/** @typedef {{}} Uifence_LabelInputs */
/** @typedef {{}} Uifence_More_LeftInputs */
/** @typedef {{}} Uifence_More_RightInputs */
/** @typedef {{}} Uifence_Next_ImageInputs */
/** @typedef {{}} Uifence_NoInputs */
/** @typedef {{}} Uifence_No_DataInputs */
/** @typedef {{}} Uifence_No_EventsInputs */
/** @typedef {{}} Uifence_Open_LinkInputs */
/** @typedef {{}} Uifence_Open_Link_DetailInputs */
/** @typedef {{}} Uifence_Open_Link_TitleInputs */
/** @typedef {{}} Uifence_Picker_ClearInputs */
/** @typedef {{}} Uifence_Prev_ImageInputs */
/** @typedef {{}} Uifence_Quiz_CorrectInputs */
/** @typedef {{}} Uifence_Quiz_HintInputs */
/** @typedef {{}} Uifence_Quiz_Hint_ExplainedInputs */
/** @typedef {{}} Uifence_Quiz_Picked_WrongInputs */
/** @typedef {{}} Uifence_Quiz_WrongInputs */
/** @typedef {{}} Uifence_Range_Next_DayInputs */
/** @typedef {{}} Uifence_Range_ReversedInputs */
/** @typedef {{}} Uifence_Range_SameInputs */
/** @typedef {{}} Uifence_Range_SepInputs */
/** @typedef {{}} Uifence_SendInputs */
/** @typedef {{}} Uifence_Send_DetailInputs */
/** @typedef {{}} Uifence_Send_TitleInputs */
/** @typedef {{}} Uifence_Show_SourceInputs */
/** @typedef {{}} Uifence_SourceInputs */
/** @typedef {{ first: NonNullable<unknown>, last: NonNullable<unknown>, min: NonNullable<unknown>, max: NonNullable<unknown> }} Uifence_Spark_RangeInputs */
/** @typedef {{}} Uifence_StaleInputs */
/** @typedef {{}} Uifence_StartInputs */
/** @typedef {{}} Uifence_TimeInputs */
/** @typedef {{}} Uifence_Time_HourInputs */
/** @typedef {{}} Uifence_Time_MinuteInputs */
/** @typedef {{}} Uifence_Time_NowInputs */
/** @typedef {{}} Uifence_Time_PickInputs */
/** @typedef {{}} Uifence_TotalInputs */
/** @typedef {{}} Uifence_Waterfall_DownInputs */
/** @typedef {{}} Uifence_Waterfall_RunningInputs */
/** @typedef {{}} Uifence_Waterfall_UpInputs */
/** @typedef {{}} Uifence_YesInputs */


export const agents_agent_label = /** @type {(inputs: Agents_Agent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

export const agents_answer_by_parent = /** @type {(inputs: Agents_Answer_By_ParentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.name}” answered: ${i?.title}`)
};

export const agents_answer_raised_from = /** @type {(inputs: Agents_Answer_Raised_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From a child chat:`)
};

export const agents_archive = /** @type {(inputs: Agents_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

export const agents_archived_empty = /** @type {(inputs: Agents_Archived_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No archived chats`)
};

export const agents_attach = /** @type {(inputs: Agents_AttachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach files`)
};

export const agents_attachment_failed = /** @type {(inputs: Agents_Attachment_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not upload ${i?.name}: ${i?.reason}`)
};

export const agents_attachment_remove = /** @type {(inputs: Agents_Attachment_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
};

export const agents_attachments = /** @type {(inputs: Agents_AttachmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files to attach`)
};

export const agents_bookmark_add = /** @type {(inputs: Agents_Bookmark_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bookmark`)
};

export const agents_bookmark_remove = /** @type {(inputs: Agents_Bookmark_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove bookmark`)
};

export const agents_browser_read_only = /** @type {(inputs: Agents_Browser_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In a browser you can only read the chat. Send instructions to the Agent from the trameria app.`)
};

export const agents_cancel = /** @type {(inputs: Agents_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const agents_case_chat = /** @type {(inputs: Agents_Case_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat about this Case`)
};

export const agents_case_chat_failed = /** @type {(inputs: Agents_Case_Chat_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not open the chat about this Case`)
};

export const agents_change_action = /** @type {(inputs: Agents_Change_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch`)
};

export const agents_change_agent_body = /** @type {(inputs: Agents_Change_Agent_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The conversation so far is handed to the new agent`)
};

export const agents_change_agent_title = /** @type {(inputs: Agents_Change_Agent_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Switch the agent to ${i?.agent}?`)
};

export const agents_change_completed = /** @type {(inputs: Agents_Change_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

export const agents_change_created = /** @type {(inputs: Agents_Change_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

export const agents_change_delegated = /** @type {(inputs: Agents_Change_DelegatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delegated`)
};

export const agents_change_deleted = /** @type {(inputs: Agents_Change_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted`)
};

export const agents_change_dropped = /** @type {(inputs: Agents_Change_DroppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropped`)
};

export const agents_change_next_reply = /** @type {(inputs: Agents_Change_Next_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not for the reply being written; it changes from the next reply`)
};

export const agents_change_obj_action = /** @type {(inputs: Agents_Change_Obj_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

export const agents_change_obj_case = /** @type {(inputs: Agents_Change_Obj_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const agents_change_obj_chat = /** @type {(inputs: Agents_Change_Obj_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chat`)
};

export const agents_change_obj_other = /** @type {(inputs: Agents_Change_Obj_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`item`)
};

export const agents_change_obj_page = /** @type {(inputs: Agents_Change_Obj_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`document`)
};

export const agents_change_obj_person = /** @type {(inputs: Agents_Change_Obj_PersonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`person`)
};

export const agents_change_obj_waiting = /** @type {(inputs: Agents_Change_Obj_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

export const agents_change_posted = /** @type {(inputs: Agents_Change_PostedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posted`)
};

export const agents_change_reopened = /** @type {(inputs: Agents_Change_ReopenedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopened`)
};

export const agents_change_updated = /** @type {(inputs: Agents_Change_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

export const agents_changes = /** @type {(inputs: Agents_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed by this reply`)
};

export const agents_child_queued = /** @type {(inputs: Agents_Child_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`waiting its turn`)
};

export const agents_child_running = /** @type {(inputs: Agents_Child_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`working`)
};

export const agents_child_waiting = /** @type {(inputs: Agents_Child_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`waiting for a decision`)
};

export const agents_children = /** @type {(inputs: Agents_ChildrenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Child chats at work`)
};

export const agents_col_agent = /** @type {(inputs: Agents_Col_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

export const agents_col_case = /** @type {(inputs: Agents_Col_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const agents_col_cost = /** @type {(inputs: Agents_Col_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost`)
};

export const agents_col_created = /** @type {(inputs: Agents_Col_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

export const agents_col_name = /** @type {(inputs: Agents_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const agents_col_updated = /** @type {(inputs: Agents_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated`)
};

export const agents_composer_shrink = /** @type {(inputs: Agents_Composer_ShrinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse`)
};

export const agents_conditions_close = /** @type {(inputs: Agents_Conditions_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const agents_conditions_drawer = /** @type {(inputs: Agents_Conditions_DrawerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent settings`)
};

export const agents_conditions_open = /** @type {(inputs: Agents_Conditions_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Agent settings`)
};

export const agents_conditions_open_device = /** @type {(inputs: Agents_Conditions_Open_DeviceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open Agent settings (device: ${i?.device})`)
};

export const agents_conditions_open_device_warning = /** @type {(inputs: Agents_Conditions_Open_Device_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open Agent settings (device: ${i?.device}, needs attention)`)
};

export const agents_conditions_open_warning = /** @type {(inputs: Agents_Conditions_Open_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Agent settings (needs attention)`)
};

export const agents_copied = /** @type {(inputs: Agents_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

export const agents_copy = /** @type {(inputs: Agents_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

export const agents_cwd_label = /** @type {(inputs: Agents_Cwd_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working directory`)
};

export const agents_cwd_missing = /** @type {(inputs: Agents_Cwd_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} (not found)`)
};

export const agents_cwd_missing_note = /** @type {(inputs: Agents_Cwd_Missing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This place is not on the device. Pick another`)
};

export const agents_cwd_none = /** @type {(inputs: Agents_Cwd_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No working directory`)
};

export const agents_cwd_none_note = /** @type {(inputs: Agents_Cwd_None_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does not touch files`)
};

export const agents_cwd_other = /** @type {(inputs: Agents_Cwd_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another directory…`)
};

export const agents_cwd_outside = /** @type {(inputs: Agents_Cwd_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a path under an allowed directory`)
};

export const agents_delegate_step = /** @type {(inputs: Agents_Delegate_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand off to Agent`)
};

export const agents_delegate_step_failed = /** @type {(inputs: Agents_Delegate_Step_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not hand "${i?.title}" off to Agent`)
};

export const agents_delegate_step_open = /** @type {(inputs: Agents_Delegate_Step_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the handed-off chat`)
};

export const agents_delete = /** @type {(inputs: Agents_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const agents_delete_body = /** @type {(inputs: Agents_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its messages, run records and your-turn items go too. This cannot be undone`)
};

export const agents_delete_many_body = /** @type {(inputs: Agents_Delete_Many_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The messages, run records and your-turn items of ${i?.names} go too. This cannot be undone`)
};

export const agents_delete_many_title = /** @type {(inputs: Agents_Delete_Many_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.count} chats?`)
};

export const agents_delete_title = /** @type {(inputs: Agents_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete “${i?.title}”?`)
};

export const agents_device_away = /** @type {(inputs: Agents_Device_AwayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The agent on ${i?.device} is not connected now. What you send is answered once it connects again`)
};

export const agents_device_away_short = /** @type {(inputs: Agents_Device_Away_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected now`)
};

export const agents_device_coming = /** @type {(inputs: Agents_Device_ComingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Getting ${i?.device} ready. What you send arrives once it's ready`)
};

export const agents_device_label = /** @type {(inputs: Agents_Device_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device`)
};

export const agents_device_offline = /** @type {(inputs: Agents_Device_OfflineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} has not connected to trameria yet, so nothing would answer. Start the trameria app or agent on ${i?.device}`)
};

export const agents_device_offline_pick = /** @type {(inputs: Agents_Device_Offline_PickInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} has not connected to trameria yet, so nothing would answer. Pick a connected device under the box, or start the trameria app or agent on ${i?.device}`)
};

export const agents_device_ready = /** @type {(inputs: Agents_Device_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected and can answer`)
};

export const agents_device_unreachable_line = /** @type {(inputs: Agents_Device_Unreachable_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Instructions cannot be sent from ${i?.self} to ${i?.device}. Add ${i?.self} to ${i?.device}'s device list.`)
};

export const agents_devices_add = /** @type {(inputs: Agents_Devices_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a device`)
};

export const agents_devices_never_seen = /** @type {(inputs: Agents_Devices_Never_SeenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected yet`)
};

export const agents_draft_ask_in_chat = /** @type {(inputs: Agents_Draft_Ask_In_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To bring this into the text to send, ask in the chat`)
};

export const agents_draft_copy_original = /** @type {(inputs: Agents_Draft_Copy_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy original`)
};

export const agents_draft_copy_subject = /** @type {(inputs: Agents_Draft_Copy_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy subject`)
};

export const agents_draft_open = /** @type {(inputs: Agents_Draft_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const agents_draft_open_original = /** @type {(inputs: Agents_Draft_Open_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the original message`)
};

export const agents_draft_original = /** @type {(inputs: Agents_Draft_OriginalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

export const agents_draft_reason_placeholder = /** @type {(inputs: Agents_Draft_Reason_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reason for not sending (optional)`)
};

export const agents_draft_reply_to = /** @type {(inputs: Agents_Draft_Reply_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original message`)
};

export const agents_draft_save_failed = /** @type {(inputs: Agents_Draft_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save the text`)
};

export const agents_draft_side = /** @type {(inputs: Agents_Draft_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text shown`)
};

export const agents_draft_side_source = /** @type {(inputs: Agents_Draft_Side_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your language (to check)`)
};

export const agents_draft_side_text = /** @type {(inputs: Agents_Draft_Side_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lang} (to send)`)
};

export const agents_draft_slack = /** @type {(inputs: Agents_Draft_SlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft`)
};

export const agents_draft_slack_again = /** @type {(inputs: Agents_Draft_Slack_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Place again`)
};

export const agents_draft_slack_failed = /** @type {(inputs: Agents_Draft_Slack_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not place it: ${i?.error}`)
};

export const agents_draft_slack_placed = /** @type {(inputs: Agents_Draft_Slack_PlacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placed as a draft`)
};

export const agents_draft_slack_placing = /** @type {(inputs: Agents_Draft_Slack_PlacingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placing the draft`)
};

export const agents_draft_slack_request_failed = /** @type {(inputs: Agents_Draft_Slack_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't ask to put it in drafts`)
};

export const agents_draft_slack_stale = /** @type {(inputs: Agents_Draft_Slack_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The text changed after it was placed`)
};

export const agents_draft_stale = /** @type {(inputs: Agents_Draft_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous content`)
};

export const agents_draft_subject = /** @type {(inputs: Agents_Draft_SubjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subject`)
};

export const agents_draft_text = /** @type {(inputs: Agents_Draft_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to send`)
};

export const agents_draft_thread = /** @type {(inputs: Agents_Draft_ThreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/thread`)
};

export const agents_draft_to_unknown = /** @type {(inputs: Agents_Draft_To_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No destination yet`)
};

export const agents_draft_translation = /** @type {(inputs: Agents_Draft_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation`)
};

export const agents_effort_label = /** @type {(inputs: Agents_Effort_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thinking effort`)
};

export const agents_empty = /** @type {(inputs: Agents_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No chats yet`)
};

export const agents_empty_active = /** @type {(inputs: Agents_Empty_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active chats`)
};

export const agents_filter = /** @type {(inputs: Agents_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter chats`)
};

export const agents_filter_active = /** @type {(inputs: Agents_Filter_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

export const agents_filter_all = /** @type {(inputs: Agents_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

export const agents_filter_archived = /** @type {(inputs: Agents_Filter_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

export const agents_from_parent = /** @type {(inputs: Agents_From_ParentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Instruction from the parent chat “${i?.name}”`)
};

export const agents_go = /** @type {(inputs: Agents_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Agents`)
};

export const agents_hours_minutes = /** @type {(inputs: Agents_Hours_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.h}h ${i?.m}m`)
};

export const agents_image_n = /** @type {(inputs: Agents_Image_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`image ${i?.n}`)
};

export const agents_limit_days = /** @type {(inputs: Agents_Limit_DaysInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} days`)
};

export const agents_limit_error = /** @type {(inputs: Agents_Limit_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.error} (values as of ${i?.at})`)
};

export const agents_limit_hours = /** @type {(inputs: Agents_Limit_HoursInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} hours`)
};

export const agents_limit_model = /** @type {(inputs: Agents_Limit_ModelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week · ${i?.model}`)
};

export const agents_limit_none = /** @type {(inputs: Agents_Limit_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not fetched yet`)
};

export const agents_limit_off = /** @type {(inputs: Agents_Limit_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching usage limits is turned off`)
};

export const agents_limit_resets = /** @type {(inputs: Agents_Limit_ResetsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`resets ${i?.when}`)
};

export const agents_limit_title = /** @type {(inputs: Agents_Limit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage limits`)
};

export const agents_limit_week = /** @type {(inputs: Agents_Limit_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Week`)
};

export const agents_list = /** @type {(inputs: Agents_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chats`)
};

export const agents_load_failed = /** @type {(inputs: Agents_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load`)
};

export const agents_loading_older = /** @type {(inputs: Agents_Loading_OlderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading`)
};

export const agents_mark_compacted = /** @type {(inputs: Agents_Mark_CompactedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The conversation up to here was compacted`)
};

export const agents_mark_read = /** @type {(inputs: Agents_Mark_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as read`)
};

export const agents_mark_rewound = /** @type {(inputs: Agents_Mark_RewoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewound here`)
};

export const agents_mark_stopped = /** @type {(inputs: Agents_Mark_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopped`)
};

export const agents_mark_withdrawn = /** @type {(inputs: Agents_Mark_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken back`)
};

export const agents_menu = /** @type {(inputs: Agents_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat menu`)
};

export const agents_message_edited = /** @type {(inputs: Agents_Message_EditedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(edited)`)
};

export const agents_message_removed = /** @type {(inputs: Agents_Message_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This message was removed`)
};

export const agents_minutes_seconds = /** @type {(inputs: Agents_Minutes_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.m}m ${i?.s}s`)
};

export const agents_model_cli_default = /** @type {(inputs: Agents_Model_Cli_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI default`)
};

export const agents_model_label = /** @type {(inputs: Agents_Model_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

export const agents_more_conditions = /** @type {(inputs: Agents_More_ConditionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working directory and other MCP`)
};

export const agents_nav = /** @type {(inputs: Agents_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents`)
};

export const agents_new = /** @type {(inputs: Agents_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New chat`)
};

export const agents_new_hint = /** @type {(inputs: Agents_New_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Write below and send; the agent on ${i?.device} answers. Pick the model and working directory under the box`)
};

export const agents_no_agent_yet = /** @type {(inputs: Agents_No_Agent_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still checking which of Claude Code / Codex this PC has. Wait a moment before sending`)
};

export const agents_no_device = /** @type {(inputs: Agents_No_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No agent is registered on this PC yet`)
};

export const agents_not_found = /** @type {(inputs: Agents_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This chat was not found`)
};

export const agents_notice_answered = /** @type {(inputs: Agents_Notice_AnsweredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`got an answer`)
};

export const agents_notice_asked = /** @type {(inputs: Agents_Notice_AskedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`is asking: ${i?.title}`)
};

export const agents_notice_ended = /** @type {(inputs: Agents_Notice_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`finished`)
};

export const agents_notice_failed = /** @type {(inputs: Agents_Notice_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`failed: ${i?.error}`)
};

export const agents_notice_instructed = /** @type {(inputs: Agents_Notice_InstructedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was instructed`)
};

export const agents_notice_other = /** @type {(inputs: Agents_Notice_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`had something happen`)
};

export const agents_notice_raised = /** @type {(inputs: Agents_Notice_RaisedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`item raised to you: ${i?.title}`)
};

export const agents_notice_read = /** @type {(inputs: Agents_Notice_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was read`)
};

export const agents_notice_retried = /** @type {(inputs: Agents_Notice_RetriedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`was retried`)
};

export const agents_notice_started = /** @type {(inputs: Agents_Notice_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`started`)
};

export const agents_notice_step_closed = /** @type {(inputs: Agents_Notice_Step_ClosedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`closed the Action “${i?.title}”`)
};

export const agents_notice_stopped = /** @type {(inputs: Agents_Notice_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`stopped`)
};

export const agents_notice_turn_added = /** @type {(inputs: Agents_Notice_Turn_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`added an item: ${i?.title}`)
};

export const agents_notices_count = /** @type {(inputs: Agents_Notices_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} behind the scenes`)
};

export const agents_open_settings = /** @type {(inputs: Agents_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open settings`)
};

export const agents_other_mcp = /** @type {(inputs: Agents_Other_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other MCPs`)
};

export const agents_other_mcp_short = /** @type {(inputs: Agents_Other_Mcp_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

export const agents_other_mcp_warning = /** @type {(inputs: Agents_Other_Mcp_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With other MCPs, it can reach whatever those MCPs reach, even without a working directory.`)
};

export const agents_outline = /** @type {(inputs: Agents_OutlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outline of the chat`)
};

export const agents_outline_side = /** @type {(inputs: Agents_Outline_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the side chat`)
};

export const agents_parent_chat = /** @type {(inputs: Agents_Parent_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parent chat`)
};

export const agents_pc_agents = /** @type {(inputs: Agents_Pc_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents found`)
};

export const agents_pc_auth_ok = /** @type {(inputs: Agents_Pc_Auth_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logged in`)
};

export const agents_pc_auth_ok_account = /** @type {(inputs: Agents_Pc_Auth_Ok_AccountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Logged in (${i?.account})`)
};

export const agents_pc_auth_out = /** @type {(inputs: Agents_Pc_Auth_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not logged in`)
};

export const agents_pc_auth_unknown = /** @type {(inputs: Agents_Pc_Auth_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not tell whether it is logged in`)
};

export const agents_pc_compact = /** @type {(inputs: Agents_Pc_CompactInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auto compact (%) · ${i?.agent}`)
};

export const agents_pc_compact_note = /** @type {(inputs: Agents_Pc_Compact_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compact after a reply when the context reaches this share. 100 never compacts`)
};

export const agents_pc_concurrency = /** @type {(inputs: Agents_Pc_ConcurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run chats at the same time`)
};

export const agents_pc_concurrency_note = /** @type {(inputs: Agents_Pc_Concurrency_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whether chats with a working directory run at the same time or one at a time`)
};

export const agents_pc_default_agent = /** @type {(inputs: Agents_Pc_Default_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

export const agents_pc_default_cwd = /** @type {(inputs: Agents_Pc_Default_CwdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working directory`)
};

export const agents_pc_default_cwd_note = /** @type {(inputs: Agents_Pc_Default_Cwd_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each chat can change it under its post box`)
};

export const agents_pc_default_model = /** @type {(inputs: Agents_Pc_Default_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

export const agents_pc_defaults = /** @type {(inputs: Agents_Pc_DefaultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defaults of a new chat`)
};

export const agents_pc_description = /** @type {(inputs: Agents_Pc_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login, usage limits and working directories of Claude Code / Codex on this PC, and the defaults of a new chat`)
};

export const agents_pc_login = /** @type {(inputs: Agents_Pc_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in`)
};

export const agents_pc_login_again = /** @type {(inputs: Agents_Pc_Login_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in again`)
};

export const agents_pc_login_code = /** @type {(inputs: Agents_Pc_Login_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login code`)
};

export const agents_pc_login_code_hint = /** @type {(inputs: Agents_Pc_Login_Code_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter this code on the page that opened. It finishes by itself`)
};

export const agents_pc_login_error = /** @type {(inputs: Agents_Pc_Login_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not log in: ${i?.error}`)
};

export const agents_pc_login_failed = /** @type {(inputs: Agents_Pc_Login_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start the login`)
};

export const agents_pc_login_open = /** @type {(inputs: Agents_Pc_Login_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the login page`)
};

export const agents_pc_login_open_copy = /** @type {(inputs: Agents_Pc_Login_Open_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy the code and open the login page`)
};

export const agents_pc_login_paste_hint = /** @type {(inputs: Agents_Pc_Login_Paste_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in on the page that opened and paste the code it shows here`)
};

export const agents_pc_login_preparing = /** @type {(inputs: Agents_Pc_Login_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing on the PC…`)
};

export const agents_pc_login_sent = /** @type {(inputs: Agents_Pc_Login_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent. Checking…`)
};

export const agents_pc_login_verifying = /** @type {(inputs: Agents_Pc_Login_VerifyingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking…`)
};

export const agents_pc_name = /** @type {(inputs: Agents_Pc_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const agents_pc_other_mcp = /** @type {(inputs: Agents_Pc_Other_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other MCP`)
};

export const agents_pc_other_mcp_all = /** @type {(inputs: Agents_Pc_Other_Mcp_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use`)
};

export const agents_pc_other_mcp_none = /** @type {(inputs: Agents_Pc_Other_Mcp_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't use`)
};

export const agents_pc_other_mcp_note = /** @type {(inputs: Agents_Pc_Other_Mcp_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whether chats use the other MCP servers registered on this PC`)
};

export const agents_pc_other_mcp_read = /** @type {(inputs: Agents_Pc_Other_Mcp_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read only`)
};

export const agents_pc_parallel = /** @type {(inputs: Agents_Pc_ParallelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Together`)
};

export const agents_pc_quiet = /** @type {(inputs: Agents_Pc_QuietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wait before replying (s)`)
};

export const agents_pc_quiet_note = /** @type {(inputs: Agents_Pc_Quiet_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long to wait to read posts sent in a row together`)
};

export const agents_pc_serial = /** @type {(inputs: Agents_Pc_SerialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One at a time`)
};

export const agents_pc_title = /** @type {(inputs: Agents_Pc_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents on this PC`)
};

export const agents_pc_usage_limits = /** @type {(inputs: Agents_Pc_Usage_LimitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetch usage limits`)
};

export const agents_pc_usage_limits_note = /** @type {(inputs: Agents_Pc_Usage_Limits_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asks Anthropic (with Claude Code's sign-in) and Codex how much of each usage window is left. Off: nothing is fetched and no usage is shown`)
};

export const agents_pc_workdirs = /** @type {(inputs: Agents_Pc_WorkdirsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working directories`)
};

export const agents_pc_workdirs_none = /** @type {(inputs: Agents_Pc_Workdirs_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None yet`)
};

export const agents_pc_workdirs_note = /** @type {(inputs: Agents_Pc_Workdirs_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places the agent on this PC reported it may use. They cannot be added here`)
};

export const agents_pending_after = /** @type {(inputs: Agents_Pending_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read after this reply`)
};

export const agents_pending_next = /** @type {(inputs: Agents_Pending_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read at the next break`)
};

export const agents_pending_reading_now = /** @type {(inputs: Agents_Pending_Reading_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Having it read now…`)
};

export const agents_pending_withdrawing = /** @type {(inputs: Agents_Pending_WithdrawingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taking back…`)
};

export const agents_post_label = /** @type {(inputs: Agents_Post_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message to the agent`)
};

export const agents_post_placeholder = /** @type {(inputs: Agents_Post_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

export const agents_post_placeholder_running = /** @type {(inputs: Agents_Post_Placeholder_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can keep sending instructions`)
};

export const agents_reach_no_signer = /** @type {(inputs: Agents_Reach_No_SignerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions cannot be sent from a browser. Send them from the trameria app.`)
};

export const agents_reach_not_trusted = /** @type {(inputs: Agents_Reach_Not_TrustedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To send instructions to ${i?.device}, add ${i?.self} to ${i?.device}'s device list.`)
};

export const agents_reach_not_trusted_unnamed = /** @type {(inputs: Agents_Reach_Not_Trusted_UnnamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To send instructions to ${i?.device}, add the device you are using to ${i?.device}'s device list.`)
};

export const agents_reach_own_only = /** @type {(inputs: Agents_Reach_Own_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.self}, instructions can be sent to ${i?.self}'s own Agent only. To send to ${i?.device}, use the trameria app on a phone or a mac.`)
};

export const agents_reach_self_only = /** @type {(inputs: Agents_Reach_Self_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} can be used from its own app only. This can be changed in ${i?.device}'s app settings.`)
};

export const agents_read_now = /** @type {(inputs: Agents_Read_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read now`)
};

export const agents_related_changed = /** @type {(inputs: Agents_Related_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related objects`)
};

export const agents_rename = /** @type {(inputs: Agents_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

export const agents_rename_action = /** @type {(inputs: Agents_Rename_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

export const agents_request_failed = /** @type {(inputs: Agents_Request_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not do it`)
};

export const agents_retry = /** @type {(inputs: Agents_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

export const agents_rewind_action = /** @type {(inputs: Agents_Rewind_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back`)
};

export const agents_rewind_checking = /** @type {(inputs: Agents_Rewind_CheckingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking…`)
};

export const agents_rewind_conversation = /** @type {(inputs: Agents_Rewind_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation`)
};

export const agents_rewind_conversation_n = /** @type {(inputs: Agents_Rewind_Conversation_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Removes this post and the ${i?.n} after it, and puts this post back in the box`)
};

export const agents_rewind_conversation_one = /** @type {(inputs: Agents_Rewind_Conversation_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removes this post and puts it back in the box`)
};

export const agents_rewind_failed = /** @type {(inputs: Agents_Rewind_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not go back`)
};

export const agents_rewind_files = /** @type {(inputs: Agents_Rewind_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files on this PC`)
};

export const agents_rewind_files_bash = /** @type {(inputs: Agents_Rewind_Files_BashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files changed by Bash and the like do not go back`)
};

export const agents_rewind_files_codex = /** @type {(inputs: Agents_Rewind_Files_CodexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files cannot go back in a Codex chat`)
};

export const agents_rewind_files_n = /** @type {(inputs: Agents_Rewind_Files_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Puts ${i?.n} files back as they were`)
};

export const agents_rewind_files_none = /** @type {(inputs: Agents_Rewind_Files_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No files to put back`)
};

export const agents_rewind_files_off = /** @type {(inputs: Agents_Rewind_Files_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No checkpoint of the files, so they cannot go back`)
};

export const agents_rewind_here = /** @type {(inputs: Agents_Rewind_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back to here`)
};

export const agents_rewind_more = /** @type {(inputs: Agents_Rewind_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} more`)
};

export const agents_rewind_title = /** @type {(inputs: Agents_Rewind_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back to before this post`)
};

export const agents_rewind_trameria = /** @type {(inputs: Agents_Rewind_TrameriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria`)
};

export const agents_rewind_trameria_n = /** @type {(inputs: Agents_Rewind_Trameria_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Undoes the agent's changes after this post (${i?.n})`)
};

export const agents_rewind_trameria_none = /** @type {(inputs: Agents_Rewind_Trameria_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes to undo`)
};

export const agents_row_asking = /** @type {(inputs: Agents_Row_AskingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has a question`)
};

export const agents_row_delegating = /** @type {(inputs: Agents_Row_DelegatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delegated to a child`)
};

export const agents_row_queued = /** @type {(inputs: Agents_Row_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting its turn`)
};

export const agents_row_unread = /** @type {(inputs: Agents_Row_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread`)
};

export const agents_row_working = /** @type {(inputs: Agents_Row_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working`)
};

export const agents_save_failed = /** @type {(inputs: Agents_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save`)
};

export const agents_seconds = /** @type {(inputs: Agents_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}s`)
};

export const agents_send = /** @type {(inputs: Agents_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

export const agents_send_failed = /** @type {(inputs: Agents_Send_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send (your text is back in the box)`)
};

export const agents_send_hint_enter = /** @type {(inputs: Agents_Send_Hint_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send (Enter). Shift+Enter for a new line`)
};

export const agents_send_hint_mod = /** @type {(inputs: Agents_Send_Hint_ModInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send (${i?.mod}+Enter). Enter for a new line`)
};

export const agents_sending = /** @type {(inputs: Agents_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

export const agents_side_close = /** @type {(inputs: Agents_Side_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const agents_side_composer_placeholder = /** @type {(inputs: Agents_Side_Composer_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write in the side chat…`)
};

export const agents_side_from = /** @type {(inputs: Agents_Side_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branched off a message of the main chat`)
};

export const agents_side_label = /** @type {(inputs: Agents_Side_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side chat`)
};

export const agents_side_new = /** @type {(inputs: Agents_Side_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branching off this reply`)
};

export const agents_side_open = /** @type {(inputs: Agents_Side_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open the side chat “${i?.title}”`)
};

export const agents_side_open_page = /** @type {(inputs: Agents_Side_Open_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open as a page`)
};

export const agents_side_placeholder = /** @type {(inputs: Agents_Side_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask something apart from the main chat…`)
};

export const agents_side_reply_gone = /** @type {(inputs: Agents_Side_Reply_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The reply of the main chat is not loaded`)
};

export const agents_side_start = /** @type {(inputs: Agents_Side_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open side chat`)
};

export const agents_signal_slack_draft = /** @type {(inputs: Agents_Signal_Slack_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asked to place a Slack draft`)
};

export const agents_signal_step_ready = /** @type {(inputs: Agents_Signal_Step_ReadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.steps} of “${i?.caseTitle}” became current`)
};

export const agents_signal_turn_awaiting = /** @type {(inputs: Agents_Signal_Turn_AwaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A child chat's item was still not handled, so it was sent again`)
};

export const agents_signal_turn_declined = /** @type {(inputs: Agents_Signal_Turn_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A your-turn item was declined`)
};

export const agents_signal_turn_withdrawn = /** @type {(inputs: Agents_Signal_Turn_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The parent chat withdrew a your-turn item`)
};

export const agents_signal_wait_target = /** @type {(inputs: Agents_Signal_Wait_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.title}”, waited on in “${i?.caseTitle}”, changed`)
};

export const agents_someone = /** @type {(inputs: Agents_SomeoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(a user who left)`)
};

export const agents_start = /** @type {(inputs: Agents_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a chat`)
};

export const agents_status_compacting = /** @type {(inputs: Agents_Status_CompactingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compacting the conversation so far`)
};

export const agents_status_starting = /** @type {(inputs: Agents_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting to be read`)
};

export const agents_status_stopping = /** @type {(inputs: Agents_Status_StoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopping…`)
};

export const agents_status_thinking = /** @type {(inputs: Agents_Status_ThinkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thinking`)
};

export const agents_status_waiting = /** @type {(inputs: Agents_Status_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting its turn (another chat is writing)`)
};

export const agents_status_writing = /** @type {(inputs: Agents_Status_WritingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing`)
};

export const agents_stop = /** @type {(inputs: Agents_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop`)
};

export const agents_stop_failed = /** @type {(inputs: Agents_Stop_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not stop`)
};

export const agents_suggest_loading = /** @type {(inputs: Agents_Suggest_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking…`)
};

export const agents_tap_to_withdraw = /** @type {(inputs: Agents_Tap_To_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to take it back into the input field`)
};

export const agents_this_pc_name = /** @type {(inputs: Agents_This_Pc_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC`)
};

export const agents_time_range = /** @type {(inputs: Agents_Time_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}–${i?.to}`)
};

export const agents_title = /** @type {(inputs: Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents`)
};

export const agents_title_label = /** @type {(inputs: Agents_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat name`)
};

export const agents_title_placeholder = /** @type {(inputs: Agents_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a name`)
};

export const agents_to_end = /** @type {(inputs: Agents_To_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to latest`)
};

export const agents_turn_after = /** @type {(inputs: Agents_Turn_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

export const agents_turn_answer = /** @type {(inputs: Agents_Turn_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer`)
};

export const agents_turn_answer_failed = /** @type {(inputs: Agents_Turn_Answer_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send`)
};

export const agents_turn_before = /** @type {(inputs: Agents_Turn_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

export const agents_turn_browser_read_only = /** @type {(inputs: Agents_Turn_Browser_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This cannot be answered in a browser. Answer it in the trameria app.`)
};

export const agents_turn_cause_approved = /** @type {(inputs: Agents_Turn_Cause_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you allowed it`)
};

export const agents_turn_cause_conversation = /** @type {(inputs: Agents_Turn_Cause_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`after talking`)
};

export const agents_turn_cause_human = /** @type {(inputs: Agents_Turn_Cause_HumanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`edited by you`)
};

export const agents_turn_changed = /** @type {(inputs: Agents_Turn_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The content changed. Read the new content before answering`)
};

export const agents_turn_check_placeholder = /** @type {(inputs: Agents_Turn_Check_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment (for NG, what needs fixing; you can paste images)`)
};

export const agents_turn_choice_placeholder = /** @type {(inputs: Agents_Turn_Choice_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment or other answer (you can paste images)`)
};

export const agents_turn_chosen = /** @type {(inputs: Agents_Turn_ChosenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chosen`)
};

export const agents_turn_close = /** @type {(inputs: Agents_Turn_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const agents_turn_closed_already = /** @type {(inputs: Agents_Turn_Closed_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This item was already closed`)
};

export const agents_turn_comment = /** @type {(inputs: Agents_Turn_CommentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment`)
};

export const agents_turn_comment_placeholder = /** @type {(inputs: Agents_Turn_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment (optional, you can paste images)`)
};

export const agents_turn_count = /** @type {(inputs: Agents_Turn_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your turn: ${i?.count}`)
};

export const agents_turn_current_above = /** @type {(inputs: Agents_Turn_Current_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current content (above)`)
};

export const agents_turn_date_clear = /** @type {(inputs: Agents_Turn_Date_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const agents_turn_date_pick = /** @type {(inputs: Agents_Turn_Date_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date`)
};

export const agents_turn_edited_by_you = /** @type {(inputs: Agents_Turn_Edited_By_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edited by you`)
};

export const agents_turn_fold = /** @type {(inputs: Agents_Turn_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fold`)
};

export const agents_turn_form_placeholder = /** @type {(inputs: Agents_Turn_Form_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment, or what the fields do not cover (you can paste images)`)
};

export const agents_turn_from = /** @type {(inputs: Agents_Turn_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From “${i?.name}”`)
};

export const agents_turn_hand_over = /** @type {(inputs: Agents_Turn_Hand_OverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand over`)
};

export const agents_turn_held_by = /** @type {(inputs: Agents_Turn_Held_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Held by “${i?.name}”`)
};

export const agents_turn_history = /** @type {(inputs: Agents_Turn_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revision history (oldest first)`)
};

export const agents_turn_kind_check = /** @type {(inputs: Agents_Turn_Kind_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please check`)
};

export const agents_turn_kind_draft_email = /** @type {(inputs: Agents_Turn_Kind_Draft_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to send by email`)
};

export const agents_turn_kind_draft_slack = /** @type {(inputs: Agents_Turn_Kind_Draft_SlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text to send on Slack`)
};

export const agents_turn_kind_operate = /** @type {(inputs: Agents_Turn_Kind_OperateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action request`)
};

export const agents_turn_kind_provide = /** @type {(inputs: Agents_Turn_Kind_ProvideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File request`)
};

export const agents_turn_label = /** @type {(inputs: Agents_Turn_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your turn`)
};

export const agents_turn_line_done = /** @type {(inputs: Agents_Turn_Line_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Done: ${i?.title}`)
};

export const agents_turn_line_withdrawn = /** @type {(inputs: Agents_Turn_Line_WithdrawnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Withdrawn: ${i?.title}`)
};

export const agents_turn_links = /** @type {(inputs: Agents_Turn_LinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places to look at`)
};

export const agents_turn_multi = /** @type {(inputs: Agents_Turn_MultiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all that apply`)
};

export const agents_turn_need_fix = /** @type {(inputs: Agents_Turn_Need_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write what should be fixed`)
};

export const agents_turn_need_reason = /** @type {(inputs: Agents_Turn_Need_ReasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write why it could not be done`)
};

export const agents_turn_no = /** @type {(inputs: Agents_Turn_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

export const agents_turn_operate_placeholder = /** @type {(inputs: Agents_Turn_Operate_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment (for a problem, what went wrong; you can paste images)`)
};

export const agents_turn_place = /** @type {(inputs: Agents_Turn_PlaceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.at}/${i?.count}`)
};

export const agents_turn_proposal = /** @type {(inputs: Agents_Turn_ProposalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wants to change this`)
};

export const agents_turn_proposal_accept = /** @type {(inputs: Agents_Turn_Proposal_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow the change`)
};

export const agents_turn_proposal_current = /** @type {(inputs: Agents_Turn_Proposal_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the current content`)
};

export const agents_turn_proposal_keep = /** @type {(inputs: Agents_Turn_Proposal_KeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep it as is`)
};

export const agents_turn_provide_placeholder = /** @type {(inputs: Agents_Turn_Provide_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write what to submit (you can paste files)`)
};

export const agents_turn_recommended = /** @type {(inputs: Agents_Turn_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

export const agents_turn_result_done = /** @type {(inputs: Agents_Turn_Result_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

export const agents_turn_result_failed = /** @type {(inputs: Agents_Turn_Result_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A problem`)
};

export const agents_turn_result_fix = /** @type {(inputs: Agents_Turn_Result_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not OK`)
};

export const agents_turn_result_ok = /** @type {(inputs: Agents_Turn_Result_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

export const agents_turn_result_sent = /** @type {(inputs: Agents_Turn_Result_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent`)
};

export const agents_turn_result_unsent = /** @type {(inputs: Agents_Turn_Result_UnsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not sending`)
};

export const agents_turn_rewritten = /** @type {(inputs: Agents_Turn_RewrittenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rewritten`)
};

export const agents_turn_text_placeholder = /** @type {(inputs: Agents_Turn_Text_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write an answer`)
};

export const agents_turn_ui_confirm = /** @type {(inputs: Agents_Turn_Ui_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer with this?`)
};

export const agents_turn_ui_placeholder = /** @type {(inputs: Agents_Turn_Ui_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment (sent with the UI's answer)`)
};

export const agents_turn_view_draft = /** @type {(inputs: Agents_Turn_View_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the text`)
};

export const agents_turn_view_question = /** @type {(inputs: Agents_Turn_View_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the question`)
};

export const agents_turn_view_request = /** @type {(inputs: Agents_Turn_View_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the request`)
};

export const agents_turn_yes = /** @type {(inputs: Agents_Turn_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};

export const agents_unarchive = /** @type {(inputs: Agents_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unarchive`)
};

export const agents_undo = /** @type {(inputs: Agents_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

export const agents_undo_all = /** @type {(inputs: Agents_Undo_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo all`)
};

export const agents_undo_all_title = /** @type {(inputs: Agents_Undo_All_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Undo all ${i?.n} changes made by this reply?`)
};

export const agents_undo_conflict = /** @type {(inputs: Agents_Undo_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What changed again afterwards was not undone`)
};

export const agents_undo_created = /** @type {(inputs: Agents_Undo_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`creation`)
};

export const agents_undo_done = /** @type {(inputs: Agents_Undo_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undone`)
};

export const agents_undo_failed = /** @type {(inputs: Agents_Undo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not undo. Press again`)
};

export const agents_undo_title = /** @type {(inputs: Agents_Undo_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Undo the ${i?.op} of “${i?.title}”?`)
};

export const agents_undo_updated = /** @type {(inputs: Agents_Undo_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`change`)
};

export const agents_undo_working = /** @type {(inputs: Agents_Undo_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undoing…`)
};

export const agents_unread_from_here = /** @type {(inputs: Agents_Unread_From_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread from here`)
};

export const agents_untitled = /** @type {(inputs: Agents_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New chat`)
};

export const agents_usage_cache_read = /** @type {(inputs: Agents_Usage_Cache_ReadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cache read`)
};

export const agents_usage_cache_write = /** @type {(inputs: Agents_Usage_Cache_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cache write`)
};

export const agents_usage_compact = /** @type {(inputs: Agents_Usage_CompactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compact`)
};

export const agents_usage_compact_failed = /** @type {(inputs: Agents_Usage_Compact_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not compact`)
};

export const agents_usage_context = /** @type {(inputs: Agents_Usage_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Context`)
};

export const agents_usage_cost = /** @type {(inputs: Agents_Usage_CostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost`)
};

export const agents_usage_empty = /** @type {(inputs: Agents_Usage_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once a run starts, its usage shows here`)
};

export const agents_usage_input = /** @type {(inputs: Agents_Usage_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input`)
};

export const agents_usage_label = /** @type {(inputs: Agents_Usage_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage of this session`)
};

export const agents_usage_output = /** @type {(inputs: Agents_Usage_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output`)
};

export const agents_usage_session = /** @type {(inputs: Agents_Usage_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This session`)
};

export const agents_value_missing = /** @type {(inputs: Agents_Value_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} (not on this PC)`)
};

export const agents_via = /** @type {(inputs: Agents_ViaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`via ${i?.name}`)
};

export const agents_view_label = /** @type {(inputs: Agents_View_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Side view`)
};

export const agents_wait_turn_closed = /** @type {(inputs: Agents_Wait_Turn_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In the chat`)
};

export const agents_wait_turn_open = /** @type {(inputs: Agents_Wait_Turn_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer in the chat`)
};

export const agents_withdraw = /** @type {(inputs: Agents_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take back`)
};

export const agents_withdraw_failed = /** @type {(inputs: Agents_Withdraw_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't take it back. The device didn't answer.`)
};

export const agents_withdraw_too_late = /** @type {(inputs: Agents_Withdraw_Too_LateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't take it back. It had already been read.`)
};

export const blocks_callout_blue = /** @type {(inputs: Blocks_Callout_BlueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blue`)
};

export const blocks_callout_change_color = /** @type {(inputs: Blocks_Callout_Change_ColorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Change color (now: ${i?.color})`)
};

export const blocks_callout_color = /** @type {(inputs: Blocks_Callout_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

export const blocks_callout_green = /** @type {(inputs: Blocks_Callout_GreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Green`)
};

export const blocks_callout_purple = /** @type {(inputs: Blocks_Callout_PurpleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purple`)
};

export const blocks_callout_red = /** @type {(inputs: Blocks_Callout_RedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Red`)
};

export const blocks_callout_title_placeholder = /** @type {(inputs: Blocks_Callout_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const blocks_callout_yellow = /** @type {(inputs: Blocks_Callout_YellowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yellow`)
};

export const blocks_close = /** @type {(inputs: Blocks_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const blocks_code_copy = /** @type {(inputs: Blocks_Code_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy code`)
};

export const blocks_copied = /** @type {(inputs: Blocks_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

export const blocks_copy_failed = /** @type {(inputs: Blocks_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't copy. Try again.`)
};

export const blocks_fence_cancel = /** @type {(inputs: Blocks_Fence_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const blocks_fence_edit_source = /** @type {(inputs: Blocks_Fence_Edit_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit source`)
};

export const blocks_fence_save = /** @type {(inputs: Blocks_Fence_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

export const blocks_fence_source = /** @type {(inputs: Blocks_Fence_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram source`)
};

export const blocks_file_actions = /** @type {(inputs: Blocks_File_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File actions`)
};

export const blocks_file_copy_link = /** @type {(inputs: Blocks_File_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

export const blocks_file_delete = /** @type {(inputs: Blocks_File_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const blocks_file_download = /** @type {(inputs: Blocks_File_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

export const blocks_file_enlarge = /** @type {(inputs: Blocks_File_EnlargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enlarge`)
};

export const blocks_file_enlarge_named = /** @type {(inputs: Blocks_File_Enlarge_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enlarge ${i?.name}`)
};

export const blocks_file_reset_width = /** @type {(inputs: Blocks_File_Reset_WidthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset width`)
};

export const blocks_file_resize = /** @type {(inputs: Blocks_File_ResizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resize image`)
};

export const blocks_footnote_body = /** @type {(inputs: Blocks_Footnote_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Body of footnote ${i?.heading}`)
};

export const blocks_footnote_create = /** @type {(inputs: Blocks_Footnote_CreateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Create footnote ${i?.label}`)
};

export const blocks_footnote_gone = /** @type {(inputs: Blocks_Footnote_GoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This footnote was removed from the body. It won't be written back.`)
};

export const blocks_footnote_heading = /** @type {(inputs: Blocks_Footnote_HeadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Footnote ${i?.heading}`)
};

export const blocks_footnote_named = /** @type {(inputs: Blocks_Footnote_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Footnote ${i?.n}`)
};

export const blocks_footnote_to_def = /** @type {(inputs: Blocks_Footnote_To_DefInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Go to the definition of footnote ${i?.n}`)
};

export const blocks_footnote_to_ref = /** @type {(inputs: Blocks_Footnote_To_RefInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Go to the reference of footnote ${i?.name}`)
};

export const blocks_footnote_unreferenced = /** @type {(inputs: Blocks_Footnote_UnreferencedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Footnote ${i?.name} (not referenced)`)
};

export const blocks_mermaid_failed = /** @type {(inputs: Blocks_Mermaid_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't draw the diagram: ${i?.error}`)
};

export const blocks_table_add_above = /** @type {(inputs: Blocks_Table_Add_AboveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add above`)
};

export const blocks_table_add_below = /** @type {(inputs: Blocks_Table_Add_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add below`)
};

export const blocks_table_add_col = /** @type {(inputs: Blocks_Table_Add_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add column`)
};

export const blocks_table_add_left = /** @type {(inputs: Blocks_Table_Add_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add left`)
};

export const blocks_table_add_right = /** @type {(inputs: Blocks_Table_Add_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add right`)
};

export const blocks_table_add_row = /** @type {(inputs: Blocks_Table_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add row`)
};

export const blocks_table_col_actions = /** @type {(inputs: Blocks_Table_Col_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Column ${i?.n} actions`)
};

export const blocks_table_col_resize = /** @type {(inputs: Blocks_Table_Col_ResizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resize column ${i?.n}`)
};

export const blocks_table_delete_col = /** @type {(inputs: Blocks_Table_Delete_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this column`)
};

export const blocks_table_delete_row = /** @type {(inputs: Blocks_Table_Delete_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this row`)
};

export const blocks_table_freeze_here = /** @type {(inputs: Blocks_Table_Freeze_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freeze up to here`)
};

export const blocks_table_row_actions = /** @type {(inputs: Blocks_Table_Row_ActionsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Row ${i?.n} actions`)
};

export const blocks_table_unfreeze = /** @type {(inputs: Blocks_Table_UnfreezeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unfreeze`)
};

export const blocks_toggle_close = /** @type {(inputs: Blocks_Toggle_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse toggle`)
};

export const blocks_toggle_open = /** @type {(inputs: Blocks_Toggle_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expand toggle`)
};

export const blocks_upload_aborted = /** @type {(inputs: Blocks_Upload_AbortedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload canceled`)
};

export const blocks_upload_cancel = /** @type {(inputs: Blocks_Upload_CancelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cancel upload of ${i?.name}`)
};

export const blocks_upload_failed = /** @type {(inputs: Blocks_Upload_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed. Try again.`)
};

export const blocks_upload_failed_network = /** @type {(inputs: Blocks_Upload_Failed_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed (network error). Try again.`)
};

export const blocks_upload_failed_status = /** @type {(inputs: Blocks_Upload_Failed_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Upload failed (${i?.status}). Try again.`)
};

export const blocks_upload_too_large = /** @type {(inputs: Blocks_Upload_Too_LargeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This file is too large to upload.`)
};

export const blocks_uploads = /** @type {(inputs: Blocks_UploadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files uploading`)
};

export const cases_action_title = /** @type {(inputs: Cases_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action title`)
};

export const cases_action_title_placeholder = /** @type {(inputs: Cases_Action_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next action`)
};

export const cases_add = /** @type {(inputs: Cases_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

export const cases_add_action = /** @type {(inputs: Cases_Add_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Action`)
};

export const cases_add_action_button = /** @type {(inputs: Cases_Add_Action_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add Action`)
};

export const cases_add_step_needs_title = /** @type {(inputs: Cases_Add_Step_Needs_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write the Case's title first`)
};

export const cases_add_waiting = /** @type {(inputs: Cases_Add_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Waiting`)
};

export const cases_add_waiting_button = /** @type {(inputs: Cases_Add_Waiting_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+ Add Waiting`)
};

export const cases_agent_memo = /** @type {(inputs: Cases_Agent_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI memo`)
};

export const cases_body = /** @type {(inputs: Cases_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

export const cases_body_placeholder = /** @type {(inputs: Cases_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

export const cases_body_write_placeholder = /** @type {(inputs: Cases_Body_Write_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write the details…`)
};

export const cases_case_title = /** @type {(inputs: Cases_Case_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case title`)
};

export const cases_chain = /** @type {(inputs: Cases_ChainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chain`)
};

export const cases_chain_done = /** @type {(inputs: Cases_Chain_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

export const cases_chain_empty = /** @type {(inputs: Cases_Chain_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Action or Waiting yet`)
};

export const cases_chain_graph = /** @type {(inputs: Cases_Chain_GraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chain diagram`)
};

export const cases_chain_later = /** @type {(inputs: Cases_Chain_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

export const cases_chain_now = /** @type {(inputs: Cases_Chain_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

export const cases_change_due = /** @type {(inputs: Cases_Change_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the due date`)
};

export const cases_change_plan = /** @type {(inputs: Cases_Change_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change the day to do it`)
};

export const cases_change_wait_until = /** @type {(inputs: Cases_Change_Wait_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change how long to wait`)
};

export const cases_closed_empty = /** @type {(inputs: Cases_Closed_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No closed Cases`)
};

export const cases_col_case = /** @type {(inputs: Cases_Col_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const cases_col_due = /** @type {(inputs: Cases_Col_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due`)
};

export const cases_col_name = /** @type {(inputs: Cases_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const cases_col_plan = /** @type {(inputs: Cases_Col_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do on`)
};

export const cases_col_updated = /** @type {(inputs: Cases_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

export const cases_col_wait = /** @type {(inputs: Cases_Col_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting on`)
};

export const cases_context = /** @type {(inputs: Cases_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Context`)
};

export const cases_context_placeholder = /** @type {(inputs: Cases_Context_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it got here`)
};

export const cases_create = /** @type {(inputs: Cases_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Case`)
};

export const cases_create_failed_kept = /** @type {(inputs: Cases_Create_Failed_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not create it (what you wrote is kept)`)
};

export const cases_delete_body = /** @type {(inputs: Cases_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its Actions, Waitings, links, files and AI memo go with it. This cannot be undone. To just finish it, complete or drop it.`)
};

export const cases_delete_failed = /** @type {(inputs: Cases_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete "${i?.title}"`)
};

export const cases_delete_title = /** @type {(inputs: Cases_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.title}"`)
};

export const cases_done = /** @type {(inputs: Cases_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete`)
};

export const cases_drop = /** @type {(inputs: Cases_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop`)
};

export const cases_due = /** @type {(inputs: Cases_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due`)
};

export const cases_due_clear = /** @type {(inputs: Cases_Due_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the due date`)
};

export const cases_empty = /** @type {(inputs: Cases_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Cases`)
};

export const cases_file_bytes = /** @type {(inputs: Cases_File_BytesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} B`)
};

export const cases_file_kb = /** @type {(inputs: Cases_File_KbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} KB`)
};

export const cases_file_mb = /** @type {(inputs: Cases_File_MbInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} MB`)
};

export const cases_file_remove = /** @type {(inputs: Cases_File_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
};

export const cases_file_remove_failed = /** @type {(inputs: Cases_File_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not remove ${i?.name}`)
};

export const cases_files = /** @type {(inputs: Cases_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files`)
};

export const cases_go = /** @type {(inputs: Cases_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Cases`)
};

export const cases_graph_delegated = /** @type {(inputs: Cases_Graph_DelegatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delegated to Agent`)
};

export const cases_graph_progress = /** @type {(inputs: Cases_Graph_ProgressInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.done} / ${i?.total}`)
};

export const cases_kind_action = /** @type {(inputs: Cases_Kind_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

export const cases_kind_waiting = /** @type {(inputs: Cases_Kind_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

export const cases_label = /** @type {(inputs: Cases_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

export const cases_label_change = /** @type {(inputs: Cases_Label_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Change the label "${i?.name}"`)
};

export const cases_label_failed = /** @type {(inputs: Cases_Label_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change the label`)
};

export const cases_label_set = /** @type {(inputs: Cases_Label_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a label`)
};

export const cases_list = /** @type {(inputs: Cases_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

export const cases_load_failed = /** @type {(inputs: Cases_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load`)
};

export const cases_menu = /** @type {(inputs: Cases_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for "${i?.title}"`)
};

export const cases_new = /** @type {(inputs: Cases_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Case`)
};

export const cases_not_found = /** @type {(inputs: Cases_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Case was not found`)
};

export const cases_overdue = /** @type {(inputs: Cases_OverdueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Past due (${i?.date})`)
};

export const cases_panel_close = /** @type {(inputs: Cases_Panel_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const cases_plan = /** @type {(inputs: Cases_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day to do it`)
};

export const cases_plan_carried = /** @type {(inputs: Cases_Plan_CarriedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Carried over (from ${i?.date})`)
};

export const cases_plan_clear = /** @type {(inputs: Cases_Plan_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the day`)
};

export const cases_plan_pick_date = /** @type {(inputs: Cases_Plan_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date…`)
};

export const cases_plan_someday = /** @type {(inputs: Cases_Plan_SomedayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later`)
};

export const cases_plan_this_week = /** @type {(inputs: Cases_Plan_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week`)
};

export const cases_plan_today = /** @type {(inputs: Cases_Plan_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

export const cases_plan_tomorrow = /** @type {(inputs: Cases_Plan_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow`)
};

export const cases_plan_week_of = /** @type {(inputs: Cases_Plan_Week_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Week of ${i?.date}`)
};

export const cases_related = /** @type {(inputs: Cases_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related`)
};

export const cases_related_add = /** @type {(inputs: Cases_Related_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add related`)
};

export const cases_related_add_failed = /** @type {(inputs: Cases_Related_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not add "${i?.name}"`)
};

export const cases_related_candidates = /** @type {(inputs: Cases_Related_CandidatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestions`)
};

export const cases_related_none = /** @type {(inputs: Cases_Related_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing found`)
};

export const cases_related_remove = /** @type {(inputs: Cases_Related_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove "${i?.name}"`)
};

export const cases_related_remove_failed = /** @type {(inputs: Cases_Related_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not remove "${i?.name}"`)
};

export const cases_related_search = /** @type {(inputs: Cases_Related_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search related`)
};

export const cases_related_search_placeholder = /** @type {(inputs: Cases_Related_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search Cases and people / paste a URL`)
};

export const cases_rename = /** @type {(inputs: Cases_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

export const cases_reopen = /** @type {(inputs: Cases_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reopen`)
};

export const cases_result = /** @type {(inputs: Cases_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

export const cases_result_placeholder = /** @type {(inputs: Cases_Result_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The result, if any`)
};

export const cases_source_step_body = /** @type {(inputs: Cases_Source_Step_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`details of ${i?.kind} "${i?.title}"`)
};

export const cases_source_step_result = /** @type {(inputs: Cases_Source_Step_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`result of ${i?.kind} "${i?.title}"`)
};

export const cases_source_step_wait = /** @type {(inputs: Cases_Source_Step_WaitInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`wait of ${i?.kind} "${i?.title}"`)
};

export const cases_status_done = /** @type {(inputs: Cases_Status_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

export const cases_status_dropped = /** @type {(inputs: Cases_Status_DroppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropped`)
};

export const cases_status_failed = /** @type {(inputs: Cases_Status_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change the state`)
};

export const cases_step_add_failed = /** @type {(inputs: Cases_Step_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not add "${i?.title}"`)
};

export const cases_step_auto_closed = /** @type {(inputs: Cases_Step_Auto_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed automatically`)
};

export const cases_step_close_failed = /** @type {(inputs: Cases_Step_Close_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not close "${i?.title}"`)
};

export const cases_step_created = /** @type {(inputs: Cases_Step_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

export const cases_step_delete_body = /** @type {(inputs: Cases_Step_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its details, result, links and files go with it. This cannot be undone.`)
};

export const cases_step_delete_failed = /** @type {(inputs: Cases_Step_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete "${i?.title}"`)
};

export const cases_step_delete_title = /** @type {(inputs: Cases_Step_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.title}"`)
};

export const cases_step_done = /** @type {(inputs: Cases_Step_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Complete "${i?.title}"`)
};

export const cases_step_due = /** @type {(inputs: Cases_Step_DueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Due ${i?.date}`)
};

export const cases_step_due_failed = /** @type {(inputs: Cases_Step_Due_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change the due date of "${i?.title}"`)
};

export const cases_step_kind = /** @type {(inputs: Cases_Step_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind`)
};

export const cases_step_menu = /** @type {(inputs: Cases_Step_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for "${i?.title}"`)
};

export const cases_step_plan = /** @type {(inputs: Cases_Step_PlanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Do ${i?.label}`)
};

export const cases_step_plan_failed = /** @type {(inputs: Cases_Step_Plan_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change the day of "${i?.title}"`)
};

export const cases_step_rename_failed = /** @type {(inputs: Cases_Step_Rename_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not rename "${i?.title}"`)
};

export const cases_step_reopen_failed = /** @type {(inputs: Cases_Step_Reopen_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not reopen "${i?.title}"`)
};

export const cases_step_resolve = /** @type {(inputs: Cases_Step_ResolveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resolve "${i?.title}"`)
};

export const cases_step_title = /** @type {(inputs: Cases_Step_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action / Waiting title`)
};

export const cases_step_unplaced = /** @type {(inputs: Cases_Step_UnplacedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Placed for now`)
};

export const cases_step_unplaced_hint = /** @type {(inputs: Cases_Step_Unplaced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added from the screen. AI will decide where it goes in the Chain`)
};

export const cases_step_wait_target_dropped = /** @type {(inputs: Cases_Step_Wait_Target_DroppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it waited on was dropped`)
};

export const cases_tab_closed = /** @type {(inputs: Cases_Tab_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

export const cases_tab_next = /** @type {(inputs: Cases_Tab_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

export const cases_tab_ready = /** @type {(inputs: Cases_Tab_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

export const cases_tab_waiting = /** @type {(inputs: Cases_Tab_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

export const cases_tabs = /** @type {(inputs: Cases_TabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases to show`)
};

export const cases_title = /** @type {(inputs: Cases_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

export const cases_title_failed = /** @type {(inputs: Cases_Title_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change the title`)
};

export const cases_title_placeholder = /** @type {(inputs: Cases_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const cases_wait_until = /** @type {(inputs: Cases_Wait_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wait until`)
};

export const cases_waiting_title = /** @type {(inputs: Cases_Waiting_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting title`)
};

export const cases_waiting_title_placeholder = /** @type {(inputs: Cases_Waiting_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you are waiting for`)
};

export const common_cancel = /** @type {(inputs: Common_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const common_days_ago = /** @type {(inputs: Common_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} days ago`)
};

export const common_days_later = /** @type {(inputs: Common_Days_LaterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`in ${i?.n} days`)
};

export const common_delete = /** @type {(inputs: Common_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const common_error_with_lead = /** @type {(inputs: Common_Error_With_LeadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.lead}. ${i?.message}`)
};

export const common_forbidden = /** @type {(inputs: Common_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission. Ask someone who has the role.`)
};

export const common_hours_ago = /** @type {(inputs: Common_Hours_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} h ago`)
};

export const common_just_now = /** @type {(inputs: Common_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`just now`)
};

export const common_load_more_failed = /** @type {(inputs: Common_Load_More_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't read more.`)
};

export const common_minutes_ago = /** @type {(inputs: Common_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} min ago`)
};

export const common_picture_apply = /** @type {(inputs: Common_Picture_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

export const common_picture_choose = /** @type {(inputs: Common_Picture_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose image`)
};

export const common_picture_crop_hint = /** @type {(inputs: Common_Picture_Crop_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drag to move it; use the slider, the wheel or a pinch to resize.`)
};

export const common_picture_failed = /** @type {(inputs: Common_Picture_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save the image`)
};

export const common_picture_remove = /** @type {(inputs: Common_Picture_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const common_picture_stage = /** @type {(inputs: Common_Picture_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crop position (arrow keys move it, + and - resize it)`)
};

export const common_picture_unreadable = /** @type {(inputs: Common_Picture_UnreadableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This image could not be read. Choose a PNG, JPEG, GIF or WebP.`)
};

export const common_picture_zoom = /** @type {(inputs: Common_Picture_ZoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

export const common_retry = /** @type {(inputs: Common_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

export const common_save = /** @type {(inputs: Common_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

export const common_today = /** @type {(inputs: Common_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`today`)
};

export const common_tomorrow = /** @type {(inputs: Common_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tomorrow`)
};

export const common_yesterday = /** @type {(inputs: Common_YesterdayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yesterday`)
};

export const datasets_add_row = /** @type {(inputs: Datasets_Add_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add row`)
};

export const datasets_col_field = /** @type {(inputs: Datasets_Col_FieldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field`)
};

export const datasets_col_filled = /** @type {(inputs: Datasets_Col_FilledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows with a value`)
};

export const datasets_date_clear = /** @type {(inputs: Datasets_Date_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear date`)
};

export const datasets_date_pick = /** @type {(inputs: Datasets_Date_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date`)
};

export const datasets_delete_row = /** @type {(inputs: Datasets_Delete_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete row`)
};

export const datasets_delete_row_body = /** @type {(inputs: Datasets_Delete_Row_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This row will be deleted from the dataset. This can't be undone.`)
};

export const datasets_distribution = /** @type {(inputs: Datasets_DistributionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Distribution of ${i?.field}`)
};

export const datasets_distribution_title = /** @type {(inputs: Datasets_Distribution_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distribution of values`)
};

export const datasets_distribution_top = /** @type {(inputs: Datasets_Distribution_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Most ${i?.count} rows`)
};

export const datasets_edit_row = /** @type {(inputs: Datasets_Edit_RowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit row`)
};

export const datasets_fields = /** @type {(inputs: Datasets_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fields`)
};

export const datasets_fields_guessed = /** @type {(inputs: Datasets_Fields_GuessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fields are set yet. These are guessed from the rows received.`)
};

export const datasets_fields_none = /** @type {(inputs: Datasets_Fields_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No fields yet.`)
};

export const datasets_json_invalid = /** @type {(inputs: Datasets_Json_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter JSON for "${i?.field}"`)
};

export const datasets_key = /** @type {(inputs: Datasets_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key`)
};

export const datasets_key_missing = /** @type {(inputs: Datasets_Key_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter the key field "${i?.field}"`)
};

export const datasets_latest = /** @type {(inputs: Datasets_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rows`)
};

export const datasets_latest_note = /** @type {(inputs: Datasets_Latest_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Newest write first · ${i?.shown} / ${i?.count} rows`)
};

export const datasets_list = /** @type {(inputs: Datasets_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset`)
};

export const datasets_list_back = /** @type {(inputs: Datasets_List_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to Documents`)
};

export const datasets_list_empty = /** @type {(inputs: Datasets_List_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No datasets yet.`)
};

export const datasets_list_load_failed = /** @type {(inputs: Datasets_List_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the datasets`)
};

export const datasets_list_new = /** @type {(inputs: Datasets_List_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New dataset`)
};

export const datasets_list_none_match = /** @type {(inputs: Datasets_List_None_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No datasets match.`)
};

export const datasets_load_failed = /** @type {(inputs: Datasets_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the dataset`)
};

export const datasets_new_create = /** @type {(inputs: Datasets_New_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

export const datasets_new_failed = /** @type {(inputs: Datasets_New_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't create the dataset`)
};

export const datasets_new_note = /** @type {(inputs: Datasets_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keeps the JSON rows that scripts and agents send. Only you see this dataset, and your own documents' ui can read it. Fields are guessed from the rows received; ask an agent to set fields or a retention period ahead.`)
};

export const datasets_new_title = /** @type {(inputs: Datasets_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const datasets_no_rows = /** @type {(inputs: Datasets_No_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No rows yet.`)
};

export const datasets_not_found = /** @type {(inputs: Datasets_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This dataset can't be found.`)
};

export const datasets_number_invalid = /** @type {(inputs: Datasets_Number_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter a number for "${i?.field}"`)
};

export const datasets_retention = /** @type {(inputs: Datasets_RetentionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rows older than ${i?.days} days are deleted`)
};

export const datasets_row_actions = /** @type {(inputs: Datasets_Row_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Row actions`)
};

export const datasets_row_json = /** @type {(inputs: Datasets_Row_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Row (JSON)`)
};

export const datasets_row_json_invalid = /** @type {(inputs: Datasets_Row_Json_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a JSON object`)
};

export const datasets_rows = /** @type {(inputs: Datasets_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rows`)
};

export const datasets_stat_distinct = /** @type {(inputs: Datasets_Stat_DistinctInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} distinct`)
};

export const datasets_stat_max = /** @type {(inputs: Datasets_Stat_MaxInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max ${i?.value}`)
};

export const datasets_stat_mean = /** @type {(inputs: Datasets_Stat_MeanInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mean ${i?.value}`)
};

export const datasets_stat_min = /** @type {(inputs: Datasets_Stat_MinInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Min ${i?.value}`)
};

export const datasets_stat_on = /** @type {(inputs: Datasets_Stat_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} checked`)
};

export const datasets_stat_range = /** @type {(inputs: Datasets_Stat_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first} – ${i?.last}`)
};

export const datasets_stat_sum = /** @type {(inputs: Datasets_Stat_SumInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total ${i?.value}`)
};

export const datasets_token_close = /** @type {(inputs: Datasets_Token_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const datasets_token_created = /** @type {(inputs: Datasets_Token_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Issued ${i?.date}`)
};

export const datasets_token_endpoint = /** @type {(inputs: Datasets_Token_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

export const datasets_token_failed = /** @type {(inputs: Datasets_Token_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't issue the token`)
};

export const datasets_token_issue = /** @type {(inputs: Datasets_Token_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue token`)
};

export const datasets_token_issue_action = /** @type {(inputs: Datasets_Token_Issue_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue`)
};

export const datasets_token_name = /** @type {(inputs: Datasets_Token_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const datasets_token_name_placeholder = /** @type {(inputs: Datasets_Token_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Morning CI`)
};

export const datasets_token_revoke = /** @type {(inputs: Datasets_Token_RevokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoke`)
};

export const datasets_token_revoke_body = /** @type {(inputs: Datasets_Token_Revoke_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scripts using this token will no longer be able to write to this dataset. This can't be undone.`)
};

export const datasets_token_revoke_label = /** @type {(inputs: Datasets_Token_Revoke_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Revoke "${i?.name}"`)
};

export const datasets_token_shown_once = /** @type {(inputs: Datasets_Token_Shown_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This token is shown only now. Copy it into your script.`)
};

export const datasets_token_unused = /** @type {(inputs: Datasets_Token_UnusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never used`)
};

export const datasets_token_used = /** @type {(inputs: Datasets_Token_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Last used ${i?.date}`)
};

export const datasets_tokens = /** @type {(inputs: Datasets_TokensInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write tokens`)
};

export const datasets_tokens_failed = /** @type {(inputs: Datasets_Tokens_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the tokens`)
};

export const datasets_tokens_left = /** @type {(inputs: Datasets_Tokens_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your personal data moved, so tokens issued before the move no longer work.`)
};

export const datasets_tokens_left_next = /** @type {(inputs: Datasets_Tokens_Left_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To keep sending rows from a script, issue a new token and replace the one set in the script.`)
};

export const datasets_tokens_none = /** @type {(inputs: Datasets_Tokens_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tokens yet.`)
};

export const datasets_tokens_note = /** @type {(inputs: Datasets_Tokens_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scripts use these to send rows. A token can only write rows of this dataset.`)
};

export const datasets_tokens_vault = /** @type {(inputs: Datasets_Tokens_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`While your personal data is in the Vault, write tokens can't be used. Add rows with "Add row" or through an agent.`)
};

export const datasets_type_boolean = /** @type {(inputs: Datasets_Type_BooleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checkbox`)
};

export const datasets_type_date = /** @type {(inputs: Datasets_Type_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

export const datasets_type_datetime = /** @type {(inputs: Datasets_Type_DatetimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date & time`)
};

export const datasets_type_json = /** @type {(inputs: Datasets_Type_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON`)
};

export const datasets_type_number = /** @type {(inputs: Datasets_Type_NumberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Number`)
};

export const datasets_type_string = /** @type {(inputs: Datasets_Type_StringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

export const datasets_updated = /** @type {(inputs: Datasets_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.time}`)
};

export const datasets_viewer_close = /** @type {(inputs: Datasets_Viewer_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const datasets_viewer_open = /** @type {(inputs: Datasets_Viewer_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open dataset`)
};

export const datasets_write_failed = /** @type {(inputs: Datasets_Write_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't save the row`)
};

export const datasets_written_at = /** @type {(inputs: Datasets_Written_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written`)
};

export const desktop_action_start = /** @type {(inputs: Desktop_Action_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const desktop_action_stop = /** @type {(inputs: Desktop_Action_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop`)
};

export const desktop_advanced_agent_bundled = /** @type {(inputs: Desktop_Advanced_Agent_BundledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.version} (bundled with the app)`)
};

export const desktop_app_update_available = /** @type {(inputs: Desktop_App_Update_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An app update is available`)
};

export const desktop_app_update_version = /** @type {(inputs: Desktop_App_Update_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version ${i?.version}`)
};

export const desktop_check_flags = /** @type {(inputs: Desktop_Check_FlagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flags`)
};

export const desktop_check_foreign_mcp = /** @type {(inputs: Desktop_Check_Foreign_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other MCPs`)
};

export const desktop_check_live = /** @type {(inputs: Desktop_Check_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectivity check`)
};

export const desktop_check_live_at = /** @type {(inputs: Desktop_Check_Live_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As of ${i?.at} (${i?.version})`)
};

export const desktop_check_live_at_stale = /** @type {(inputs: Desktop_Check_Live_At_StaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As of ${i?.at} (${i?.version}; now ${i?.current} — outdated result)`)
};

export const desktop_check_live_not_run = /** @type {(inputs: Desktop_Check_Live_Not_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectivity check: not run`)
};

export const desktop_device_add_hint = /** @type {(inputs: Desktop_Device_Add_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registers this Mac as a trameria device and starts the Agent`)
};

export const desktop_device_needs_login = /** @type {(inputs: Desktop_Device_Needs_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log in in the trameria window first`)
};

export const desktop_device_not_registered = /** @type {(inputs: Desktop_Device_Not_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not a trameria device`)
};

export const desktop_device_registered = /** @type {(inputs: Desktop_Device_RegisteredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered as a trameria device`)
};

export const desktop_device_remove_hint = /** @type {(inputs: Desktop_Device_Remove_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stops the Agent and removes this Mac from your trameria devices`)
};

export const desktop_device_removed_elsewhere = /** @type {(inputs: Desktop_Device_Removed_ElsewhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Mac was removed from your devices. To use it again, choose “Use this Mac as a device”`)
};

export const desktop_find_close = /** @type {(inputs: Desktop_Find_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const desktop_find_next = /** @type {(inputs: Desktop_Find_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

export const desktop_find_placeholder = /** @type {(inputs: Desktop_Find_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find in page`)
};

export const desktop_find_previous = /** @type {(inputs: Desktop_Find_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous`)
};

export const desktop_menubar_agent_toggle = /** @type {(inputs: Desktop_Menubar_Agent_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start or stop the Agent`)
};

export const desktop_menubar_block_next = /** @type {(inputs: Desktop_Menubar_Block_NextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next · ${i?.time}`)
};

export const desktop_notifications_blocked = /** @type {(inputs: Desktop_Notifications_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS notifications are not allowed`)
};

export const desktop_notifications_blocked_note = /** @type {(inputs: Desktop_Notifications_Blocked_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS notifications are not allowed. Allow this app in System Settings > Notifications to get mentions and other updates as macOS notifications`)
};

export const desktop_notifications_need_signed_build = /** @type {(inputs: Desktop_Notifications_Need_Signed_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications need a signed build. This build cannot show macOS notifications`)
};

export const desktop_notifications_open_settings = /** @type {(inputs: Desktop_Notifications_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open System Settings`)
};

export const desktop_open_main = /** @type {(inputs: Desktop_Open_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open trameria`)
};

export const desktop_quit = /** @type {(inputs: Desktop_QuitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quit`)
};

export const desktop_status_connected = /** @type {(inputs: Desktop_Status_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

export const desktop_status_error = /** @type {(inputs: Desktop_Status_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

export const desktop_status_reconnecting = /** @type {(inputs: Desktop_Status_ReconnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnecting`)
};

export const desktop_status_starting = /** @type {(inputs: Desktop_Status_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting`)
};

export const desktop_status_stopped = /** @type {(inputs: Desktop_Status_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopped`)
};

export const desktop_status_stopping = /** @type {(inputs: Desktop_Status_StoppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopping`)
};

export const desktop_token_unavailable = /** @type {(inputs: Desktop_Token_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This environment can't store the login`)
};

export const desktop_usage_loading = /** @type {(inputs: Desktop_Usage_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading usage…`)
};

export const desktop_usage_not_installed = /** @type {(inputs: Desktop_Usage_Not_InstalledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not found on this Mac`)
};

export const desktop_usage_off = /** @type {(inputs: Desktop_Usage_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching usage limits is turned off in settings`)
};

export const desktop_usage_refresh = /** @type {(inputs: Desktop_Usage_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

export const desktop_usage_settings = /** @type {(inputs: Desktop_Usage_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

export const desktop_usage_stale_error = /** @type {(inputs: Desktop_Usage_Stale_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't refresh: ${i?.error}`)
};

export const desktop_usage_title = /** @type {(inputs: Desktop_Usage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria usage`)
};

export const desktop_usage_updated_at = /** @type {(inputs: Desktop_Usage_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`As of ${i?.time}`)
};

export const desktop_usage_updated_minutes_ago = /** @type {(inputs: Desktop_Usage_Updated_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated ${i?.n} min ago`)
};

export const documents_agent_memo = /** @type {(inputs: Documents_Agent_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI memo`)
};

export const documents_archive = /** @type {(inputs: Documents_ArchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive`)
};

export const documents_archive_failed = /** @type {(inputs: Documents_Archive_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not archive “${i?.title}”`)
};

export const documents_block_bullet_list = /** @type {(inputs: Documents_Block_Bullet_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulleted list`)
};

export const documents_block_callout = /** @type {(inputs: Documents_Block_CalloutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Callout`)
};

export const documents_block_code = /** @type {(inputs: Documents_Block_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

export const documents_block_copied = /** @type {(inputs: Documents_Block_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

export const documents_block_copy_failed = /** @type {(inputs: Documents_Block_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy`)
};

export const documents_block_copy_markdown = /** @type {(inputs: Documents_Block_Copy_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy as Markdown`)
};

export const documents_block_delete = /** @type {(inputs: Documents_Block_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const documents_block_divider = /** @type {(inputs: Documents_Block_DividerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Divider`)
};

export const documents_block_duplicate = /** @type {(inputs: Documents_Block_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate`)
};

export const documents_block_file = /** @type {(inputs: Documents_Block_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

export const documents_block_file_hint = /** @type {(inputs: Documents_Block_File_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image, attachment`)
};

export const documents_block_footnote = /** @type {(inputs: Documents_Block_FootnoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Footnote`)
};

export const documents_block_heading1 = /** @type {(inputs: Documents_Block_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heading 1`)
};

export const documents_block_heading2 = /** @type {(inputs: Documents_Block_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heading 2`)
};

export const documents_block_heading3 = /** @type {(inputs: Documents_Block_Heading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heading 3`)
};

export const documents_block_insert = /** @type {(inputs: Documents_Block_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert a block`)
};

export const documents_block_lift_out = /** @type {(inputs: Documents_Block_Lift_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move out of the quote`)
};

export const documents_block_menu = /** @type {(inputs: Documents_Block_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block actions`)
};

export const documents_block_menu_section_block = /** @type {(inputs: Documents_Block_Menu_Section_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This block`)
};

export const documents_block_menu_section_type = /** @type {(inputs: Documents_Block_Menu_Section_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn into`)
};

export const documents_block_mermaid = /** @type {(inputs: Documents_Block_MermaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diagram (mermaid)`)
};

export const documents_block_numbered_list = /** @type {(inputs: Documents_Block_Numbered_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numbered list`)
};

export const documents_block_paragraph = /** @type {(inputs: Documents_Block_ParagraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

export const documents_block_quote = /** @type {(inputs: Documents_Block_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quote`)
};

export const documents_block_table = /** @type {(inputs: Documents_Block_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table`)
};

export const documents_block_task_list = /** @type {(inputs: Documents_Block_Task_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task list`)
};

export const documents_block_toggle = /** @type {(inputs: Documents_Block_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle`)
};

export const documents_block_unwrap_list = /** @type {(inputs: Documents_Block_Unwrap_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the list`)
};

export const documents_block_unwrap_quote = /** @type {(inputs: Documents_Block_Unwrap_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove the quote`)
};

export const documents_body = /** @type {(inputs: Documents_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body`)
};

export const documents_body_placeholder = /** @type {(inputs: Documents_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start writing, or type “/” for blocks`)
};

export const documents_close = /** @type {(inputs: Documents_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const documents_col_created = /** @type {(inputs: Documents_Col_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

export const documents_col_name = /** @type {(inputs: Documents_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const documents_col_updated = /** @type {(inputs: Documents_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updated`)
};

export const documents_copied_to_own = /** @type {(inputs: Documents_Copied_To_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to your documents`)
};

export const documents_copy = /** @type {(inputs: Documents_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a copy`)
};

export const documents_copy_failed = /** @type {(inputs: Documents_Copy_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not copy “${i?.title}”`)
};

export const documents_copy_to_own = /** @type {(inputs: Documents_Copy_To_OwnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy to my documents`)
};

export const documents_create = /** @type {(inputs: Documents_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a document`)
};

export const documents_create_failed = /** @type {(inputs: Documents_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not create the document`)
};

export const documents_delete = /** @type {(inputs: Documents_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const documents_delete_body = /** @type {(inputs: Documents_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its text and history go with it. This cannot be undone.`)
};

export const documents_delete_failed = /** @type {(inputs: Documents_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete “${i?.title}”`)
};

export const documents_delete_many_body = /** @type {(inputs: Documents_Delete_Many_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The text and history of ${i?.names} go with them. This cannot be undone.`)
};

export const documents_delete_many_title = /** @type {(inputs: Documents_Delete_Many_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.count} documents`)
};

export const documents_delete_title = /** @type {(inputs: Documents_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete “${i?.title}”`)
};

export const documents_empty = /** @type {(inputs: Documents_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents yet.`)
};

export const documents_empty_archived = /** @type {(inputs: Documents_Empty_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No archived documents.`)
};

export const documents_history = /** @type {(inputs: Documents_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

export const documents_history_actor_via = /** @type {(inputs: Documents_History_Actor_ViaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (${i?.connection})`)
};

export const documents_history_change_count = /** @type {(inputs: Documents_History_Change_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changed places: ${i?.count}`)
};

export const documents_history_changes = /** @type {(inputs: Documents_History_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes`)
};

export const documents_history_empty = /** @type {(inputs: Documents_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No history yet.`)
};

export const documents_history_failed = /** @type {(inputs: Documents_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the history`)
};

export const documents_history_is_latest = /** @type {(inputs: Documents_History_Is_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the latest version`)
};

export const documents_history_latest = /** @type {(inputs: Documents_History_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`latest`)
};

export const documents_history_no_body = /** @type {(inputs: Documents_History_No_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No text`)
};

export const documents_history_no_changes = /** @type {(inputs: Documents_History_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes from the previous version`)
};

export const documents_history_restored = /** @type {(inputs: Documents_History_RestoredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`restored`)
};

export const documents_history_saves = /** @type {(inputs: Documents_History_SavesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} saves`)
};

export const documents_history_system = /** @type {(inputs: Documents_History_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recorded automatically`)
};

export const documents_history_unchanged = /** @type {(inputs: Documents_History_UnchangedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unchanged lines`)
};

export const documents_history_versions = /** @type {(inputs: Documents_History_VersionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versions`)
};

export const documents_index_add = /** @type {(inputs: Documents_Index_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a document`)
};

export const documents_index_add_existing = /** @type {(inputs: Documents_Index_Add_ExistingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a document you made…`)
};

export const documents_index_add_failed = /** @type {(inputs: Documents_Index_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not add “${i?.title}”`)
};

export const documents_index_add_new = /** @type {(inputs: Documents_Index_Add_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New document`)
};

export const documents_index_archived = /** @type {(inputs: Documents_Index_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This index is archived. It can be read but not rearranged.`)
};

export const documents_index_button = /** @type {(inputs: Documents_Index_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index`)
};

export const documents_index_create_failed = /** @type {(inputs: Documents_Index_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not make the index`)
};

export const documents_index_create_with = /** @type {(inputs: Documents_Index_Create_WithInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a new index with it`)
};

export const documents_index_default_title = /** @type {(inputs: Documents_Index_Default_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Index of ${i?.title}`)
};

export const documents_index_delete_body = /** @type {(inputs: Documents_Index_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its order of documents goes with it; the documents in it stay. This cannot be undone.`)
};

export const documents_index_detach = /** @type {(inputs: Documents_Index_DetachInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take out of this index`)
};

export const documents_index_detach_failed = /** @type {(inputs: Documents_Index_Detach_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not take out “${i?.title}”`)
};

export const documents_index_empty = /** @type {(inputs: Documents_Index_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No documents in it yet`)
};

export const documents_index_existing_under = /** @type {(inputs: Documents_Index_Existing_UnderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a document you made under it…`)
};

export const documents_index_fold = /** @type {(inputs: Documents_Index_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fold the documents under it`)
};

export const documents_index_in = /** @type {(inputs: Documents_Index_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In these indexes`)
};

export const documents_index_in_none = /** @type {(inputs: Documents_Index_In_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not in any index yet`)
};

export const documents_index_indent = /** @type {(inputs: Documents_Index_IndentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Down one level (under the one above)`)
};

export const documents_index_load_failed = /** @type {(inputs: Documents_Index_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the index`)
};

export const documents_index_menu = /** @type {(inputs: Documents_Index_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index actions`)
};

export const documents_index_move_down = /** @type {(inputs: Documents_Index_Move_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move down`)
};

export const documents_index_move_failed = /** @type {(inputs: Documents_Index_Move_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not move “${i?.title}”`)
};

export const documents_index_move_up = /** @type {(inputs: Documents_Index_Move_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move up`)
};

export const documents_index_new_hint = /** @type {(inputs: Documents_Index_New_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write a name and press Enter. Documents go in after it is made.`)
};

export const documents_index_new_under = /** @type {(inputs: Documents_Index_New_UnderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New document under it`)
};

export const documents_index_open = /** @type {(inputs: Documents_Index_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const documents_index_outdent = /** @type {(inputs: Documents_Index_OutdentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up one level`)
};

export const documents_index_pick = /** @type {(inputs: Documents_Index_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a document you made`)
};

export const documents_index_pick_none = /** @type {(inputs: Documents_Index_Pick_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No document to add`)
};

export const documents_index_pick_search = /** @type {(inputs: Documents_Index_Pick_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find by title or text`)
};

export const documents_index_put_failed = /** @type {(inputs: Documents_Index_Put_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not put it in “${i?.title}”`)
};

export const documents_index_put_in = /** @type {(inputs: Documents_Index_Put_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put in an index`)
};

export const documents_index_remove_from = /** @type {(inputs: Documents_Index_Remove_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Take out of “${i?.title}”`)
};

export const documents_index_title = /** @type {(inputs: Documents_Index_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name of the index`)
};

export const documents_index_title_placeholder = /** @type {(inputs: Documents_Index_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const documents_index_unfold = /** @type {(inputs: Documents_Index_UnfoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the documents under it`)
};

export const documents_kind_html = /** @type {(inputs: Documents_Kind_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HTML document`)
};

export const documents_kind_index = /** @type {(inputs: Documents_Kind_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index`)
};

export const documents_kind_markdown = /** @type {(inputs: Documents_Kind_MarkdownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown document`)
};

export const documents_kind_slide = /** @type {(inputs: Documents_Kind_SlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slides`)
};

export const documents_link_suggest = /** @type {(inputs: Documents_Link_SuggestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents to link`)
};

export const documents_list_failed = /** @type {(inputs: Documents_List_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the documents`)
};

export const documents_load_failed = /** @type {(inputs: Documents_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load the document`)
};

export const documents_menu = /** @type {(inputs: Documents_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document menu`)
};

export const documents_mermaid_default_payload = /** @type {(inputs: Documents_Mermaid_Default_PayloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`flowchart TD
  A[Start] --> B[End]`)
};

export const documents_missing = /** @type {(inputs: Documents_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document cannot be found. It was deleted, or the URL is wrong.`)
};

export const documents_more = /** @type {(inputs: Documents_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

export const documents_nav = /** @type {(inputs: Documents_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

export const documents_new = /** @type {(inputs: Documents_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New document`)
};

export const documents_new_document = /** @type {(inputs: Documents_New_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document`)
};

export const documents_new_index = /** @type {(inputs: Documents_New_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New index`)
};

export const documents_new_index_item = /** @type {(inputs: Documents_New_Index_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index`)
};

export const documents_new_menu = /** @type {(inputs: Documents_New_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

export const documents_offline = /** @type {(inputs: Documents_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline. What you write is sent when the connection is back.`)
};

export const documents_outline = /** @type {(inputs: Documents_OutlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outline`)
};

export const documents_outline_headings = /** @type {(inputs: Documents_Outline_HeadingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headings`)
};

export const documents_read_only_archived = /** @type {(inputs: Documents_Read_Only_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document is archived. Unarchive it to write.`)
};

export const documents_read_only_newer = /** @type {(inputs: Documents_Read_Only_NewerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written by a newer version of the app, so it is read only. Update the app to write.`)
};

export const documents_read_only_not_writable = /** @type {(inputs: Documents_Read_Only_Not_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may read this document but not change it.`)
};

export const documents_reload = /** @type {(inputs: Documents_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

export const documents_reload_needed = /** @type {(inputs: Documents_Reload_NeededInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app was updated. Reload to keep writing.`)
};

export const documents_rename_failed = /** @type {(inputs: Documents_Rename_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change the title`)
};

export const documents_restore = /** @type {(inputs: Documents_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore this version`)
};

export const documents_restore_body = /** @type {(inputs: Documents_Restore_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The text of “${i?.title}” becomes this version. The current text stays in the history, so you can go back to it.`)
};

export const documents_restore_failed = /** @type {(inputs: Documents_Restore_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not restore`)
};

export const documents_restore_title = /** @type {(inputs: Documents_Restore_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Restore the version of ${i?.time}`)
};

export const documents_row_menu = /** @type {(inputs: Documents_Row_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for “${i?.title}”`)
};

export const documents_save_pdf = /** @type {(inputs: Documents_Save_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save as PDF`)
};

export const documents_selection_bold = /** @type {(inputs: Documents_Selection_BoldInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bold (${i?.key})`)
};

export const documents_selection_code = /** @type {(inputs: Documents_Selection_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Code (${i?.key})`)
};

export const documents_selection_edit_link = /** @type {(inputs: Documents_Selection_Edit_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit link`)
};

export const documents_selection_format = /** @type {(inputs: Documents_Selection_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatting`)
};

export const documents_selection_italic = /** @type {(inputs: Documents_Selection_ItalicInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Italic (${i?.key})`)
};

export const documents_selection_link = /** @type {(inputs: Documents_Selection_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

export const documents_selection_link_url = /** @type {(inputs: Documents_Selection_Link_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link URL`)
};

export const documents_selection_open_link = /** @type {(inputs: Documents_Selection_Open_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open (${i?.key}+click)`)
};

export const documents_selection_paste_url = /** @type {(inputs: Documents_Selection_Paste_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a URL`)
};

export const documents_selection_strike = /** @type {(inputs: Documents_Selection_StrikeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Strikethrough (${i?.key})`)
};

export const documents_selection_unlink = /** @type {(inputs: Documents_Selection_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove link`)
};

export const documents_show = /** @type {(inputs: Documents_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents to show`)
};

export const documents_show_active = /** @type {(inputs: Documents_Show_ActiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In use`)
};

export const documents_show_archived = /** @type {(inputs: Documents_Show_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archived`)
};

export const documents_slide_next = /** @type {(inputs: Documents_Slide_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next slide`)
};

export const documents_slide_previous = /** @type {(inputs: Documents_Slide_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous slide`)
};

export const documents_source = /** @type {(inputs: Documents_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

export const documents_source_close = /** @type {(inputs: Documents_Source_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the view`)
};

export const documents_source_conflict = /** @type {(inputs: Documents_Source_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The text changed elsewhere, so the current text was loaded. Apply your change again and save.`)
};

export const documents_source_edit = /** @type {(inputs: Documents_Source_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit source`)
};

export const documents_source_query = /** @type {(inputs: Documents_Source_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Query when shown`)
};

export const documents_source_query_failed = /** @type {(inputs: Documents_Source_Query_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save the query`)
};

export const documents_source_save = /** @type {(inputs: Documents_Source_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

export const documents_source_save_failed = /** @type {(inputs: Documents_Source_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save`)
};

export const documents_source_saved = /** @type {(inputs: Documents_Source_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved`)
};

export const documents_suggest_empty = /** @type {(inputs: Documents_Suggest_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matches`)
};

export const documents_title = /** @type {(inputs: Documents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const documents_title_placeholder = /** @type {(inputs: Documents_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const documents_unarchive = /** @type {(inputs: Documents_UnarchiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unarchive`)
};

export const documents_unarchive_failed = /** @type {(inputs: Documents_Unarchive_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not unarchive “${i?.title}”`)
};

export const documents_untitled = /** @type {(inputs: Documents_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled`)
};

export const editor_diff_block_count = /** @type {(inputs: Editor_Diff_Block_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Block count differs (live ${i?.live} / candidate ${i?.candidate})`)
};

export const editor_excerpt_callout = /** @type {(inputs: Editor_Excerpt_CalloutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Callout)`)
};

export const editor_excerpt_code = /** @type {(inputs: Editor_Excerpt_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Code)`)
};

export const editor_excerpt_empty = /** @type {(inputs: Editor_Excerpt_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Empty block)`)
};

export const editor_excerpt_html = /** @type {(inputs: Editor_Excerpt_HtmlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(HTML)`)
};

export const editor_excerpt_mermaid = /** @type {(inputs: Editor_Excerpt_MermaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(mermaid)`)
};

export const editor_excerpt_rule = /** @type {(inputs: Editor_Excerpt_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Divider)`)
};

export const editor_excerpt_table = /** @type {(inputs: Editor_Excerpt_TableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(Table)`)
};

export const editor_shape_attr_differs = /** @type {(inputs: Editor_Shape_Attr_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} differs`)
};

export const editor_shape_block_count_differs = /** @type {(inputs: Editor_Shape_Block_Count_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Block count differs (${i?.from} → ${i?.to})`)
};

export const editor_shape_child_count_differs = /** @type {(inputs: Editor_Shape_Child_Count_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Child block count differs (${i?.from} → ${i?.to})`)
};

export const editor_shape_type_differs = /** @type {(inputs: Editor_Shape_Type_DiffersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type differs (${i?.from} → ${i?.to})`)
};

export const editor_table_option_fix_range = /** @type {(inputs: Editor_Table_Option_Fix_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} must be 0–2`)
};

export const editor_table_option_shape = /** @type {(inputs: Editor_Table_Option_ShapeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The option line has the wrong format`)
};

export const editor_table_option_twice = /** @type {(inputs: Editor_Table_Option_TwiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.key} appears twice`)
};

export const editor_table_option_unknown_key = /** @type {(inputs: Editor_Table_Option_Unknown_KeyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unknown key ${i?.key}`)
};

export const editor_table_option_widths = /** @type {(inputs: Editor_Table_Option_WidthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`widths must be comma-separated positive numbers`)
};

export const editor_toggle_body_placeholder = /** @type {(inputs: Editor_Toggle_Body_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content`)
};

export const editor_toggle_summary_placeholder = /** @type {(inputs: Editor_Toggle_Summary_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle`)
};

export const inbox_answered_by_parent = /** @type {(inputs: Inbox_Answered_By_ParentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} answered for you`)
};

export const inbox_case = /** @type {(inputs: Inbox_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow to a Case`)
};

export const inbox_case_all = /** @type {(inputs: Inbox_Case_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Cases`)
};

export const inbox_chat = /** @type {(inputs: Inbox_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow to a chat`)
};

export const inbox_chat_all = /** @type {(inputs: Inbox_Chat_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All chats`)
};

export const inbox_done = /** @type {(inputs: Inbox_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settled`)
};

export const inbox_done_by_agent = /** @type {(inputs: Inbox_Done_By_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done by the agent`)
};

export const inbox_done_empty = /** @type {(inputs: Inbox_Done_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing settled yet`)
};

export const inbox_dot = /** @type {(inputs: Inbox_DotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something is waiting for you`)
};

export const inbox_from = /** @type {(inputs: Inbox_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`from ${i?.name}`)
};

export const inbox_go = /** @type {(inputs: Inbox_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Inbox`)
};

export const inbox_kind_dm = /** @type {(inputs: Inbox_Kind_DmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const inbox_kind_mention = /** @type {(inputs: Inbox_Kind_MentionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mention`)
};

export const inbox_kind_question = /** @type {(inputs: Inbox_Kind_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question`)
};

export const inbox_kind_reply = /** @type {(inputs: Inbox_Kind_ReplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply`)
};

export const inbox_load_failed = /** @type {(inputs: Inbox_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not read the Inbox`)
};

export const inbox_narrow = /** @type {(inputs: Inbox_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow the Inbox`)
};

export const inbox_narrow_placeholder = /** @type {(inputs: Inbox_Narrow_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search titles and answers`)
};

export const inbox_nav = /** @type {(inputs: Inbox_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox`)
};

export const inbox_no_match = /** @type {(inputs: Inbox_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing matches`)
};

export const inbox_now = /** @type {(inputs: Inbox_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your move`)
};

export const inbox_now_empty = /** @type {(inputs: Inbox_Now_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is waiting for you`)
};

export const inbox_unread = /** @type {(inputs: Inbox_UnreadInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} unread`)
};

export const inbox_withdrawn = /** @type {(inputs: Inbox_WithdrawnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Withdrawn`)
};

export const inbox_workspace_unreachable = /** @type {(inputs: Inbox_Workspace_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Workspace's direct messages and mentions are as last read`)
};

export const inbox_workspace_unreachable_empty = /** @type {(inputs: Inbox_Workspace_Unreachable_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Workspace's direct messages and mentions cannot be read`)
};

export const inbox_workspace_unreachable_why = /** @type {(inputs: Inbox_Workspace_Unreachable_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not be read: the Cloud is not connected. They show once it is`)
};

export const labels_color_custom = /** @type {(inputs: Labels_Color_CustomInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Custom color of "${i?.name}"`)
};

export const labels_color_failed = /** @type {(inputs: Labels_Color_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not change the color of "${i?.name}"`)
};

export const labels_color_of = /** @type {(inputs: Labels_Color_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Color of "${i?.name}"`)
};

export const labels_create_failed = /** @type {(inputs: Labels_Create_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not create the label "${i?.name}"`)
};

export const labels_create_named = /** @type {(inputs: Labels_Create_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Create the label "${i?.name}"`)
};

export const labels_delete = /** @type {(inputs: Labels_DeleteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.name}"`)
};

export const labels_delete_body = /** @type {(inputs: Labels_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It comes off the Cases that carry it.`)
};

export const labels_delete_failed = /** @type {(inputs: Labels_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete the label "${i?.name}"`)
};

export const labels_delete_title = /** @type {(inputs: Labels_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete the label "${i?.name}"?`)
};

export const labels_move_down = /** @type {(inputs: Labels_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move "${i?.name}" down`)
};

export const labels_move_failed = /** @type {(inputs: Labels_Move_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reorder the labels`)
};

export const labels_move_up = /** @type {(inputs: Labels_Move_UpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move "${i?.name}" up`)
};

export const labels_name = /** @type {(inputs: Labels_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label name`)
};

export const labels_new = /** @type {(inputs: Labels_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New label`)
};

export const labels_pick_empty = /** @type {(inputs: Labels_Pick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No labels yet. Type a name to create one`)
};

export const labels_pick_placeholder = /** @type {(inputs: Labels_Pick_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a label / a new label's name`)
};

export const labels_rename_failed = /** @type {(inputs: Labels_Rename_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not rename the label "${i?.name}"`)
};

export const labels_settings_description = /** @type {(inputs: Labels_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels you put on Cases: their names, colors and order.`)
};

export const labels_title = /** @type {(inputs: Labels_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels`)
};

export const local_agent_diagram = /** @type {(inputs: Local_Agent_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices that can send instructions to this PC's Agent`)
};

export const local_agent_diagram_browser = /** @type {(inputs: Local_Agent_Diagram_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser`)
};

export const local_agent_diagram_carrier = /** @type {(inputs: Local_Agent_Diagram_CarrierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud / Vault`)
};

export const local_agent_diagram_carrier_note = /** @type {(inputs: Local_Agent_Diagram_Carrier_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only delivers them`)
};

export const local_agent_diagram_devices = /** @type {(inputs: Local_Agent_Diagram_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phones, other PCs`)
};

export const local_agent_diagram_in_list = /** @type {(inputs: Local_Agent_Diagram_In_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device list`)
};

export const local_agent_diagram_refused = /** @type {(inputs: Local_Agent_Diagram_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not allowed`)
};

export const local_agent_diagram_signed = /** @type {(inputs: Local_Agent_Diagram_SignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed`)
};

export const local_agent_diagram_this_app = /** @type {(inputs: Local_Agent_Diagram_This_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The app on this PC`)
};

export const local_agent_help_browser = /** @type {(inputs: Local_Agent_Help_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browsers and devices not in your device list can't use it, even when on.`)
};

export const local_agent_help_signed = /** @type {(inputs: Local_Agent_Help_SignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions are signed on the device that sends them, and the Agent verifies them. Cloud and the Vault can't change them.`)
};

export const local_agent_help_title = /** @type {(inputs: Local_Agent_Help_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use from other devices`)
};

export const local_agent_others = /** @type {(inputs: Local_Agent_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow use from other devices`)
};

export const local_agent_others_note = /** @type {(inputs: Local_Agent_Others_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It can also be used from phones and other PCs.`)
};

export const local_agent_others_off_note = /** @type {(inputs: Local_Agent_Others_Off_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When off, it can be used from the app on this PC only.`)
};

export const local_agent_others_vault_off_note = /** @type {(inputs: Local_Agent_Others_Vault_Off_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`When off, it can be used from the app on ${i?.name} only.`)
};

export const local_agent_use = /** @type {(inputs: Local_Agent_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use this PC's Agent`)
};

export const local_agent_use_note = /** @type {(inputs: Local_Agent_Use_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When off, the Agent does not run on this PC.`)
};

export const local_backup = /** @type {(inputs: Local_BackupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backup`)
};

export const local_backup_choose = /** @type {(inputs: Local_Backup_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose folder…`)
};

export const local_backup_default = /** @type {(inputs: Local_Backup_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default (inside the data folder)`)
};

export const local_backup_description = /** @type {(inputs: Local_Backup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Backs up the database and files when the app quits and every 3 hours. If the database cannot be opened, it is restored from here.`)
};

export const local_backup_error_failed = /** @type {(inputs: Local_Backup_Error_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change the location.`)
};

export const local_backup_error_inside_data = /** @type {(inputs: Local_Backup_Error_Inside_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The data folder itself, and the database and files inside it, cannot be chosen.`)
};

export const local_backup_error_not_absolute = /** @type {(inputs: Local_Backup_Error_Not_AbsoluteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the folder's full path.`)
};

export const local_backup_error_not_writable = /** @type {(inputs: Local_Backup_Error_Not_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This folder cannot be written to.`)
};

export const local_backup_failed = /** @type {(inputs: Local_Backup_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not read the backup settings.`)
};

export const local_backup_folder = /** @type {(inputs: Local_Backup_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Location`)
};

export const local_backup_folder_note = /** @type {(inputs: Local_Backup_Folder_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a folder on an external drive or NAS to keep the backup even if this PC or its disk fails. Changing the location does not delete the backup in the previous one.`)
};

export const local_backup_last = /** @type {(inputs: Local_Backup_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last backup`)
};

export const local_backup_missing = /** @type {(inputs: Local_Backup_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This folder cannot be found, so backups go inside the data folder for now. Once the drive is connected, the next backup goes here again.`)
};

export const local_backup_none = /** @type {(inputs: Local_Backup_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None yet`)
};

export const local_backup_not_writable = /** @type {(inputs: Local_Backup_Not_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This folder cannot be written to, so backups go inside the data folder for now.`)
};

export const local_backup_path = /** @type {(inputs: Local_Backup_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder path`)
};

export const local_backup_reset = /** @type {(inputs: Local_Backup_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use default`)
};

export const local_backup_use = /** @type {(inputs: Local_Backup_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use`)
};

export const local_cloud = /** @type {(inputs: Local_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const local_cloud_account = /** @type {(inputs: Local_Cloud_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

export const local_cloud_account_settings = /** @type {(inputs: Local_Cloud_Account_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud account`)
};

export const local_cloud_account_settings_description = /** @type {(inputs: Local_Cloud_Account_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens your cloud account's settings: security, passkeys, connected apps.`)
};

export const local_cloud_again_done = /** @type {(inputs: Local_Cloud_Again_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in again.`)
};

export const local_cloud_agent_failed = /** @type {(inputs: Local_Cloud_Agent_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not register this PC in Cloud. Turn it off, then on again.`)
};

export const local_cloud_agent_removed = /** @type {(inputs: Local_Cloud_Agent_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC was removed in Cloud. To use it again, turn it off and then on.`)
};

export const local_cloud_code_note = /** @type {(inputs: Local_Cloud_Code_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check that the page you opened in the browser shows the same code, then link. If the page asks for a code, enter this one.`)
};

export const local_cloud_denied = /** @type {(inputs: Local_Cloud_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denied.`)
};

export const local_cloud_description = /** @type {(inputs: Local_Cloud_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link this PC to your trameria Cloud account. Until you sign in, this PC does not talk to the Cloud.`)
};

export const local_cloud_device = /** @type {(inputs: Local_Cloud_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC's sign-in`)
};

export const local_cloud_device_done = /** @type {(inputs: Local_Cloud_Device_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in.`)
};

export const local_cloud_device_hub_not_tied = /** @type {(inputs: Local_Cloud_Device_Hub_Not_TiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link the Vault to a Cloud account first.`)
};

export const local_cloud_device_hub_unreachable = /** @type {(inputs: Local_Cloud_Device_Hub_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Vault is out of reach, so its account cannot be checked. Sign in once the Vault is connected.`)
};

export const local_cloud_device_in = /** @type {(inputs: Local_Cloud_Device_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Signed in as ${i?.name}. The token is kept by this PC alone and never given to the Vault.`)
};

export const local_cloud_device_mismatch = /** @type {(inputs: Local_Cloud_Device_MismatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The Vault is linked to ${i?.hub}, but this PC is signed in as ${i?.mine}. Sign out, then sign in as ${i?.hub}.`)
};

export const local_cloud_device_needs_hub = /** @type {(inputs: Local_Cloud_Device_Needs_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once the Vault is linked, this PC can sign in as the same account.`)
};

export const local_cloud_device_none = /** @type {(inputs: Local_Cloud_Device_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not signed in. Signed in, this PC reaches the Cloud with a token of its own, even while the Vault is stopped.`)
};

export const local_cloud_device_other = /** @type {(inputs: Local_Cloud_Device_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You cannot sign in as ${i?.account}. The Vault is linked to ${i?.tied}.`)
};

export const local_cloud_expired = /** @type {(inputs: Local_Cloud_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code expired. Sign in again.`)
};

export const local_cloud_frame = /** @type {(inputs: Local_Cloud_FrameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud page`)
};

export const local_cloud_frame_signed_out_body = /** @type {(inputs: Local_Cloud_Frame_Signed_Out_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in again under Cloud in the app's settings. You sign in in your browser.`)
};

export const local_cloud_from_login = /** @type {(inputs: Local_Cloud_From_LoginInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Signed in automatically when this PC was added to your device list on ${i?.from}.`)
};

export const local_cloud_hub_away = /** @type {(inputs: Local_Cloud_Hub_AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Vault is out of reach. This PC's sign-in works as it is.`)
};

export const local_cloud_hub_row = /** @type {(inputs: Local_Cloud_Hub_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault (${i?.main})'s link`)
};

export const local_cloud_hub_token = /** @type {(inputs: Local_Cloud_Hub_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started from this PC, the token is still kept by the Vault alone.`)
};

export const local_cloud_linked = /** @type {(inputs: Local_Cloud_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot sign in here while this PC uses a Vault.`)
};

export const local_cloud_login = /** @type {(inputs: Local_Cloud_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in`)
};

export const local_cloud_login_again = /** @type {(inputs: Local_Cloud_Login_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in again`)
};

export const local_cloud_logout = /** @type {(inputs: Local_Cloud_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

export const local_cloud_logout_body = /** @type {(inputs: Local_Cloud_Logout_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC's token goes back to the Cloud and is removed here. The Vault's link and the data stay as they are.`)
};

export const local_cloud_logout_failed = /** @type {(inputs: Local_Cloud_Logout_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not sign out`)
};

export const local_cloud_logout_title = /** @type {(inputs: Local_Cloud_Logout_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign out of ${i?.name}?`)
};

export const local_cloud_none = /** @type {(inputs: Local_Cloud_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not linked`)
};

export const local_cloud_open = /** @type {(inputs: Local_Cloud_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in browser`)
};

export const local_cloud_other = /** @type {(inputs: Local_Cloud_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You cannot sign in as ${i?.account}. This PC is linked to ${i?.tied}.`)
};

export const local_cloud_restarting = /** @type {(inputs: Local_Cloud_RestartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked. trameria is starting again…`)
};

export const local_cloud_retry = /** @type {(inputs: Local_Cloud_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

export const local_cloud_signed_out_body = /** @type {(inputs: Local_Cloud_Signed_Out_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your personal data is in the cloud. Sign in again under Cloud in the app's settings to see it here.`)
};

export const local_cloud_signed_out_open = /** @type {(inputs: Local_Cloud_Signed_Out_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open app settings`)
};

export const local_cloud_signed_out_title = /** @type {(inputs: Local_Cloud_Signed_Out_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed out of the cloud`)
};

export const local_cloud_tied = /** @type {(inputs: Local_Cloud_TiedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linked to ${i?.name}. Until you unlink it, it cannot be linked to another account.`)
};

export const local_cloud_unlink = /** @type {(inputs: Local_Cloud_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink`)
};

export const local_cloud_unlink_body = /** @type {(inputs: Local_Cloud_Unlink_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC stops talking to the Cloud. Its data stays as it is. After unlinking, it can be linked to another account.`)
};

export const local_cloud_unlink_failed = /** @type {(inputs: Local_Cloud_Unlink_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not unlink`)
};

export const local_cloud_unlink_title = /** @type {(inputs: Local_Cloud_Unlink_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unlink from ${i?.name}?`)
};

export const local_cloud_unreachable = /** @type {(inputs: Local_Cloud_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not connect to Cloud`)
};

export const local_cloud_unreached_body = /** @type {(inputs: Local_Cloud_Unreached_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the network or the cloud, then try again. Personal still works as it is.`)
};

export const local_cloud_unreached_title = /** @type {(inputs: Local_Cloud_Unreached_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't connect to the cloud`)
};

export const local_cloud_waiting = /** @type {(inputs: Local_Cloud_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for you to link in the browser…`)
};

export const local_dms = /** @type {(inputs: Local_DmsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DM`)
};

export const local_dms_unread = /** @type {(inputs: Local_Dms_UnreadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unread`)
};

export const local_headless_backup_dir = /** @type {(inputs: Local_Headless_Backup_DirInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Backup location: ${i?.dir}`)
};

export const local_headless_backup_dir_refused = /** @type {(inputs: Local_Headless_Backup_Dir_RefusedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`--backup-dir ${i?.dir} cannot be used: ${i?.reason}`)
};

export const local_headless_connect_to = /** @type {(inputs: Local_Headless_Connect_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Other devices connect to: ${i?.addresses}`)
};

export const local_headless_could_not_start = /** @type {(inputs: Local_Headless_Could_Not_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} could not start: ${i?.error}`)
};

export const local_headless_linked = /** @type {(inputs: Local_Headless_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} in ${i?.dir} uses a Vault, so it cannot run as one. Leave it in the settings ("Vault"), then start it again.`)
};

export const local_headless_login_again = /** @type {(inputs: Local_Headless_Login_AgainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Signed in again as ${i?.account}.`)
};

export const local_headless_login_bound = /** @type {(inputs: Local_Headless_Login_BoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linked to ${i?.account}. ${i?.app} is starting again.`)
};

export const local_headless_login_denied = /** @type {(inputs: Local_Headless_Login_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denied. Not linked.`)
};

export const local_headless_login_expired = /** @type {(inputs: Local_Headless_Login_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code expired. Run --headless --login again.`)
};

export const local_headless_login_failed = /** @type {(inputs: Local_Headless_Login_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not sign in to the Cloud: ${i?.error}`)
};

export const local_headless_login_linked = /** @type {(inputs: Local_Headless_Login_LinkedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} in ${i?.dir} uses a Vault, so it cannot sign in to the Cloud.`)
};

export const local_headless_login_not_running = /** @type {(inputs: Local_Headless_Login_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} is not running on ${i?.dir}. Start it first (${i?.app} --headless, or the service), then run --headless --login again.`)
};

export const local_headless_login_open = /** @type {(inputs: Local_Headless_Login_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open ${i?.url} in a browser and enter the code ${i?.code} to link (works for ${i?.minutes} more minutes).`)
};

export const local_headless_login_other = /** @type {(inputs: Local_Headless_Login_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You cannot sign in as ${i?.account}. This Vault is linked to ${i?.tied}.`)
};

export const local_headless_login_waiting = /** @type {(inputs: Local_Headless_Login_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for you to link…`)
};

export const local_headless_others_not_running = /** @type {(inputs: Local_Headless_Others_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} is not running on ${i?.dir}. Start it first (${i?.app} --headless, or as a service), then run --headless --other-devices again.`)
};

export const local_headless_others_off = /** @type {(inputs: Local_Headless_Others_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC's Agent does not allow use from other devices.`)
};

export const local_headless_others_on = /** @type {(inputs: Local_Headless_Others_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC's Agent allows use from other devices.`)
};

export const local_headless_others_usage = /** @type {(inputs: Local_Headless_Others_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write on or off after --other-devices.`)
};

export const local_headless_pair_failed = /** @type {(inputs: Local_Headless_Pair_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No pairing code: ${i?.error}`)
};

export const local_headless_pair_no_pairing = /** @type {(inputs: Local_Headless_Pair_No_PairingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ${i?.app} running on ${i?.dir} makes no pairing codes this way; update it and start it again.`)
};

export const local_headless_pair_not_running = /** @type {(inputs: Local_Headless_Pair_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} is not running on ${i?.dir}. Start it first (${i?.app} --headless, or the service), then run --headless --pair again.`)
};

export const local_headless_pair_port_in_use = /** @type {(inputs: Local_Headless_Pair_Port_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Other devices cannot connect to the ${i?.app} running on ${i?.dir}: port ${i?.port} is in use by another program. Free it and start ${i?.app} again.`)
};

export const local_headless_pair_remote_off = /** @type {(inputs: Local_Headless_Pair_Remote_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connections from other devices are off in the ${i?.app} running on ${i?.dir}.`)
};

export const local_headless_pairing_code = /** @type {(inputs: Local_Headless_Pairing_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pairing code (works once, for ${i?.minutes} more minutes): ${i?.code}`)
};

export const local_headless_port = /** @type {(inputs: Local_Headless_PortInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`port ${i?.port}`)
};

export const local_headless_port_in_use = /** @type {(inputs: Local_Headless_Port_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Other devices cannot connect: port ${i?.port} is in use (${i?.error})`)
};

export const local_headless_restored = /** @type {(inputs: Local_Headless_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The database could not be opened, so it was restored from the backup taken at ${i?.time}. Changes after that time are lost.`)
};

export const local_headless_running = /** @type {(inputs: Local_Headless_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} is running without windows (data: ${i?.dir})`)
};

export const local_headless_unlink_done = /** @type {(inputs: Local_Headless_Unlink_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unlinked from ${i?.account}.`)
};

export const local_headless_unlink_none = /** @type {(inputs: Local_Headless_Unlink_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not linked.`)
};

export const local_headless_unlink_not_running = /** @type {(inputs: Local_Headless_Unlink_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} is not running on ${i?.dir}. Start it first (${i?.app} --headless, or the service), then run --headless --unlink again.`)
};

export const local_link_connected = /** @type {(inputs: Local_Link_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected.`)
};

export const local_link_connected_cloud = /** @type {(inputs: Local_Link_Connected_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected via Cloud.`)
};

export const local_link_connected_via = /** @type {(inputs: Local_Link_Connected_ViaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected over ${i?.where}.`)
};

export const local_link_connecting = /** @type {(inputs: Local_Link_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnecting.`)
};

export const local_link_hub_door = /** @type {(inputs: Local_Link_Hub_DoorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault (${i?.main}) accepts connections via Cloud`)
};

export const local_link_hub_door_away = /** @type {(inputs: Local_Link_Hub_Door_AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected to the Vault, so this can't be changed.`)
};

export const local_link_hub_door_not_tied = /** @type {(inputs: Local_Link_Hub_Door_Not_TiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available once the Vault is linked to Cloud.`)
};

export const local_link_hub_door_note = /** @type {(inputs: Local_Link_Hub_Door_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A setting of the Vault. When on, devices outside the network can connect to the Vault via Cloud.`)
};

export const local_link_hub_door_via_cloud = /** @type {(inputs: Local_Link_Hub_Door_Via_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't be changed while connected via Cloud.`)
};

export const local_link_invalid_code = /** @type {(inputs: Local_Link_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is not a pairing code.`)
};

export const local_link_is_hub = /** @type {(inputs: Local_Link_Is_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC is a Vault, so it cannot join one.`)
};

export const local_link_join = /** @type {(inputs: Local_Link_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join a Vault`)
};

export const local_link_join_button = /** @type {(inputs: Local_Link_Join_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join`)
};

export const local_link_join_note = /** @type {(inputs: Local_Link_Join_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the code from "Connect a device" in the settings of the PC to use as the Vault. While joined, this app uses the Vault's data; this PC's own data is kept as it is.`)
};

export const local_link_leave = /** @type {(inputs: Local_Link_LeaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave`)
};

export const local_link_leave_body = /** @type {(inputs: Local_Link_Leave_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC goes back to its own data. The Vault's data stays as it is.`)
};

export const local_link_leave_title = /** @type {(inputs: Local_Link_Leave_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stop using ${i?.main}?`)
};

export const local_link_main = /** @type {(inputs: Local_Link_MainInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Using ${i?.main}'s data`)
};

export const local_link_network_settings = /** @type {(inputs: Local_Link_Network_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Local Network settings`)
};

export const local_link_open_settings = /** @type {(inputs: Local_Link_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open settings`)
};

export const local_link_reconnecting = /** @type {(inputs: Local_Link_ReconnectingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reconnecting to ${i?.main}`)
};

export const local_link_reconnecting_not_listening = /** @type {(inputs: Local_Link_Reconnecting_Not_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnecting. The Vault does not accept connections via Cloud.`)
};

export const local_link_reconnecting_sign_in = /** @type {(inputs: Local_Link_Reconnecting_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconnecting. Sign in again from this PC under “Cloud”.`)
};

export const local_link_refused = /** @type {(inputs: Local_Link_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code did not work. Make a new one on the Vault.`)
};

export const local_link_removed = /** @type {(inputs: Local_Link_RemovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} removed this PC`)
};

export const local_link_removed_short = /** @type {(inputs: Local_Link_Removed_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Vault removed this PC. Leave, then join again.`)
};

export const local_link_routes = /** @type {(inputs: Local_Link_RoutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the Vault via Cloud outside the network`)
};

export const local_link_routes_cloud_home = /** @type {(inputs: Local_Link_Routes_Cloud_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not used now, because Personal data is in Cloud.`)
};

export const local_link_routes_no_sign_in = /** @type {(inputs: Local_Link_Routes_No_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available once this PC signs in under “Cloud”.`)
};

export const local_link_routes_note = /** @type {(inputs: Local_Link_Routes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the Vault's Personal data via Cloud even where you can't connect to the Vault. The connection stays encrypted.`)
};

export const local_link_screen_app_outdated = /** @type {(inputs: Local_Link_Screen_App_OutdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This PC's app is older than ${i?.main}'s, so this PC's own screen is shown. Update the app to get the same screen as ${i?.main}.`)
};

export const local_link_screen_hub_outdated = /** @type {(inputs: Local_Link_Screen_Hub_OutdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main}'s app is older, so this PC's own screen is shown.`)
};

export const local_link_unreachable = /** @type {(inputs: Local_Link_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach the Vault. Check that it accepts connections and that both PCs are on the same network or Tailscale.`)
};

export const local_link_unreachable_mac = /** @type {(inputs: Local_Link_Unreachable_MacInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If it is on the same network, also check that this app is allowed under Local Network in System Settings.`)
};

export const local_link_unreachable_now = /** @type {(inputs: Local_Link_Unreachable_NowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.main} is out of reach`)
};

export const local_link_write_failed = /** @type {(inputs: Local_Link_Write_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not saved: ${i?.main} is out of reach.`)
};

export const local_mcp = /** @type {(inputs: Local_McpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP clients`)
};

export const local_mcp_claude_code_note = /** @type {(inputs: Local_Mcp_Claude_Code_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run it in a terminal.`)
};

export const local_mcp_claude_desktop_note = /** @type {(inputs: Local_Mcp_Claude_Desktop_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add it to mcpServers in claude_desktop_config.json (Settings → Developer → Edit Config).`)
};

export const local_mcp_codex_note = /** @type {(inputs: Local_Mcp_Codex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add it to ~/.codex/config.toml.`)
};

export const local_mcp_copied = /** @type {(inputs: Local_Mcp_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

export const local_mcp_copy = /** @type {(inputs: Local_Mcp_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

export const local_mcp_copy_failed = /** @type {(inputs: Local_Mcp_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy`)
};

export const local_mcp_description = /** @type {(inputs: Local_Mcp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Let Claude Code, Codex and Claude Desktop read and write the Cases, People and documents on this PC. They connect only while this app is open.`)
};

export const local_mcp_load_failed = /** @type {(inputs: Local_Mcp_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load`)
};

export const local_mcp_retry = /** @type {(inputs: Local_Mcp_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try again`)
};

export const local_mcp_unavailable = /** @type {(inputs: Local_Mcp_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP clients cannot connect from here.`)
};

export const local_me_cancel = /** @type {(inputs: Local_Me_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const local_me_cancel_body = /** @type {(inputs: Local_Me_Cancel_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data goes back where it was and can be changed again.`)
};

export const local_me_cancel_title = /** @type {(inputs: Local_Me_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel moving personal data?`)
};

export const local_me_cancelled = /** @type {(inputs: Local_Me_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving personal data was cancelled`)
};

export const local_me_changes = /** @type {(inputs: Local_Me_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What changes`)
};

export const local_me_check_far_note = /** @type {(inputs: Local_Me_Check_Far_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places that cannot reach this Vault can no longer read or change it.`)
};

export const local_me_check_far_title = /** @type {(inputs: Local_Me_Check_Far_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outside apps' MCP and agents elsewhere`)
};

export const local_me_check_google_note = /** @type {(inputs: Local_Me_Check_Google_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect it again after the move.`)
};

export const local_me_check_google_title = /** @type {(inputs: Local_Me_Check_Google_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Calendar`)
};

export const local_me_check_hub_agents_note = /** @type {(inputs: Local_Me_Check_Hub_Agents_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It gets no Personal data until it reconnects to Cloud.`)
};

export const local_me_check_hub_agents_title = /** @type {(inputs: Local_Me_Check_Hub_Agents_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Vault's Agent`)
};

export const local_me_check_phone_note = /** @type {(inputs: Local_Me_Check_Phone_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications of personal data stop. The workspaces' still come.`)
};

export const local_me_check_phone_title = /** @type {(inputs: Local_Me_Check_Phone_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications on the phone`)
};

export const local_me_check_published_note = /** @type {(inputs: Local_Me_Check_Published_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing stops when it moves (it does not come back if you move back to the cloud).`)
};

export const local_me_check_published_title = /** @type {(inputs: Local_Me_Check_Published_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published personal documents`)
};

export const local_me_check_sandbox_note = /** @type {(inputs: Local_Me_Check_Sandbox_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox agents stop.`)
};

export const local_me_check_sandbox_title = /** @type {(inputs: Local_Me_Check_Sandbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud sandboxes`)
};

export const local_me_check_web_gets = /** @type {(inputs: Local_Me_Check_Web_GetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data can be opened there too.`)
};

export const local_me_check_web_loses = /** @type {(inputs: Local_Me_Check_Web_LosesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data can no longer be opened there. The workspaces work as before.`)
};

export const local_me_check_web_title = /** @type {(inputs: Local_Me_Check_Web_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The web and the phone app (PWA)`)
};

export const local_me_elsewhere_body = /** @type {(inputs: Local_Me_Elsewhere_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data moved to the cloud. This Vault keeps only a copy. Open it on the web or in a desktop connected to the cloud.`)
};

export const local_me_elsewhere_title = /** @type {(inputs: Local_Me_Elsewhere_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data lives in the cloud`)
};

export const local_me_estimate = /** @type {(inputs: Local_Me_EstimateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About how long: ${i?.length}`)
};

export const local_me_estimate_long = /** @type {(inputs: Local_Me_Estimate_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`over ten minutes`)
};

export const local_me_estimate_minute = /** @type {(inputs: Local_Me_Estimate_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`about a minute`)
};

export const local_me_estimate_minutes = /** @type {(inputs: Local_Me_Estimate_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a few minutes`)
};

export const local_me_estimate_seconds = /** @type {(inputs: Local_Me_Estimate_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a few seconds`)
};

export const local_me_failed = /** @type {(inputs: Local_Me_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stopped: ${i?.message}`)
};

export const local_me_failed_changed = /** @type {(inputs: Local_Me_Failed_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped because personal data changed while it moved (an agent's run ended, for example). Continue sends only what changed.`)
};

export const local_me_failed_limit = /** @type {(inputs: Local_Me_Failed_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped at the limit of switches. Continue a little later.`)
};

export const local_me_failed_unreachable = /** @type {(inputs: Local_Me_Failed_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stopped because the cloud or the file storage was out of reach. Continue once you are connected.`)
};

export const local_me_finished = /** @type {(inputs: Local_Me_FinishedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moved to ${i?.place} in ${i?.time}.`)
};

export const local_me_finished_merge = /** @type {(inputs: Local_Me_Finished_MergeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.what} to ${i?.place} in ${i?.time}.`)
};

export const local_me_finished_place_cloud = /** @type {(inputs: Local_Me_Finished_Place_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the cloud`)
};

export const local_me_finished_place_hub = /** @type {(inputs: Local_Me_Finished_Place_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this Vault`)
};

export const local_me_finished_what = /** @type {(inputs: Local_Me_Finished_WhatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ${i?.name}`)
};

export const local_me_finished_what_more = /** @type {(inputs: Local_Me_Finished_What_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ${i?.name} and more`)
};

export const local_me_item_created = /** @type {(inputs: Local_Me_Item_CreatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`made ${i?.date}`)
};

export const local_me_merge = /** @type {(inputs: Local_Me_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is added`)
};

export const local_me_merge_body = /** @type {(inputs: Local_Me_Merge_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The personal data in the cloud and on this Vault are added together. The side you choose holds it from then on; the other keeps the same as a copy for 30 days. While it is being combined, it can only be read.`)
};

export const local_me_merge_from_cloud = /** @type {(inputs: Local_Me_Merge_From_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only in the cloud`)
};

export const local_me_merge_from_hub = /** @type {(inputs: Local_Me_Merge_From_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only on this Vault`)
};

export const local_me_merge_kept = /** @type {(inputs: Local_Me_Merge_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What both already have stays as one.`)
};

export const local_me_merge_labels = /** @type {(inputs: Local_Me_Merge_LabelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labels with the same name become one`)
};

export const local_me_merge_none = /** @type {(inputs: Local_Me_Merge_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing`)
};

export const local_me_merge_persons = /** @type {(inputs: Local_Me_Merge_PersonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The same person becomes one`)
};

export const local_me_merge_persons_note = /** @type {(inputs: Local_Me_Merge_Persons_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People with the same Slack or email id, or the same trameria user`)
};

export const local_me_merge_to_cloud = /** @type {(inputs: Local_Me_Merge_To_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine in the cloud`)
};

export const local_me_merge_to_cloud_title = /** @type {(inputs: Local_Me_Merge_To_Cloud_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine your personal data and keep it in the cloud?`)
};

export const local_me_merge_to_hub = /** @type {(inputs: Local_Me_Merge_To_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine on the Vault`)
};

export const local_me_merge_to_hub_title = /** @type {(inputs: Local_Me_Merge_To_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine your personal data and keep it on this Vault?`)
};

export const local_me_move_body = /** @type {(inputs: Local_Me_Move_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`While it moves, it is read-only. Afterwards the side it left keeps a copy for 30 days (moving back sends only what differs).`)
};

export const local_me_moves = /** @type {(inputs: Local_Me_MovesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What moves`)
};

export const local_me_moving_digest = /** @type {(inputs: Local_Me_Moving_DigestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving personal data (finding what differs)…`)
};

export const local_me_moving_digest_of = /** @type {(inputs: Local_Me_Moving_Digest_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moving personal data (finding what differs, ${i?.done}/${i?.total})…`)
};

export const local_me_moving_files = /** @type {(inputs: Local_Me_Moving_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving personal data (sending files)…`)
};

export const local_me_moving_merge = /** @type {(inputs: Local_Me_Moving_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Putting personal data together (adding)…`)
};

export const local_me_moving_note = /** @type {(inputs: Local_Me_Moving_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data is moving. It cannot be changed until it is done.`)
};

export const local_me_moving_send = /** @type {(inputs: Local_Me_Moving_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving personal data (sending)…`)
};

export const local_me_moving_verify = /** @type {(inputs: Local_Me_Moving_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving personal data (checking)…`)
};

export const local_me_place = /** @type {(inputs: Local_Me_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where personal data lives`)
};

export const local_me_place_both_now = /** @type {(inputs: Local_Me_Place_Both_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both the cloud and this Vault hold personal data.`)
};

export const local_me_place_cloud = /** @type {(inputs: Local_Me_Place_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data lives in the cloud.`)
};

export const local_me_place_cloud_copy = /** @type {(inputs: Local_Me_Place_Cloud_CopyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Personal data lives in the cloud. This Vault keeps a copy until ${i?.date} (it cannot be read or changed).`)
};

export const local_me_place_cloud_only = /** @type {(inputs: Local_Me_Place_Cloud_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data lives in the cloud. Moved to this Vault, the web and the phone app show only the workspaces.`)
};

export const local_me_place_hub = /** @type {(inputs: Local_Me_Place_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data lives on this Vault. The workspaces live in the cloud.`)
};

export const local_me_place_other_hub = /** @type {(inputs: Local_Me_Place_Other_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data lives on another Vault.`)
};

export const local_me_place_unreachable = /** @type {(inputs: Local_Me_Place_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cloud is out of reach.`)
};

export const local_me_place_update = /** @type {(inputs: Local_Me_Place_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The cloud and this Vault run different versions. Update the Vault before moving.`)
};

export const local_me_queue_cancel = /** @type {(inputs: Local_Me_Queue_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop waiting`)
};

export const local_me_queued = /** @type {(inputs: Local_Me_QueuedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting in line (${i?.ahead} ahead, starts in about ${i?.minutes} min). It starts by itself when its turn comes.`)
};

export const local_me_queued_note = /** @type {(inputs: Local_Me_Queued_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data can be used as usual while it waits.`)
};

export const local_me_queued_soon = /** @type {(inputs: Local_Me_Queued_SoonInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting in line (${i?.ahead} ahead, starts soon). It starts by itself when its turn comes.`)
};

export const local_me_retry = /** @type {(inputs: Local_Me_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

export const local_me_side_cloud = /** @type {(inputs: Local_Me_Side_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const local_me_side_hub = /** @type {(inputs: Local_Me_Side_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

export const local_me_stopped = /** @type {(inputs: Local_Me_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moving personal data stopped half way. Continue to go on from where it was, or cancel to put it back.`)
};

export const local_me_time_minutes = /** @type {(inputs: Local_Me_Time_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min ${i?.seconds} s`)
};

export const local_me_time_seconds = /** @type {(inputs: Local_Me_Time_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

export const local_me_to_cloud = /** @type {(inputs: Local_Me_To_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to the cloud`)
};

export const local_me_to_cloud_title = /** @type {(inputs: Local_Me_To_Cloud_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move personal data to the cloud?`)
};

export const local_me_to_hub = /** @type {(inputs: Local_Me_To_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to this Vault`)
};

export const local_me_to_hub_title = /** @type {(inputs: Local_Me_To_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move personal data to this Vault?`)
};

export const local_me_untitled = /** @type {(inputs: Local_Me_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(untitled)`)
};

export const local_menubar = /** @type {(inputs: Local_MenubarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu bar`)
};

export const local_menubar_agent = /** @type {(inputs: Local_Menubar_AgentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent: ${i?.name}`)
};

export const local_menubar_agent_cloud_off = /** @type {(inputs: Local_Menubar_Agent_Cloud_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't reach Cloud`)
};

export const local_menubar_agent_cloud_on = /** @type {(inputs: Local_Menubar_Agent_Cloud_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taking work from Cloud`)
};

export const local_menubar_agent_hub_on = /** @type {(inputs: Local_Menubar_Agent_Hub_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Taking work from Vault (${i?.main})`)
};

export const local_menubar_agent_unused = /** @type {(inputs: Local_Menubar_Agent_UnusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`“Use this PC's Agent” is off`)
};

export const local_menubar_cloud_signed_in = /** @type {(inputs: Local_Menubar_Cloud_Signed_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in to Cloud`)
};

export const local_menubar_description = /** @type {(inputs: Local_Menubar_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The icon in the mac menu bar. Kept on this Mac.`)
};

export const local_menubar_hub_devices = /** @type {(inputs: Local_Menubar_Hub_DevicesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vault, waiting for devices · ${i?.count} connected`)
};

export const local_menubar_hub_listening = /** @type {(inputs: Local_Menubar_Hub_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault, waiting for devices (none connected)`)
};

export const local_menubar_hub_off = /** @type {(inputs: Local_Menubar_Hub_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Can't connect to Vault (${i?.main})`)
};

export const local_menubar_hub_on = /** @type {(inputs: Local_Menubar_Hub_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected to Vault (${i?.main})`)
};

export const local_menubar_hub_on_cloud = /** @type {(inputs: Local_Menubar_Hub_On_CloudInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected to Vault (${i?.main}) via Cloud`)
};

export const local_menubar_hub_on_where = /** @type {(inputs: Local_Menubar_Hub_On_WhereInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected to Vault (${i?.main}) · ${i?.where}`)
};

export const local_menubar_hub_port_in_use = /** @type {(inputs: Local_Menubar_Hub_Port_In_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Another program uses the Vault's port, so no device can connect`)
};

export const local_menubar_icon = /** @type {(inputs: Local_Menubar_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu bar icon`)
};

export const local_menubar_icon_logo = /** @type {(inputs: Local_Menubar_Icon_LogoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria logo`)
};

export const local_menubar_icon_note = /** @type {(inputs: Local_Menubar_Icon_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage limits shows how much of Claude Code's or Codex's 5-hour and weekly limits you have used, as horizontal bars.`)
};

export const local_menubar_icon_usage = /** @type {(inputs: Local_Menubar_Icon_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage limits`)
};

export const local_menubar_provider = /** @type {(inputs: Local_Menubar_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage limits of`)
};

export const local_menubar_provider_note = /** @type {(inputs: Local_Menubar_Provider_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whose usage limits the icon's bars show.`)
};

export const local_menubar_provider_note_unused = /** @type {(inputs: Local_Menubar_Provider_Note_UnusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whose usage limits the icon's bars show. A CLI this PC does not use cannot be chosen.`)
};

export const local_menubar_show = /** @type {(inputs: Local_Menubar_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show the icon in the menu bar`)
};

export const local_menubar_show_note = /** @type {(inputs: Local_Menubar_Show_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When off, the app shows in the Dock instead. It keeps running after you close the window (the Agent keeps working); click the Dock icon to open the window again, and press ⌘Q to quit.`)
};

export const local_notice_cloud_login = /** @type {(inputs: Local_Notice_Cloud_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in to Cloud`)
};

export const local_notice_cloud_login_body = /** @type {(inputs: Local_Notice_Cloud_Login_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This PC was added to your device list on ${i?.from}, so it signed in as ${i?.name} automatically. If you do not need it, sign out in Settings.`)
};

export const local_notice_failed = /** @type {(inputs: Local_Notice_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chat} stopped with an error`)
};

export const local_notice_failed_body = /** @type {(inputs: Local_Notice_Failed_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The reply could not be written.`)
};

export const local_notice_reply = /** @type {(inputs: Local_Notice_ReplyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chat} replied`)
};

export const local_notice_turn = /** @type {(inputs: Local_Notice_TurnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.chat} is waiting for you`)
};

export const local_open_in_new_window = /** @type {(inputs: Local_Open_In_New_WindowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in New Window`)
};

export const local_rail = /** @type {(inputs: Local_RailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspaces`)
};

export const local_rail_new = /** @type {(inputs: Local_Rail_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a workspace`)
};

export const local_release = /** @type {(inputs: Local_ReleaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to a workspace`)
};

export const local_release_action = /** @type {(inputs: Local_Release_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move`)
};

export const local_release_body = /** @type {(inputs: Local_Release_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The document becomes the workspace's, in the cloud. People who see the space can read it, and those who may write documents there can write it. It leaves this Vault's personal documents and cannot come back (make a copy first to keep one).`)
};

export const local_release_failed = /** @type {(inputs: Local_Release_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not move “${i?.title}”`)
};

export const local_release_no_space = /** @type {(inputs: Local_Release_No_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workspace has no space where you may write documents.`)
};

export const local_release_none = /** @type {(inputs: Local_Release_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no workspace to move it to.`)
};

export const local_release_space = /** @type {(inputs: Local_Release_SpaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Space`)
};

export const local_release_title = /** @type {(inputs: Local_Release_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move “${i?.title}” to a workspace`)
};

export const local_release_unavailable = /** @type {(inputs: Local_Release_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It can be moved only while your personal data is on this Vault and the cloud is in reach.`)
};

export const local_release_workspace = /** @type {(inputs: Local_Release_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

export const local_released = /** @type {(inputs: Local_ReleasedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moved “${i?.title}” to ${i?.workspace}`)
};

export const local_remote = /** @type {(inputs: Local_RemoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

export const local_remote_add = /** @type {(inputs: Local_Remote_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect a device`)
};

export const local_remote_add_note = /** @type {(inputs: Local_Remote_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In trameria on the device to connect, scan this QR or enter the code. It works once, for 10 minutes.`)
};

export const local_remote_cloud = /** @type {(inputs: Local_Remote_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Also accept connections via Cloud`)
};

export const local_remote_cloud_connecting = /** @type {(inputs: Local_Remote_Cloud_ConnectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to Cloud…`)
};

export const local_remote_cloud_needs_tie = /** @type {(inputs: Local_Remote_Cloud_Needs_TieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available once this PC is linked to Cloud.`)
};

export const local_remote_cloud_note = /** @type {(inputs: Local_Remote_Cloud_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices outside the network can connect to this Vault via Cloud. The connection stays encrypted, and Cloud cannot read it.`)
};

export const local_remote_cloud_open = /** @type {(inputs: Local_Remote_Cloud_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepting connections via Cloud.`)
};

export const local_remote_cloud_refused = /** @type {(inputs: Local_Remote_Cloud_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not connect to Cloud. Sign in again under “Cloud”.`)
};

export const local_remote_code = /** @type {(inputs: Local_Remote_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

export const local_remote_connected = /** @type {(inputs: Local_Remote_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

export const local_remote_connected_from = /** @type {(inputs: Local_Remote_Connected_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Connected · ${i?.where}`)
};

export const local_remote_description = /** @type {(inputs: Local_Remote_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect trameria on your other devices to this PC, to use the same data and Agent. Only paired devices can connect.`)
};

export const local_remote_devices = /** @type {(inputs: Local_Remote_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected devices`)
};

export const local_remote_devices_none = /** @type {(inputs: Local_Remote_Devices_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None yet.`)
};

export const local_remote_failed = /** @type {(inputs: Local_Remote_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load.`)
};

export const local_remote_linked = /** @type {(inputs: Local_Remote_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC uses a Vault, so it cannot be one.`)
};

export const local_remote_listen = /** @type {(inputs: Local_Remote_ListenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept connections from other devices`)
};

export const local_remote_listen_note = /** @type {(inputs: Local_Remote_Listen_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When on, this PC is the one other devices join (the Vault). It opens one port on this PC while on.`)
};

export const local_remote_port_in_use = /** @type {(inputs: Local_Remote_Port_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Port ${i?.port} is used by another app and cannot be opened.`)
};

export const local_remote_remove = /** @type {(inputs: Local_Remote_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const local_remote_remove_body = /** @type {(inputs: Local_Remote_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It can no longer connect to this PC. To use it again, pair it again.`)
};

export const local_remote_remove_title = /** @type {(inputs: Local_Remote_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name}?`)
};

export const local_remote_retry = /** @type {(inputs: Local_Remote_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

export const local_route_anywhere = /** @type {(inputs: Local_Route_AnywhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anywhere`)
};

export const local_route_client_cloud_home = /** @type {(inputs: Local_Route_Client_Cloud_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data is in Cloud, so this PC connects to Cloud directly. This setting is used while Personal data is on the Vault.`)
};

export const local_route_client_diagram = /** @type {(inputs: Local_Route_Client_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC's connection to the Vault`)
};

export const local_route_client_needs = /** @type {(inputs: Local_Route_Client_NeedsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available when this PC and the Vault are signed in to Cloud with the same account and the Vault accepts connections via Cloud.`)
};

export const local_route_client_title = /** @type {(inputs: Local_Route_Client_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to the Vault from outside the network`)
};

export const local_route_devices = /** @type {(inputs: Local_Route_DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC, smartphone`)
};

export const local_route_direct = /** @type {(inputs: Local_Route_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direct`)
};

export const local_route_direct_first = /** @type {(inputs: Local_Route_Direct_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you can connect to the Vault, it is used directly. Cloud is used only while you are outside the network.`)
};

export const local_route_help = /** @type {(inputs: Local_Route_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show a diagram`)
};

export const local_route_help_close = /** @type {(inputs: Local_Route_Help_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const local_route_hub = /** @type {(inputs: Local_Route_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vault`)
};

export const local_route_hub_cloud_home = /** @type {(inputs: Local_Route_Hub_Cloud_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connections via Cloud are used only while Personal data is on this Vault. Personal data is in Cloud now, so other devices connect to Cloud directly.`)
};

export const local_route_hub_copy = /** @type {(inputs: Local_Route_Hub_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A copy of Personal data`)
};

export const local_route_hub_diagram = /** @type {(inputs: Local_Route_Hub_DiagramInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecting to this Vault via Cloud`)
};

export const local_route_hub_first_direct = /** @type {(inputs: Local_Route_Hub_First_DirectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect a new device on the same network or over Tailscale first.`)
};

export const local_route_hub_paired_only = /** @type {(inputs: Local_Route_Hub_Paired_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only devices that have connected to this Vault directly once (paired) can connect via Cloud.`)
};

export const local_route_hub_title = /** @type {(inputs: Local_Route_Hub_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connections via Cloud`)
};

export const local_route_network = /** @type {(inputs: Local_Route_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same network`)
};

export const local_route_network_note = /** @type {(inputs: Local_Route_Network_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Same Wi-Fi or Tailscale`)
};

export const local_route_off = /** @type {(inputs: Local_Route_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Off`)
};

export const local_route_outside = /** @type {(inputs: Local_Route_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outside the network`)
};

export const local_route_personal_data = /** @type {(inputs: Local_Route_Personal_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data`)
};

export const local_route_relay = /** @type {(inputs: Local_Route_RelayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relay`)
};

export const local_route_relay_note = /** @type {(inputs: Local_Route_Relay_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't read the contents`)
};

export const local_route_sealed = /** @type {(inputs: Local_Route_SealedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encrypted`)
};

export const local_route_this_agent = /** @type {(inputs: Local_Route_This_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC's Agent`)
};

export const local_route_this_hub = /** @type {(inputs: Local_Route_This_HubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Vault`)
};

export const local_route_this_hub_note = /** @type {(inputs: Local_Route_This_Hub_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data, chats`)
};

export const local_route_this_pc = /** @type {(inputs: Local_Route_This_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC`)
};

export const local_setting_change_failed = /** @type {(inputs: Local_Setting_Change_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change this. Please try again.`)
};

export const local_trust = /** @type {(inputs: Local_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device list`)
};

export const local_trust_accept = /** @type {(inputs: Local_Trust_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept a list`)
};

export const local_trust_accept_body = /** @type {(inputs: Local_Trust_Accept_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check that the device ID on ${i?.name} is ${i?.fingerprint}. Once accepted, the devices in this list may instruct this PC's Agent.`)
};

export const local_trust_accept_button = /** @type {(inputs: Local_Trust_Accept_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept`)
};

export const local_trust_accept_first = /** @type {(inputs: Local_Trust_Accept_FirstInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`First device: ${i?.name}`)
};

export const local_trust_accept_note = /** @type {(inputs: Local_Trust_Accept_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lists made on another device. Accept one only if the device ID matches the one on its first device's screen.`)
};

export const local_trust_accept_title = /** @type {(inputs: Local_Trust_Accept_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept this list?`)
};

export const local_trust_add = /** @type {(inputs: Local_Trust_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a device`)
};

export const local_trust_add_another = /** @type {(inputs: Local_Trust_Add_AnotherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add another`)
};

export const local_trust_add_button = /** @type {(inputs: Local_Trust_Add_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

export const local_trust_add_note = /** @type {(inputs: Local_Trust_Add_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type the code shown under "Get added" on that device.`)
};

export const local_trust_agent_problem = /** @type {(inputs: Local_Trust_Agent_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The device list does not match the one saved on this PC, so this PC's agent has stopped running instructions.`)
};

export const local_trust_agent_settings = /** @type {(inputs: Local_Trust_Agent_SettingsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}'s Agent settings`)
};

export const local_trust_already_member = /** @type {(inputs: Local_Trust_Already_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That device is in the list already.`)
};

export const local_trust_approve_adding = /** @type {(inputs: Local_Trust_Approve_AddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding…`)
};

export const local_trust_approve_button = /** @type {(inputs: Local_Trust_Approve_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check`)
};

export const local_trust_approve_compare = /** @type {(inputs: Local_Trust_Approve_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add it if this matches the device ID on its screen.`)
};

export const local_trust_approve_done = /** @type {(inputs: Local_Trust_Approve_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.name} to the list.`)
};

export const local_trust_approve_finding = /** @type {(inputs: Local_Trust_Approve_FindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking for the device showing the code…`)
};

export const local_trust_candidates = /** @type {(inputs: Local_Trust_CandidatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices waiting to be added`)
};

export const local_trust_candidates_note = /** @type {(inputs: Local_Trust_Candidates_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They paired with this Vault. Add one if its device ID matches the one on its screen.`)
};

export const local_trust_cli_accepted = /** @type {(inputs: Local_Trust_Cli_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted the list.`)
};

export const local_trust_cli_agent_problem = /** @type {(inputs: Local_Trust_Cli_Agent_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The device list does not match the one saved on this PC, so this PC's agent has stopped running instructions.`)
};

export const local_trust_cli_approve_done = /** @type {(inputs: Local_Trust_Cli_Approve_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Added ${i?.name} to the list.`)
};

export const local_trust_cli_approve_finding = /** @type {(inputs: Local_Trust_Cli_Approve_FindingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Looking for the device showing the code…`)
};

export const local_trust_cli_approve_peer = /** @type {(inputs: Local_Trust_Cli_Approve_PeerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adding ${i?.name} (${i?.kind}, device ID: ${i?.fingerprint}). If it matches the device ID on that device, type the passphrase (empty to decline).`)
};

export const local_trust_cli_available = /** @type {(inputs: Local_Trust_Cli_AvailableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`List ${i?.list} (first device: ${i?.name}, device ID: ${i?.fingerprint})`)
};

export const local_trust_cli_compare = /** @type {(inputs: Local_Trust_Cli_CompareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check that the device ID shown on the first device is ${i?.fingerprint}. If it is, type the passphrase to accept.`)
};

export const local_trust_cli_created = /** @type {(inputs: Local_Trust_Cli_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made the list. This PC is its first device.`)
};

export const local_trust_cli_failed = /** @type {(inputs: Local_Trust_Cli_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That did not work (${i?.error}).`)
};

export const local_trust_cli_fingerprint = /** @type {(inputs: Local_Trust_Cli_FingerprintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This PC's device ID: ${i?.fingerprint}`)
};

export const local_trust_cli_invite = /** @type {(inputs: Local_Trust_Cli_InviteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Approval code (works once, for ${i?.minutes} more minutes): ${i?.code}
Type it on the approving device, or scan the QR.`)
};

export const local_trust_cli_invite_approved = /** @type {(inputs: Local_Trust_Cli_Invite_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC joined the list.`)
};

export const local_trust_cli_invite_declined = /** @type {(inputs: Local_Trust_Cli_Invite_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It was declined.`)
};

export const local_trust_cli_invite_expired = /** @type {(inputs: Local_Trust_Cli_Invite_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code expired.`)
};

export const local_trust_cli_invite_proved = /** @type {(inputs: Local_Trust_Cli_Invite_ProvedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Checked the code with ${i?.name}. Waiting for ${i?.name} to approve…`)
};

export const local_trust_cli_invite_refused = /** @type {(inputs: Local_Trust_Cli_Invite_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code did not check. It no longer works.`)
};

export const local_trust_cli_keys_made = /** @type {(inputs: Local_Trust_Cli_Keys_MadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Made this PC's keys.`)
};

export const local_trust_cli_list = /** @type {(inputs: Local_Trust_Cli_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Device list (version ${i?.n}):`)
};

export const local_trust_cli_made = /** @type {(inputs: Local_Trust_Cli_MadeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`    Created ${i?.date}`)
};

export const local_trust_cli_no_list = /** @type {(inputs: Local_Trust_Cli_No_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No device list accepted yet.`)
};

export const local_trust_cli_no_lists = /** @type {(inputs: Local_Trust_Cli_No_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There is no list to accept.`)
};

export const local_trust_cli_not_found = /** @type {(inputs: Local_Trust_Cli_Not_FoundInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not found: ${i?.what}`)
};

export const local_trust_cli_not_running = /** @type {(inputs: Local_Trust_Cli_Not_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.app} is not running on ${i?.dir}. Start it first (${i?.app} --headless, or the service), then run this again.`)
};

export const local_trust_cli_others = /** @type {(inputs: Local_Trust_Cli_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The storage has a device list created on another device. See it with ${i?.app} --headless --trust lists.`)
};

export const local_trust_cli_pair_note = /** @type {(inputs: Local_Trust_Cli_Pair_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The device that pairs with this code joins the device list too.`)
};

export const local_trust_cli_passphrase = /** @type {(inputs: Local_Trust_Cli_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passphrase: `)
};

export const local_trust_cli_passphrase_again = /** @type {(inputs: Local_Trust_Cli_Passphrase_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Again: `)
};

export const local_trust_cli_passphrase_mismatch = /** @type {(inputs: Local_Trust_Cli_Passphrase_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The two did not match.`)
};

export const local_trust_cli_passphrase_new = /** @type {(inputs: Local_Trust_Cli_Passphrase_NewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Choose a passphrase. You type it when adding or removing devices on this PC; if you forget it, this PC can no longer change the device list (${i?.min} characters or more): `)
};

export const local_trust_cli_problem = /** @type {(inputs: Local_Trust_Cli_ProblemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The storage (${i?.place}) hands out a list that disagrees with this PC's.`)
};

export const local_trust_cli_remove_done = /** @type {(inputs: Local_Trust_Cli_Remove_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Removed ${i?.name} from the list.`)
};

export const local_trust_cli_switch = /** @type {(inputs: Local_Trust_Cli_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This switches from the current device list to this one. The devices in the current list can no longer instruct this PC's Agent, and you cannot switch back.`)
};

export const local_trust_cli_switched = /** @type {(inputs: Local_Trust_Cli_SwitchedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switched device lists.`)
};

export const local_trust_cli_usage = /** @type {(inputs: Local_Trust_Cli_UsageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usage: ${i?.app} --headless --trust [status | init | create | lists | accept <list> | invite [vault|cloud] | approve <code> | remove <device> | pair]`)
};

export const local_trust_cli_waiting = /** @type {(inputs: Local_Trust_Cli_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting…`)
};

export const local_trust_cli_wrong_passphrase = /** @type {(inputs: Local_Trust_Cli_Wrong_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrong passphrase.`)
};

export const local_trust_cloud = /** @type {(inputs: Local_Trust_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud`)
};

export const local_trust_cloud_add = /** @type {(inputs: Local_Trust_Cloud_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

export const local_trust_cloud_add_when_ready = /** @type {(inputs: Local_Trust_Cloud_Add_When_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can add it once it is ready.`)
};

export const local_trust_cloud_adding = /** @type {(inputs: Local_Trust_Cloud_AddingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is added to the list once it is ready.`)
};

export const local_trust_cloud_create = /** @type {(inputs: Local_Trust_Cloud_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

export const local_trust_cloud_create_limit = /** @type {(inputs: Local_Trust_Cloud_Create_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can create one up to 3 times a day.`)
};

export const local_trust_cloud_delete = /** @type {(inputs: Local_Trust_Cloud_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const local_trust_cloud_delete_body = /** @type {(inputs: Local_Trust_Cloud_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is removed from the list, and all its files in Cloud are deleted.`)
};

export const local_trust_cloud_delete_title = /** @type {(inputs: Local_Trust_Cloud_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}?`)
};

export const local_trust_cloud_failed = /** @type {(inputs: Local_Trust_Cloud_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud could not do it.`)
};

export const local_trust_cloud_name_dev = /** @type {(inputs: Local_Trust_Cloud_Name_DevInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud (dev)`)
};

export const local_trust_cloud_name_general = /** @type {(inputs: Local_Trust_Cloud_Name_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria cloud`)
};

export const local_trust_cloud_none = /** @type {(inputs: Local_Trust_Cloud_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not created yet`)
};

export const local_trust_cloud_note = /** @type {(inputs: Local_Trust_Cloud_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices that run an Agent in Cloud. They take instructions from the devices in the list.`)
};

export const local_trust_cloud_other_list = /** @type {(inputs: Local_Trust_Cloud_Other_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It belongs to an earlier device list. Remake it to add it to this one.`)
};

export const local_trust_cloud_phase_asleep = /** @type {(inputs: Local_Trust_Cloud_Phase_AsleepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asleep`)
};

export const local_trust_cloud_phase_deleting = /** @type {(inputs: Local_Trust_Cloud_Phase_DeletingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting`)
};

export const local_trust_cloud_phase_error = /** @type {(inputs: Local_Trust_Cloud_Phase_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error`)
};

export const local_trust_cloud_phase_preparing = /** @type {(inputs: Local_Trust_Cloud_Phase_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getting ready`)
};

export const local_trust_cloud_phase_queued = /** @type {(inputs: Local_Trust_Cloud_Phase_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for room`)
};

export const local_trust_cloud_phase_queued_at = /** @type {(inputs: Local_Trust_Cloud_Phase_Queued_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting for room · ${i?.n}`)
};

export const local_trust_cloud_phase_remaking = /** @type {(inputs: Local_Trust_Cloud_Phase_RemakingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remaking`)
};

export const local_trust_cloud_phase_running = /** @type {(inputs: Local_Trust_Cloud_Phase_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

export const local_trust_cloud_phase_starting = /** @type {(inputs: Local_Trust_Cloud_Phase_StartingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting`)
};

export const local_trust_cloud_remake = /** @type {(inputs: Local_Trust_Cloud_RemakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remake`)
};

export const local_trust_cloud_remake_body = /** @type {(inputs: Local_Trust_Cloud_Remake_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is deleted, then created again and added to this list. All its files are deleted.`)
};

export const local_trust_cloud_remake_title = /** @type {(inputs: Local_Trust_Cloud_Remake_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remake ${i?.name}?`)
};

export const local_trust_cloud_unlisted = /** @type {(inputs: Local_Trust_Cloud_UnlistedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It takes no instructions until it is added to the list.`)
};

export const local_trust_cloud_update_clis = /** @type {(inputs: Local_Trust_Cloud_Update_ClisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update CLIs`)
};

export const local_trust_cloud_updating = /** @type {(inputs: Local_Trust_Cloud_UpdatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating CLIs`)
};

export const local_trust_cloud_wake = /** @type {(inputs: Local_Trust_Cloud_WakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const local_trust_cloud_wake_to_add = /** @type {(inputs: Local_Trust_Cloud_Wake_To_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start it to add it to the list.`)
};

export const local_trust_code = /** @type {(inputs: Local_Trust_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

export const local_trust_code_expired = /** @type {(inputs: Local_Trust_Code_ExpiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code expired.`)
};

export const local_trust_create = /** @type {(inputs: Local_Trust_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a list`)
};

export const local_trust_create_again_body = /** @type {(inputs: Local_Trust_Create_Again_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A device list created on ${i?.name} exists already. If you create a new one, the devices in that list cannot instruct this PC's Agent. Create one only if you lost ${i?.name} and every other device in it.`)
};

export const local_trust_create_again_note = /** @type {(inputs: Local_Trust_Create_Again_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only for when you lost every device in the device list found. If you still have one of them, use "Get added" or "Accept a list" above.`)
};

export const local_trust_create_again_title = /** @type {(inputs: Local_Trust_Create_Again_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new device list?`)
};

export const local_trust_create_button = /** @type {(inputs: Local_Trust_Create_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make`)
};

export const local_trust_create_note = /** @type {(inputs: Local_Trust_Create_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a new list with this device as its first.`)
};

export const local_trust_decline = /** @type {(inputs: Local_Trust_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

export const local_trust_description = /** @type {(inputs: Local_Trust_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The devices that may instruct your Agents. Choose a device to change its Agent's settings.`)
};

export const local_trust_device_not_found = /** @type {(inputs: Local_Trust_Device_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device is not in the device list. It may have been removed.`)
};

export const local_trust_failed = /** @type {(inputs: Local_Trust_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That did not work.`)
};

export const local_trust_guide = /** @type {(inputs: Local_Trust_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to add a device`)
};

export const local_trust_guide_add = /** @type {(inputs: Local_Trust_Guide_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a device`)
};

export const local_trust_guide_add_this = /** @type {(inputs: Local_Trust_Guide_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add this device`)
};

export const local_trust_guide_agent = /** @type {(inputs: Local_Trust_Guide_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each PC's Agent`)
};

export const local_trust_guide_agent_note = /** @type {(inputs: Local_Trust_Guide_Agent_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checks that the sending device is in the device list`)
};

export const local_trust_guide_by_vault = /** @type {(inputs: Local_Trust_Guide_By_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can also add a PC by connecting it to a Vault`)
};

export const local_trust_guide_by_vault_linked = /** @type {(inputs: Local_Trust_Guide_By_Vault_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When the PC connects to the Vault, it shows under the Vault's "Devices waiting to be added". Compare the device ID and press "Add".`)
};

export const local_trust_guide_by_vault_self = /** @type {(inputs: Local_Trust_Guide_By_Vault_SelfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`When the PC connects to ${i?.name}, it shows under ${i?.name}'s "Devices waiting to be added". Compare the device ID and press "Add".`)
};

export const local_trust_guide_code_goes = /** @type {(inputs: Local_Trust_Guide_Code_GoesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code`)
};

export const local_trust_guide_create_made = /** @type {(inputs: Local_Trust_Guide_Create_MadeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A device list with only this PC in it is made. This PC is its first device.`)
};

export const local_trust_guide_create_next = /** @type {(inputs: Local_Trust_Guide_Create_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add other devices from this PC under "Add a device". The steps to add one then show here too.`)
};

export const local_trust_guide_create_once = /** @type {(inputs: Local_Trust_Guide_Create_OnceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make only one device list. If another device has made one, do not make one here: it would be a separate list, and this PC's Agent would no longer take instructions from that device.`)
};

export const local_trust_guide_create_passphrase = /** @type {(inputs: Local_Trust_Guide_Create_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC has no keychain, so you set a passphrase. You type it each time the device list changes.`)
};

export const local_trust_guide_create_press = /** @type {(inputs: Local_Trust_Guide_Create_PressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Under "Make a list" below, press "Make".`)
};

export const local_trust_guide_example_pc = /** @type {(inputs: Local_Trust_Guide_Example_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MacBook`)
};

export const local_trust_guide_example_phone = /** @type {(inputs: Local_Trust_Guide_Example_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone`)
};

export const local_trust_guide_flow_check = /** @type {(inputs: Local_Trust_Guide_Flow_CheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The PC receiving it`)
};

export const local_trust_guide_flow_from = /** @type {(inputs: Local_Trust_Guide_Flow_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent from`)
};

export const local_trust_guide_flow_result = /** @type {(inputs: Local_Trust_Guide_Flow_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Result`)
};

export const local_trust_guide_found = /** @type {(inputs: Local_Trust_Guide_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A device list made on another device was found. Add this PC from that device.`)
};

export const local_trust_guide_found_trust = /** @type {(inputs: Local_Trust_Guide_Found_TrustInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Accept a list" also shows below. Adding this PC as above accepts the list too, so you need not press it.`)
};

export const local_trust_guide_here = /** @type {(inputs: Local_Trust_Guide_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC's screen`)
};

export const local_trust_guide_here_name = /** @type {(inputs: Local_Trust_Guide_Here_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC's name`)
};

export const local_trust_guide_in_list = /** @type {(inputs: Local_Trust_Guide_In_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices in the device list`)
};

export const local_trust_guide_join_first = /** @type {(inputs: Local_Trust_Guide_Join_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First sign in to the same Cloud account as a device in the device list, or connect to the same Vault. Then a code can be shown.`)
};

export const local_trust_guide_kind_headless = /** @type {(inputs: Local_Trust_Guide_Kind_HeadlessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC with no screen`)
};

export const local_trust_guide_kind_headless_note = /** @type {(inputs: Local_Trust_Guide_Kind_Headless_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A PC such as a server that runs trameria from a command`)
};

export const local_trust_guide_kind_pc = /** @type {(inputs: Local_Trust_Guide_Kind_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC with a screen`)
};

export const local_trust_guide_kind_pc_note = /** @type {(inputs: Local_Trust_Guide_Kind_Pc_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Mac, Windows or Linux PC using the trameria app on its screen`)
};

export const local_trust_guide_kind_phone = /** @type {(inputs: Local_Trust_Guide_Kind_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iPhone`)
};

export const local_trust_guide_kind_phone_note = /** @type {(inputs: Local_Trust_Guide_Kind_Phone_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trameria app on an iPhone`)
};

export const local_trust_guide_kind_question = /** @type {(inputs: Local_Trust_Guide_Kind_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which device do you want to add?`)
};

export const local_trust_guide_member_screen = /** @type {(inputs: Local_Trust_Guide_Member_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The screen of a PC in the device list`)
};

export const local_trust_guide_more_add = /** @type {(inputs: Local_Trust_Guide_More_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how to add a device`)
};

export const local_trust_guide_more_add_this = /** @type {(inputs: Local_Trust_Guide_More_Add_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how to add this device`)
};

export const local_trust_guide_more_start = /** @type {(inputs: Local_Trust_Guide_More_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See how to start a device list`)
};

export const local_trust_guide_new_pc = /** @type {(inputs: Local_Trust_Guide_New_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The screen of the PC to add`)
};

export const local_trust_guide_new_phone = /** @type {(inputs: Local_Trust_Guide_New_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The screen of the iPhone to add`)
};

export const local_trust_guide_others = /** @type {(inputs: Local_Trust_Guide_OthersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices not in the list, a Cloud or Vault taken over`)
};

export const local_trust_guide_reach_cloud = /** @type {(inputs: Local_Trust_Guide_Reach_CloudInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can add a device signed in to the same Cloud account as ${i?.name}.`)
};

export const local_trust_guide_reach_none = /** @type {(inputs: Local_Trust_Guide_Reach_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to a Vault or sign in to Cloud to add devices.`)
};

export const local_trust_guide_reach_outside = /** @type {(inputs: Local_Trust_Guide_Reach_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This works when it is connected to the same Vault as a device in the device list, or signed in to the same Cloud account.`)
};

export const local_trust_guide_reach_self = /** @type {(inputs: Local_Trust_Guide_Reach_SelfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can add a device connected to ${i?.name}. Sign in to Cloud to add devices on other networks too.`)
};

export const local_trust_guide_reach_self_cloud = /** @type {(inputs: Local_Trust_Guide_Reach_Self_CloudInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can add a device connected to ${i?.name}, or signed in to the same Cloud account as ${i?.name}.`)
};

export const local_trust_guide_reach_vault = /** @type {(inputs: Local_Trust_Guide_Reach_VaultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can add a device connected to the same Vault as ${i?.name}. Sign in to Cloud to add devices on other networks too.`)
};

export const local_trust_guide_reach_vault_cloud = /** @type {(inputs: Local_Trust_Guide_Reach_Vault_CloudInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You can add a device connected to the same Vault as ${i?.name}, or signed in to the same Cloud account.`)
};

export const local_trust_guide_refused = /** @type {(inputs: Local_Trust_Guide_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not run`)
};

export const local_trust_guide_runs = /** @type {(inputs: Local_Trust_Guide_RunsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runs`)
};

export const local_trust_guide_screen_of = /** @type {(inputs: Local_Trust_Guide_Screen_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name}'s screen`)
};

export const local_trust_guide_start = /** @type {(inputs: Local_Trust_Guide_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start a device list`)
};

export const local_trust_guide_start_create = /** @type {(inputs: Local_Trust_Guide_Start_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a new device list`)
};

export const local_trust_guide_start_create_note = /** @type {(inputs: Local_Trust_Guide_Start_Create_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When there is none yet. This PC becomes its first device`)
};

export const local_trust_guide_start_join = /** @type {(inputs: Local_Trust_Guide_Start_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add it to an existing device list`)
};

export const local_trust_guide_start_join_note = /** @type {(inputs: Local_Trust_Guide_Start_Join_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put this PC in a device list made on another device`)
};

export const local_trust_guide_start_none = /** @type {(inputs: Local_Trust_Guide_Start_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No device list made on another device was found in the Vault or in Cloud. It may be kept in another Vault or Cloud account.`)
};

export const local_trust_guide_start_question = /** @type {(inputs: Local_Trust_Guide_Start_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What do you want to do with this PC?`)
};

export const local_trust_guide_start_unreached = /** @type {(inputs: Local_Trust_Guide_Start_UnreachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC is not signed in to Cloud nor connected to a Vault, so it cannot look for a device list made on another device.`)
};

export const local_trust_guide_step_add = /** @type {(inputs: Local_Trust_Guide_Step_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If they match, press "Add". The added device may then instruct Agents too.`)
};

export const local_trust_guide_step_compare = /** @type {(inputs: Local_Trust_Guide_Step_CompareInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check that the device ID ${i?.name} shows is the same as "This device's ID" on the other screen. If not, press "Decline".`)
};

export const local_trust_guide_step_compare_headless = /** @type {(inputs: Local_Trust_Guide_Step_Compare_HeadlessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check that the device ID ${i?.name} shows is the same as the one in the terminal. If not, press "Decline".`)
};

export const local_trust_guide_step_compare_member = /** @type {(inputs: Local_Trust_Guide_Step_Compare_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check that the device ID that PC shows is the same as "This device's ID" on this PC. If not, press "Decline".`)
};

export const local_trust_guide_step_enter = /** @type {(inputs: Local_Trust_Guide_Step_EnterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`On ${i?.name}, in Settings › Device list, type the code in "Add a device" and press "Check".`)
};

export const local_trust_guide_step_enter_member = /** @type {(inputs: Local_Trust_Guide_Step_Enter_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On a PC in the device list, in Settings › Device list, type the code in "Add a device" and press "Check".`)
};

export const local_trust_guide_step_show_headless = /** @type {(inputs: Local_Trust_Guide_Step_Show_HeadlessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run the command in the PC's terminal. A code and that PC's device ID show.`)
};

export const local_trust_guide_step_show_here = /** @type {(inputs: Local_Trust_Guide_Step_Show_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On this PC, under "Get added" below, press "Show a code".`)
};

export const local_trust_guide_step_show_pc = /** @type {(inputs: Local_Trust_Guide_Step_Show_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the PC to add, in Settings › Device list, under "Get added", press "Show a code". A code and that PC's device ID show.`)
};

export const local_trust_guide_step_show_phone = /** @type {(inputs: Local_Trust_Guide_Step_Show_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the iPhone, in Settings › Device list, under "Get added", press "Show a code". A code and the iPhone's device ID show.`)
};

export const local_trust_guide_term_code = /** @type {(inputs: Local_Trust_Guide_Term_CodeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Approval code: ${i?.code}`)
};

export const local_trust_guide_what = /** @type {(inputs: Local_Trust_Guide_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the device list is`)
};

export const local_trust_guide_what_body = /** @type {(inputs: Local_Trust_Guide_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The devices that may instruct your Agents. Each PC's Agent runs only instructions sent from a device in the device list. Even if Cloud or a Vault is taken over, instructions from outside the list are not run.`)
};

export const local_trust_guide_where = /** @type {(inputs: Local_Trust_Guide_WhereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings › Device list`)
};

export const local_trust_invalid_code = /** @type {(inputs: Local_Trust_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is not a code.`)
};

export const local_trust_invite = /** @type {(inputs: Local_Trust_InviteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get added`)
};

export const local_trust_invite_approved = /** @type {(inputs: Local_Trust_Invite_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device joined the list.`)
};

export const local_trust_invite_button = /** @type {(inputs: Local_Trust_Invite_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show a code`)
};

export const local_trust_invite_declined = /** @type {(inputs: Local_Trust_Invite_DeclinedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It was declined.`)
};

export const local_trust_invite_note = /** @type {(inputs: Local_Trust_Invite_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a device in the list add this one.`)
};

export const local_trust_invite_proved = /** @type {(inputs: Local_Trust_Invite_ProvedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Checked the code with ${i?.name}. Waiting for ${i?.name} to add this device.`)
};

export const local_trust_invite_refused = /** @type {(inputs: Local_Trust_Invite_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code did not check, so it no longer works.`)
};

export const local_trust_invite_waiting = /** @type {(inputs: Local_Trust_Invite_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type this code under "Add a device" on a device in the list. It works once.`)
};

export const local_trust_kind_cloud = /** @type {(inputs: Local_Trust_Kind_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const local_trust_kind_pc = /** @type {(inputs: Local_Trust_Kind_PcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC`)
};

export const local_trust_kind_phone = /** @type {(inputs: Local_Trust_Kind_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

export const local_trust_last_approver = /** @type {(inputs: Local_Trust_Last_ApproverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The last device that can change the list cannot be removed.`)
};

export const local_trust_left = /** @type {(inputs: Local_Trust_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot go back to a device list you switched from.`)
};

export const local_trust_list_made = /** @type {(inputs: Local_Trust_List_MadeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created ${i?.date}`)
};

export const local_trust_members = /** @type {(inputs: Local_Trust_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices`)
};

export const local_trust_members_note = /** @type {(inputs: Local_Trust_Members_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device can change the list.`)
};

export const local_trust_members_note_outside = /** @type {(inputs: Local_Trust_Members_Note_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device is not in the list.`)
};

export const local_trust_members_note_receiver = /** @type {(inputs: Local_Trust_Members_Note_ReceiverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device cannot change the list.`)
};

export const local_trust_no_keys = /** @type {(inputs: Local_Trust_No_KeysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No keys yet`)
};

export const local_trust_no_place = /** @type {(inputs: Local_Trust_No_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to a Vault or sign in to Cloud to show a code.`)
};

export const local_trust_no_place_failed = /** @type {(inputs: Local_Trust_No_Place_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to a Vault or sign in to Cloud.`)
};

export const local_trust_outside = /** @type {(inputs: Local_Trust_OutsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices not in the device list`)
};

export const local_trust_outside_not_taking = /** @type {(inputs: Local_Trust_Outside_Not_TakingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takes no instructions: it does not trust the device list.`)
};

export const local_trust_outside_note = /** @type {(inputs: Local_Trust_Outside_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`They take instructions from devices in the device list, but cannot give any. To add one, show a code on it and type the code in "Add a device".`)
};

export const local_trust_outside_page_note = /** @type {(inputs: Local_Trust_Outside_Page_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device is not in the device list. Its Agent takes instructions from devices in the device list.`)
};

export const local_trust_passphrase = /** @type {(inputs: Local_Trust_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passphrase`)
};

export const local_trust_passphrase_again = /** @type {(inputs: Local_Trust_Passphrase_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type it again`)
};

export const local_trust_passphrase_ask_body = /** @type {(inputs: Local_Trust_Passphrase_Ask_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To change the device list on this PC, enter its passphrase.`)
};

export const local_trust_passphrase_ask_button = /** @type {(inputs: Local_Trust_Passphrase_Ask_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue`)
};

export const local_trust_passphrase_ask_title = /** @type {(inputs: Local_Trust_Passphrase_Ask_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the passphrase`)
};

export const local_trust_passphrase_mismatch = /** @type {(inputs: Local_Trust_Passphrase_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The two entries differ.`)
};

export const local_trust_passphrase_new_note = /** @type {(inputs: Local_Trust_Passphrase_New_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This PC has no keychain, so you type a passphrase when adding or removing devices. Choose one of 8 characters or more. If you forget it, this PC can no longer change the device list.`)
};

export const local_trust_passphrase_set_title = /** @type {(inputs: Local_Trust_Passphrase_Set_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a passphrase`)
};

export const local_trust_passphrase_short = /** @type {(inputs: Local_Trust_Passphrase_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use 8 characters or more.`)
};

export const local_trust_problem = /** @type {(inputs: Local_Trust_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A storage hands out a list that disagrees with this device's. Someone may be trying to change it.`)
};

export const local_trust_receiver_mark = /** @type {(inputs: Local_Trust_Receiver_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`takes instructions only`)
};

export const local_trust_remove = /** @type {(inputs: Local_Trust_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const local_trust_remove_body = /** @type {(inputs: Local_Trust_Remove_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The removed device can no longer instruct your Agents. To bring it back, add it again.`)
};

export const local_trust_remove_self_body = /** @type {(inputs: Local_Trust_Remove_Self_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device will no longer instruct your Agents or change the list. To come back, another device adds it again.`)
};

export const local_trust_remove_title = /** @type {(inputs: Local_Trust_Remove_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.name} from the list?`)
};

export const local_trust_switch = /** @type {(inputs: Local_Trust_SwitchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch device lists`)
};

export const local_trust_switch_body = /** @type {(inputs: Local_Trust_Switch_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check that the device ID on ${i?.name} is ${i?.fingerprint}. Once you switch, the devices in the current list can no longer instruct this PC's Agent. You cannot switch back to the current list.`)
};

export const local_trust_switch_button = /** @type {(inputs: Local_Trust_Switch_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch`)
};

export const local_trust_switch_note = /** @type {(inputs: Local_Trust_Switch_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new device list created on another device. Switch only if you lost all your devices and created the list again, and only if the device ID matches the one on its first device's screen.`)
};

export const local_trust_switch_title = /** @type {(inputs: Local_Trust_Switch_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to this device list?`)
};

export const local_trust_this_device = /** @type {(inputs: Local_Trust_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device's ID`)
};

export const local_trust_this_device_mark = /** @type {(inputs: Local_Trust_This_Device_MarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this device`)
};

export const local_trust_this_device_note = /** @type {(inputs: Local_Trust_This_Device_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare it when another device adds this one, or accepts a list.`)
};

export const local_trust_unreachable = /** @type {(inputs: Local_Trust_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach the storage.`)
};

export const local_trust_wrong_passphrase = /** @type {(inputs: Local_Trust_Wrong_PassphraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrong passphrase.`)
};

export const local_trust_wrong_proof = /** @type {(inputs: Local_Trust_Wrong_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The code did not check.`)
};

export const local_via_cloud_refused = /** @type {(inputs: Local_Via_Cloud_RefusedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Vault's settings can't be changed from outside the network. Change them when you can connect to the Vault.`)
};

export const local_where_cloud = /** @type {(inputs: Local_Where_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cloud`)
};

export const media_close = /** @type {(inputs: Media_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const media_download = /** @type {(inputs: Media_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download`)
};

export const media_image_actions = /** @type {(inputs: Media_Image_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image actions`)
};

export const media_image_next = /** @type {(inputs: Media_Image_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next image`)
};

export const media_image_position = /** @type {(inputs: Media_Image_PositionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Image ${i?.n} of ${i?.count}`)
};

export const media_image_previous = /** @type {(inputs: Media_Image_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous image`)
};

export const media_more_actions = /** @type {(inputs: Media_More_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More actions`)
};

export const media_open_in_tab = /** @type {(inputs: Media_Open_In_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in new tab`)
};

export const media_video_exit_fullscreen = /** @type {(inputs: Media_Video_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit full screen`)
};

export const media_video_fullscreen = /** @type {(inputs: Media_Video_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full screen`)
};

export const media_video_label = /** @type {(inputs: Media_Video_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Video: ${i?.name}`)
};

export const media_video_mute = /** @type {(inputs: Media_Video_MuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mute`)
};

export const media_video_native_fullscreen = /** @type {(inputs: Media_Video_Native_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full screen in the native player`)
};

export const media_video_pause = /** @type {(inputs: Media_Video_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause`)
};

export const media_video_play = /** @type {(inputs: Media_Video_PlayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play`)
};

export const media_video_play_named = /** @type {(inputs: Media_Video_Play_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Play ${i?.name}`)
};

export const media_video_seconds = /** @type {(inputs: Media_Video_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n} sec`)
};

export const media_video_seek = /** @type {(inputs: Media_Video_SeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek`)
};

export const media_video_speed = /** @type {(inputs: Media_Video_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playback speed`)
};

export const media_video_speed_normal = /** @type {(inputs: Media_Video_Speed_NormalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normal`)
};

export const media_video_unmute = /** @type {(inputs: Media_Video_UnmuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unmute`)
};

export const media_video_unplayable = /** @type {(inputs: Media_Video_UnplayableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This video can't be played`)
};

export const media_video_volume = /** @type {(inputs: Media_Video_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volume`)
};

export const media_zoom_in = /** @type {(inputs: Media_Zoom_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom in`)
};

export const media_zoom_out = /** @type {(inputs: Media_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom out`)
};

export const memos_close = /** @type {(inputs: Memos_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const memos_handover = /** @type {(inputs: Memos_HandoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handover`)
};

export const memos_handover_placeholder = /** @type {(inputs: Memos_Handover_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A handover to the next AI (where things stand)`)
};

export const memos_load_failed = /** @type {(inputs: Memos_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load`)
};

export const memos_log = /** @type {(inputs: Memos_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log`)
};

export const memos_log_delete = /** @type {(inputs: Memos_Log_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this entry`)
};

export const memos_log_delete_failed = /** @type {(inputs: Memos_Log_Delete_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not delete the entry`)
};

export const memos_log_empty = /** @type {(inputs: Memos_Log_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No log yet`)
};

export const memos_log_more = /** @type {(inputs: Memos_Log_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

export const memos_save_failed = /** @type {(inputs: Memos_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save (what you wrote is kept)`)
};

export const memos_title = /** @type {(inputs: Memos_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI memo`)
};

export const notices_agent_title = /** @type {(inputs: Notices_Agent_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Agent · ${i?.name}`)
};

export const notices_app_denied = /** @type {(inputs: Notices_App_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Notifications are not allowed in the ${i?.device}'s Settings`)
};

export const notices_app_destinations = /** @type {(inputs: Notices_App_DestinationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destinations`)
};

export const notices_app_failed = /** @type {(inputs: Notices_App_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't change receiving`)
};

export const notices_app_label = /** @type {(inputs: Notices_App_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.device} (app)`)
};

export const notices_app_open_settings = /** @type {(inputs: Notices_App_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Settings`)
};

export const notices_app_receive = /** @type {(inputs: Notices_App_ReceiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receive on this device`)
};

export const notices_app_this_device = /** @type {(inputs: Notices_App_This_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device`)
};

export const notices_app_untied = /** @type {(inputs: Notices_App_UntiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Vault is not linked with Cloud, so nothing arrives while the app is closed`)
};

export const notices_file_only = /** @type {(inputs: Notices_File_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

export const notices_settings_denied = /** @type {(inputs: Notices_Settings_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are not allowed. Allow them in the browser or OS settings, then turn them on here`)
};

export const notices_settings_description = /** @type {(inputs: Notices_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tells you about Agent replies and items waiting for you, with OS notifications and the app's badge`)
};

export const notices_settings_os = /** @type {(inputs: Notices_Settings_OsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show OS notifications`)
};

export const notices_settings_os_blocked = /** @type {(inputs: Notices_Settings_Os_BlockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are not allowed on this Mac`)
};

export const notices_settings_os_description = /** @type {(inputs: Notices_Settings_Os_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent replies and items waiting for you appear as OS notifications when the window is not in front`)
};

export const notices_settings_os_open_settings = /** @type {(inputs: Notices_Settings_Os_Open_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open System Settings`)
};

export const notices_settings_os_unsigned = /** @type {(inputs: Notices_Settings_Os_UnsignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unsigned build cannot show Mac notifications`)
};

export const notices_settings_title = /** @type {(inputs: Notices_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

export const notices_settings_unsupported = /** @type {(inputs: Notices_Settings_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser does not support notifications`)
};

export const notices_test_body = /** @type {(inputs: Notices_Test_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is a test notification`)
};

export const notices_test_title = /** @type {(inputs: Notices_Test_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trameria`)
};

export const notices_trust_added_body = /** @type {(inputs: Notices_Trust_Added_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} was added to your device list. If you did not add it, remove it from the list.`)
};

export const notices_trust_added_title = /** @type {(inputs: Notices_Trust_Added_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A device was added to your device list`)
};

export const notices_turn_edited_prefix = /** @type {(inputs: Notices_Turn_Edited_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edited: `)
};

export const notices_turn_proposal_prefix = /** @type {(inputs: Notices_Turn_Proposal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wants to change: `)
};

export const persons_agent_memo = /** @type {(inputs: Persons_Agent_MemoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI memo`)
};

export const persons_alias_add = /** @type {(inputs: Persons_Alias_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an alias`)
};

export const persons_alias_add_failed = /** @type {(inputs: Persons_Alias_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not add the alias "${i?.alias}"`)
};

export const persons_alias_placeholder = /** @type {(inputs: Persons_Alias_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading, nickname`)
};

export const persons_alias_remove = /** @type {(inputs: Persons_Alias_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove the alias "${i?.alias}"`)
};

export const persons_alias_remove_failed = /** @type {(inputs: Persons_Alias_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not remove the alias "${i?.alias}"`)
};

export const persons_aliases = /** @type {(inputs: Persons_AliasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aliases`)
};

export const persons_aliases_ids = /** @type {(inputs: Persons_Aliases_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aliases and ids`)
};

export const persons_context = /** @type {(inputs: Persons_ContextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Context`)
};

export const persons_context_placeholder = /** @type {(inputs: Persons_Context_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who they are, how you know them, what to keep in mind`)
};

export const persons_create = /** @type {(inputs: Persons_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Person`)
};

export const persons_create_failed = /** @type {(inputs: Persons_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not create the person`)
};

export const persons_create_failed_kept = /** @type {(inputs: Persons_Create_Failed_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not create them (what you wrote is kept)`)
};

export const persons_create_named = /** @type {(inputs: Persons_Create_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Create "${i?.name}"`)
};

export const persons_creating = /** @type {(inputs: Persons_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating`)
};

export const persons_delete_body = /** @type {(inputs: Persons_Delete_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Their external ids and AI memo go too. Cases keep showing the name ${i?.name}`)
};

export const persons_delete_failed = /** @type {(inputs: Persons_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete ${i?.name}`)
};

export const persons_delete_title = /** @type {(inputs: Persons_Delete_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete ${i?.name}`)
};

export const persons_empty = /** @type {(inputs: Persons_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No people yet`)
};

export const persons_external_ids = /** @type {(inputs: Persons_External_IdsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External ids`)
};

export const persons_go = /** @type {(inputs: Persons_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to People`)
};

export const persons_history = /** @type {(inputs: Persons_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before`)
};

export const persons_id_add = /** @type {(inputs: Persons_Id_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an id`)
};

export const persons_id_add_failed = /** @type {(inputs: Persons_Id_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not add "${i?.value}"`)
};

export const persons_id_kind = /** @type {(inputs: Persons_Id_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind of id`)
};

export const persons_id_remove = /** @type {(inputs: Persons_Id_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove "${i?.value}"`)
};

export const persons_id_remove_failed = /** @type {(inputs: Persons_Id_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not remove "${i?.value}"`)
};

export const persons_id_value = /** @type {(inputs: Persons_Id_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id`)
};

export const persons_id_value_placeholder = /** @type {(inputs: Persons_Id_Value_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email, user name, phone number or URL`)
};

export const persons_kind_email = /** @type {(inputs: Persons_Kind_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

export const persons_kind_github = /** @type {(inputs: Persons_Kind_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GitHub`)
};

export const persons_kind_phone = /** @type {(inputs: Persons_Kind_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone`)
};

export const persons_kind_slack = /** @type {(inputs: Persons_Kind_SlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slack`)
};

export const persons_kind_url = /** @type {(inputs: Persons_Kind_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL`)
};

export const persons_link_empty = /** @type {(inputs: Persons_Link_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No members to link (you and members linked to other people aren't shown)`)
};

export const persons_link_failed = /** @type {(inputs: Persons_Link_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not link ${i?.name}`)
};

export const persons_link_label = /** @type {(inputs: Persons_Link_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to member`)
};

export const persons_link_menu = /** @type {(inputs: Persons_Link_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to member…`)
};

export const persons_link_search = /** @type {(inputs: Persons_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search members to link`)
};

export const persons_link_search_placeholder = /** @type {(inputs: Persons_Link_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by name`)
};

export const persons_link_title = /** @type {(inputs: Persons_Link_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Member to link with ${i?.name}`)
};

export const persons_linked_former = /** @type {(inputs: Persons_Linked_FormerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Former member`)
};

export const persons_list = /** @type {(inputs: Persons_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

export const persons_load_failed = /** @type {(inputs: Persons_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load`)
};

export const persons_menu = /** @type {(inputs: Persons_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actions for "${i?.name}"`)
};

export const persons_merge_action = /** @type {(inputs: Persons_Merge_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge`)
};

export const persons_merge_body = /** @type {(inputs: Persons_Merge_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waits, links, references, external ids, aliases and the AI memo move to ${i?.keep}, and ${i?.from} goes away`)
};

export const persons_merge_failed = /** @type {(inputs: Persons_Merge_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not merge ${i?.from} into ${i?.keep}`)
};

export const persons_merge_label = /** @type {(inputs: Persons_Merge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge with the same person`)
};

export const persons_merge_menu = /** @type {(inputs: Persons_Merge_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merge with the same person…`)
};

export const persons_merge_note = /** @type {(inputs: Persons_Merge_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pick the other record of the same person. They are merged into ${i?.name} and go away`)
};

export const persons_merge_pick_title = /** @type {(inputs: Persons_Merge_Pick_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Who to merge into ${i?.name}`)
};

export const persons_merge_search = /** @type {(inputs: Persons_Merge_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the person to merge`)
};

export const persons_merge_title = /** @type {(inputs: Persons_Merge_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Merge ${i?.from} into ${i?.keep}`)
};

export const persons_name = /** @type {(inputs: Persons_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const persons_name_failed = /** @type {(inputs: Persons_Name_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change the name`)
};

export const persons_narrow = /** @type {(inputs: Persons_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow`)
};

export const persons_narrow_placeholder = /** @type {(inputs: Persons_Narrow_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow by name, note or id`)
};

export const persons_new = /** @type {(inputs: Persons_NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New person`)
};

export const persons_no_match = /** @type {(inputs: Persons_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No one matches`)
};

export const persons_not_found = /** @type {(inputs: Persons_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This person was not found`)
};

export const persons_now = /** @type {(inputs: Persons_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Now`)
};

export const persons_now_empty = /** @type {(inputs: Persons_Now_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing is waiting on them`)
};

export const persons_open_email = /** @type {(inputs: Persons_Open_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write an email`)
};

export const persons_open_github = /** @type {(inputs: Persons_Open_GithubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open on GitHub`)
};

export const persons_open_phone = /** @type {(inputs: Persons_Open_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call`)
};

export const persons_open_slack = /** @type {(inputs: Persons_Open_SlackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in Slack`)
};

export const persons_open_url = /** @type {(inputs: Persons_Open_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const persons_pick_action = /** @type {(inputs: Persons_Pick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose who`)
};

export const persons_pick_candidates = /** @type {(inputs: Persons_Pick_CandidatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestions`)
};

export const persons_pick_clear = /** @type {(inputs: Persons_Pick_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take the person off`)
};

export const persons_pick_none = /** @type {(inputs: Persons_Pick_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing found`)
};

export const persons_pick_placeholder = /** @type {(inputs: Persons_Pick_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who`)
};

export const persons_pick_search = /** @type {(inputs: Persons_Pick_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search people`)
};

export const persons_pick_search_or_create = /** @type {(inputs: Persons_Pick_Search_Or_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by name or alias / a new person's name`)
};

export const persons_pick_search_placeholder = /** @type {(inputs: Persons_Pick_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search by name or alias`)
};

export const persons_slack_workspace = /** @type {(inputs: Persons_Slack_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace id`)
};

export const persons_slack_workspace_placeholder = /** @type {(inputs: Persons_Slack_Workspace_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace id (T…)`)
};

export const persons_summary = /** @type {(inputs: Persons_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One line`)
};

export const persons_summary_failed = /** @type {(inputs: Persons_Summary_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change the line`)
};

export const persons_summary_placeholder = /** @type {(inputs: Persons_Summary_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who they are to you, in one line`)
};

export const persons_title = /** @type {(inputs: Persons_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

export const persons_unlink = /** @type {(inputs: Persons_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink member`)
};

export const persons_unlink_failed = /** @type {(inputs: Persons_Unlink_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not unlink the member`)
};

export const persons_waiting_count = /** @type {(inputs: Persons_Waiting_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting ${i?.count}`)
};

export const phone_doc_redo = /** @type {(inputs: Phone_Doc_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo`)
};

export const phone_doc_undo = /** @type {(inputs: Phone_Doc_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

export const phone_dock_settings = /** @type {(inputs: Phone_Dock_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone Dock`)
};

export const phone_dock_settings_cutoff = /** @type {(inputs: Phone_Dock_Settings_CutoffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places above this line go in the bottom bar`)
};

export const phone_dock_settings_description = /** @type {(inputs: Phone_Dock_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The places in the bar at the bottom of a phone, and their order. Kept on this device.`)
};

export const phone_dock_settings_me = /** @type {(inputs: Phone_Dock_Settings_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me`)
};

export const phone_dock_settings_move = /** @type {(inputs: Phone_Dock_Settings_MoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.label}`)
};

export const phone_dock_settings_no_place = /** @type {(inputs: Phone_Dock_Settings_No_PlaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In a workspace, its places are listed here too.`)
};

export const phone_dock_settings_note = /** @type {(inputs: Phone_Dock_Settings_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the top, as many as fit the screen's width go in the bottom bar. Me's places and the workspace's are kept apart in the bar.`)
};

export const phone_dock_settings_show = /** @type {(inputs: Phone_Dock_Settings_ShowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Show ${i?.label} in the Dock and the menu`)
};

export const phone_menu = /** @type {(inputs: Phone_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu`)
};

export const phone_menu_all = /** @type {(inputs: Phone_Menu_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All places`)
};

export const phone_menu_arrange = /** @type {(inputs: Phone_Menu_ArrangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrange the Dock`)
};

export const phone_menu_open = /** @type {(inputs: Phone_Menu_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open menu`)
};

export const phone_more = /** @type {(inputs: Phone_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

export const phone_more_current = /** @type {(inputs: Phone_More_CurrentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More (current: ${i?.label})`)
};

export const phone_place_menu = /** @type {(inputs: Phone_Place_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menu of ${i?.name}`)
};

export const phone_unread_named = /** @type {(inputs: Phone_Unread_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} (something new)`)
};

export const publishing_action = /** @type {(inputs: Publishing_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish`)
};

export const publishing_building = /** @type {(inputs: Publishing_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published. It takes a few seconds until the link can be read.`)
};

export const publishing_close = /** @type {(inputs: Publishing_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const publishing_copied = /** @type {(inputs: Publishing_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied`)
};

export const publishing_copy = /** @type {(inputs: Publishing_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy`)
};

export const publishing_copy_failed = /** @type {(inputs: Publishing_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy`)
};

export const publishing_dataset_more_fields = /** @type {(inputs: Publishing_Dataset_More_FieldsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} more`)
};

export const publishing_dataset_not_allowed = /** @type {(inputs: Publishing_Dataset_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workspace doesn't allow publishing by link`)
};

export const publishing_dataset_not_writable = /** @type {(inputs: Publishing_Dataset_Not_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have permission to write this dataset`)
};

export const publishing_dataset_rows = /** @type {(inputs: Publishing_Dataset_RowsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rows`)
};

export const publishing_datasets_blocked = /** @type {(inputs: Publishing_Datasets_BlockedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} datasets can't be published. Their UI shows no data on the published page.`)
};

export const publishing_datasets_confirm_body = /** @type {(inputs: Publishing_Datasets_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone with the link will be able to read all their rows and fields.`)
};

export const publishing_datasets_confirm_title = /** @type {(inputs: Publishing_Datasets_Confirm_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Publish ${i?.count} datasets`)
};

export const publishing_datasets_failed = /** @type {(inputs: Publishing_Datasets_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't publish the datasets`)
};

export const publishing_datasets_hidden = /** @type {(inputs: Publishing_Datasets_HiddenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} datasets weren't found`)
};

export const publishing_datasets_intro = /** @type {(inputs: Publishing_Datasets_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The datasets this document's UI reads. Anyone with the link will be able to read all their rows and fields.`)
};

export const publishing_datasets_pending = /** @type {(inputs: Publishing_Datasets_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This document reads datasets that aren't published. Their UI shows no data on the published page.`)
};

export const publishing_datasets_publish = /** @type {(inputs: Publishing_Datasets_PublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish datasets`)
};

export const publishing_datasets_published = /** @type {(inputs: Publishing_Datasets_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published datasets`)
};

export const publishing_datasets_title = /** @type {(inputs: Publishing_Datasets_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datasets published with it`)
};

export const publishing_failed = /** @type {(inputs: Publishing_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not publish`)
};

export const publishing_failing = /** @type {(inputs: Publishing_FailingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The published page could not be put again. It is being retried.`)
};

export const publishing_html_scripts = /** @type {(inputs: Publishing_Html_ScriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The scripts of an HTML document run on the published page too.`)
};

export const publishing_intro = /** @type {(inputs: Publishing_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone with the unguessable URL can read it without signing in. When you change the text, the published page follows a little later.`)
};

export const publishing_menu = /** @type {(inputs: Publishing_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish by link`)
};

export const publishing_open = /** @type {(inputs: Publishing_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const publishing_preview = /** @type {(inputs: Publishing_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview of the published page`)
};

export const publishing_preview_failed = /** @type {(inputs: Publishing_Preview_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not make the preview`)
};

export const publishing_published = /** @type {(inputs: Publishing_PublishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published by link`)
};

export const publishing_published_at = /** @type {(inputs: Publishing_Published_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Published ${i?.date}`)
};

export const publishing_published_pending = /** @type {(inputs: Publishing_Published_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published by link (some datasets aren't published)`)
};

export const publishing_stop = /** @type {(inputs: Publishing_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop publishing`)
};

export const publishing_stop_body = /** @type {(inputs: Publishing_Stop_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The link will no longer open it. Publishing again gives another URL.`)
};

export const publishing_stop_failed = /** @type {(inputs: Publishing_Stop_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not stop publishing`)
};

export const publishing_stop_title = /** @type {(inputs: Publishing_Stop_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stop publishing “${i?.title}”`)
};

export const publishing_title = /** @type {(inputs: Publishing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish by link`)
};

export const publishing_unpublished_links = /** @type {(inputs: Publishing_Unpublished_LinksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} links point at documents that are not published. The published page takes those links off.`)
};

export const publishing_unpublished_refs = /** @type {(inputs: Publishing_Unpublished_RefsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} references point at things that are not published. The published page shows only their kind.`)
};

export const publishing_url = /** @type {(inputs: Publishing_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published URL`)
};

export const refs_cannot_open_here = /** @type {(inputs: Refs_Cannot_Open_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This app cannot open it`)
};

export const refs_in_cloud = /** @type {(inputs: Refs_In_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In a Workspace on the Cloud (cannot open it here)`)
};

export const refs_missing_label = /** @type {(inputs: Refs_Missing_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} (${i?.why})`)
};

export const refs_not_found = /** @type {(inputs: Refs_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not found`)
};

export const refs_note_conflict = /** @type {(inputs: Refs_Note_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It was changed somewhere else, so this was not saved. The text above is the current one.`)
};

export const refs_note_conflict_drop = /** @type {(inputs: Refs_Note_Conflict_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop what you wrote`)
};

export const refs_note_conflict_use_mine = /** @type {(inputs: Refs_Note_Conflict_Use_MineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace with what you wrote`)
};

export const refs_note_conflict_yours = /** @type {(inputs: Refs_Note_Conflict_YoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you wrote`)
};

export const refs_save_failed_kept = /** @type {(inputs: Refs_Save_Failed_KeptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save (what you wrote is kept)`)
};

export const refs_unreachable = /** @type {(inputs: Refs_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not be read: the Cloud is not connected. It shows once it is`)
};

export const settings_app_open = /** @type {(inputs: Settings_App_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App settings`)
};

export const settings_app_open_description = /** @type {(inputs: Settings_App_Open_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens the settings of trameria on this PC (Cloud, Vault, backups, appearance and more) in a window of their own.`)
};

export const settings_app_open_description_device = /** @type {(inputs: Settings_App_Open_Description_DeviceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opens the settings of the trameria app on this device (appearance, notifications, Cloud, Vault).`)
};

export const settings_app_window_description = /** @type {(inputs: Settings_App_Window_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The settings of trameria on this PC. They apply to Cloud's screen too.`)
};

export const settings_appearance = /** @type {(inputs: Settings_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance`)
};

export const settings_appearance_description = /** @type {(inputs: Settings_Appearance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kept on this device.`)
};

export const settings_back_to_index = /** @type {(inputs: Settings_Back_To_IndexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to settings`)
};

export const settings_general = /** @type {(inputs: Settings_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

export const settings_general_description = /** @type {(inputs: Settings_General_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language and time zone. The same on every device.`)
};

export const settings_general_description_account = /** @type {(inputs: Settings_General_Description_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picture, name, language and time zone. The same on every device.`)
};

export const settings_group_app = /** @type {(inputs: Settings_Group_AppInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This app`)
};

export const settings_input = /** @type {(inputs: Settings_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input`)
};

export const settings_input_description = /** @type {(inputs: Settings_Input_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kept on this device, since keyboards differ between devices.`)
};

export const settings_language = /** @type {(inputs: Settings_LanguageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language`)
};

export const settings_language_browser = /** @type {(inputs: Settings_Language_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match the browser`)
};

export const settings_language_note = /** @type {(inputs: Settings_Language_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changing it reloads the screen.`)
};

export const settings_name = /** @type {(inputs: Settings_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

export const settings_picture = /** @type {(inputs: Settings_PictureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picture`)
};

export const settings_save_failed = /** @type {(inputs: Settings_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save`)
};

export const settings_send_key = /** @type {(inputs: Settings_Send_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send key`)
};

export const settings_send_key_enter = /** @type {(inputs: Settings_Send_Key_EnterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter sends`)
};

export const settings_send_key_mod = /** @type {(inputs: Settings_Send_Key_ModInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`⌘/Ctrl+Enter sends`)
};

export const settings_send_key_note = /** @type {(inputs: Settings_Send_Key_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The other one breaks the line.`)
};

export const settings_theme = /** @type {(inputs: Settings_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theme`)
};

export const settings_theme_auto = /** @type {(inputs: Settings_Theme_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

export const settings_theme_dark = /** @type {(inputs: Settings_Theme_DarkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

export const settings_theme_light = /** @type {(inputs: Settings_Theme_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

export const settings_theme_note = /** @type {(inputs: Settings_Theme_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto follows the system.`)
};

export const settings_time_zone = /** @type {(inputs: Settings_Time_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time zone`)
};

export const settings_time_zone_browser = /** @type {(inputs: Settings_Time_Zone_BrowserInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Match this device (${i?.zone})`)
};

export const settings_time_zone_note = /** @type {(inputs: Settings_Time_Zone_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used to show dates and for due dates and the secretary's jobs.`)
};

export const shell_account_menu = /** @type {(inputs: Shell_Account_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account menu`)
};

export const shell_back = /** @type {(inputs: Shell_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

export const shell_back_to_list = /** @type {(inputs: Shell_Back_To_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to the list`)
};

export const shell_clear_picks = /** @type {(inputs: Shell_Clear_PicksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear selection`)
};

export const shell_copied = /** @type {(inputs: Shell_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

export const shell_copy_failed = /** @type {(inputs: Shell_Copy_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not copy`)
};

export const shell_copy_link = /** @type {(inputs: Shell_Copy_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy link`)
};

export const shell_error_body = /** @type {(inputs: Shell_Error_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If reloading does not help, report it with the line below.`)
};

export const shell_error_reload = /** @type {(inputs: Shell_Error_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

export const shell_error_title = /** @type {(inputs: Shell_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This screen could not be shown`)
};

export const shell_favorites = /** @type {(inputs: Shell_FavoritesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorites`)
};

export const shell_favorites_add = /** @type {(inputs: Shell_Favorites_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to favorites`)
};

export const shell_favorites_add_failed = /** @type {(inputs: Shell_Favorites_Add_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not add ${i?.title} to favorites`)
};

export const shell_favorites_create_folder_failed = /** @type {(inputs: Shell_Favorites_Create_Folder_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not create the folder ${i?.name}`)
};

export const shell_favorites_delete_folder = /** @type {(inputs: Shell_Favorites_Delete_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete folder`)
};

export const shell_favorites_delete_folder_body = /** @type {(inputs: Shell_Favorites_Delete_Folder_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The favorites in it move out of the folder.`)
};

export const shell_favorites_delete_folder_failed = /** @type {(inputs: Shell_Favorites_Delete_Folder_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not delete the folder ${i?.name}`)
};

export const shell_favorites_delete_folder_title = /** @type {(inputs: Shell_Favorites_Delete_Folder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete the folder ${i?.name}`)
};

export const shell_favorites_empty = /** @type {(inputs: Shell_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press a star to keep things here`)
};

export const shell_favorites_folder_menu = /** @type {(inputs: Shell_Favorites_Folder_MenuInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Menu of ${i?.name}`)
};

export const shell_favorites_folder_name = /** @type {(inputs: Shell_Favorites_Folder_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder name`)
};

export const shell_favorites_move_failed = /** @type {(inputs: Shell_Favorites_Move_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not move the favorite`)
};

export const shell_favorites_new_folder = /** @type {(inputs: Shell_Favorites_New_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New folder`)
};

export const shell_favorites_remove = /** @type {(inputs: Shell_Favorites_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from favorites`)
};

export const shell_favorites_remove_failed = /** @type {(inputs: Shell_Favorites_Remove_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not remove ${i?.title} from favorites`)
};

export const shell_favorites_rename = /** @type {(inputs: Shell_Favorites_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

export const shell_favorites_rename_failed = /** @type {(inputs: Shell_Favorites_Rename_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Could not rename the folder ${i?.name}`)
};

export const shell_fold_sidebar = /** @type {(inputs: Shell_Fold_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fold the sidebar`)
};

export const shell_hub_away = /** @type {(inputs: Shell_Hub_AwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't connect to the Vault. Your changes will be applied when it reconnects`)
};

export const shell_keep_sidebar_open = /** @type {(inputs: Shell_Keep_Sidebar_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep the sidebar open`)
};

export const shell_language_auto = /** @type {(inputs: Shell_Language_AutoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto`)
};

export const shell_list_fold = /** @type {(inputs: Shell_List_FoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse`)
};

export const shell_list_fold_rest = /** @type {(inputs: Shell_List_Fold_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} more`)
};

export const shell_list_narrow = /** @type {(inputs: Shell_List_NarrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow the list`)
};

export const shell_list_narrow_title = /** @type {(inputs: Shell_List_Narrow_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Narrow by title`)
};

export const shell_list_no_match = /** @type {(inputs: Shell_List_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing matches`)
};

export const shell_me = /** @type {(inputs: Shell_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me`)
};

export const shell_me_away_settings = /** @type {(inputs: Shell_Me_Away_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open settings`)
};

export const shell_me_empty = /** @type {(inputs: Shell_Me_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbox, Cases, People, Agents and Documents will be listed here.`)
};

export const shell_me_moving_almost = /** @type {(inputs: Shell_Me_Moving_AlmostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almost done`)
};

export const shell_me_moving_done = /** @type {(inputs: Shell_Me_Moving_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.percent}% · ${i?.left}`)
};

export const shell_me_moving_measuring = /** @type {(inputs: Shell_Me_Moving_MeasuringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working out the time left`)
};

export const shell_me_moving_minutes = /** @type {(inputs: Shell_Me_Moving_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`About ${i?.minutes} minutes left`)
};

export const shell_me_moving_progress = /** @type {(inputs: Shell_Me_Moving_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How far personal data has moved`)
};

export const shell_me_moving_under_minute = /** @type {(inputs: Shell_Me_Moving_Under_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About a minute left`)
};

export const shell_not_found_body = /** @type {(inputs: Shell_Not_Found_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The URL is wrong, or it was deleted.`)
};

export const shell_not_found_title = /** @type {(inputs: Shell_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not found`)
};

export const shell_open_sidebar = /** @type {(inputs: Shell_Open_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the sidebar`)
};

export const shell_personal_data_not_workspace = /** @type {(inputs: Shell_Personal_Data_Not_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workspaces' documents, spaces, DMs and issues are not included.`)
};

export const shell_personal_documents = /** @type {(inputs: Shell_Personal_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal documents`)
};

export const shell_personal_in_cloud = /** @type {(inputs: Shell_Personal_In_CloudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved in Cloud. Only you can see the items here`)
};

export const shell_personal_in_vault = /** @type {(inputs: Shell_Personal_In_VaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved in Vault. Only you can see the items here`)
};

export const shell_personal_only = /** @type {(inputs: Shell_Personal_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only you can see the items here`)
};

export const shell_pick_actions = /** @type {(inputs: Shell_Pick_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

export const shell_pick_count_label = /** @type {(inputs: Shell_Pick_Count_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.base} (${i?.n})`)
};

export const shell_pick_names_join = /** @type {(inputs: Shell_Pick_Names_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`, `)
};

export const shell_pick_names_more = /** @type {(inputs: Shell_Pick_Names_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.head}, and ${i?.rest} more`)
};

export const shell_pick_quoted = /** @type {(inputs: Shell_Pick_QuotedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.title}"`)
};

export const shell_pick_row = /** @type {(inputs: Shell_Pick_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select ${i?.title}`)
};

export const shell_picked_actions = /** @type {(inputs: Shell_Picked_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions for selection`)
};

export const shell_picked_count = /** @type {(inputs: Shell_Picked_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

export const shell_rail_personal = /** @type {(inputs: Shell_Rail_PersonalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal data`)
};

export const shell_resize_sidebar = /** @type {(inputs: Shell_Resize_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidebar width`)
};

export const shell_route_pending = /** @type {(inputs: Shell_Route_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weaving…`)
};

export const shell_settings = /** @type {(inputs: Shell_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

export const shell_settings_back = /** @type {(inputs: Shell_Settings_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close settings`)
};

export const shell_settings_description = /** @type {(inputs: Shell_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your own settings, for every screen.`)
};

export const shell_settings_no_match = /** @type {(inputs: Shell_Settings_No_MatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No settings match`)
};

export const shell_settings_search = /** @type {(inputs: Shell_Settings_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search settings`)
};

export const shell_shortcuts = /** @type {(inputs: Shell_ShortcutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyboard shortcuts`)
};

export const shell_shortcuts_group_create = /** @type {(inputs: Shell_Shortcuts_Group_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

export const shell_shortcuts_group_general = /** @type {(inputs: Shell_Shortcuts_Group_GeneralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

export const shell_shortcuts_group_navigate = /** @type {(inputs: Shell_Shortcuts_Group_NavigateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigate`)
};

export const shell_shortcuts_group_view = /** @type {(inputs: Shell_Shortcuts_Group_ViewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View`)
};

export const shell_side_close = /** @type {(inputs: Shell_Side_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const shell_side_open_full = /** @type {(inputs: Shell_Side_Open_FullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open on its own screen`)
};

export const shell_toggle_sidebar = /** @type {(inputs: Shell_Toggle_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fold or expand the sidebar`)
};

export const shell_unreachable_cannot_open = /** @type {(inputs: Shell_Unreachable_Cannot_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't connect to the Vault. Only screens opened before can be shown`)
};

export const shell_wide = /** @type {(inputs: Shell_WideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full width`)
};

export const shell_wide_off = /** @type {(inputs: Shell_Wide_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit full width`)
};

export const shell_wide_toggle = /** @type {(inputs: Shell_Wide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle full width`)
};

export const shell_window_close = /** @type {(inputs: Shell_Window_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const shell_window_maximize = /** @type {(inputs: Shell_Window_MaximizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximize`)
};

export const shell_window_minimize = /** @type {(inputs: Shell_Window_MinimizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimize`)
};

export const shell_window_restore = /** @type {(inputs: Shell_Window_RestoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore`)
};

export const shell_workspace_change = /** @type {(inputs: Shell_Workspace_ChangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Change workspace (${i?.name})`)
};

export const shell_workspace_change_many = /** @type {(inputs: Shell_Workspace_Change_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Change workspaces (${i?.names})`)
};

export const shell_workspace_col = /** @type {(inputs: Shell_Workspace_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS`)
};

export const shell_workspace_failed = /** @type {(inputs: Shell_Workspace_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not change the workspace`)
};

export const shell_workspace_left = /** @type {(inputs: Shell_Workspace_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (left workspace)`)
};

export const shell_workspace_offline = /** @type {(inputs: Shell_Workspace_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected to Cloud, so it cannot be changed`)
};

export const shell_workspace_remove = /** @type {(inputs: Shell_Workspace_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take out of workspace`)
};

export const shell_workspace_set = /** @type {(inputs: Shell_Workspace_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a workspace`)
};

export const timeblocker_accounts = /** @type {(inputs: Timeblocker_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected accounts`)
};

export const timeblocker_activity_agent_run = /** @type {(inputs: Timeblocker_Activity_Agent_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat ran`)
};

export const timeblocker_activity_case_closed = /** @type {(inputs: Timeblocker_Activity_Case_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case done`)
};

export const timeblocker_activity_step_closed = /** @type {(inputs: Timeblocker_Activity_Step_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action done`)
};

export const timeblocker_add_block = /** @type {(inputs: Timeblocker_Add_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Block`)
};

export const timeblocker_add_lane = /** @type {(inputs: Timeblocker_Add_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add lane`)
};

export const timeblocker_all_day = /** @type {(inputs: Timeblocker_All_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All day`)
};

export const timeblocker_block_ended = /** @type {(inputs: Timeblocker_Block_EndedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ended`)
};

export const timeblocker_block_label = /** @type {(inputs: Timeblocker_Block_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.title} (${i?.start}–${i?.end})`)
};

export const timeblocker_block_remove = /** @type {(inputs: Timeblocker_Block_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Block`)
};

export const timeblocker_calendar = /** @type {(inputs: Timeblocker_CalendarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar`)
};

export const timeblocker_calendar_error = /** @type {(inputs: Timeblocker_Calendar_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't read ${i?.name}`)
};

export const timeblocker_calendar_settings = /** @type {(inputs: Timeblocker_Calendar_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar settings`)
};

export const timeblocker_calendars = /** @type {(inputs: Timeblocker_CalendarsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendars`)
};

export const timeblocker_cancel = /** @type {(inputs: Timeblocker_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

export const timeblocker_case_add_whole = /** @type {(inputs: Timeblocker_Case_Add_WholeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add whole Case`)
};

export const timeblocker_case_whole = /** @type {(inputs: Timeblocker_Case_WholeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whole Case`)
};

export const timeblocker_cases = /** @type {(inputs: Timeblocker_CasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases`)
};

export const timeblocker_change_deferred = /** @type {(inputs: Timeblocker_Change_DeferredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put off`)
};

export const timeblocker_change_moved = /** @type {(inputs: Timeblocker_Change_MovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed`)
};

export const timeblocker_close = /** @type {(inputs: Timeblocker_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

export const timeblocker_color = /** @type {(inputs: Timeblocker_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

export const timeblocker_color_of = /** @type {(inputs: Timeblocker_Color_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Color of ${i?.name}`)
};

export const timeblocker_connect_description = /** @type {(inputs: Timeblocker_Connect_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a Google account on the consent screen. It doesn't have to be the one you sign in with`)
};

export const timeblocker_connect_failed = /** @type {(inputs: Timeblocker_Connect_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't connect Google Calendar`)
};

export const timeblocker_connect_google = /** @type {(inputs: Timeblocker_Connect_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google Calendar`)
};

export const timeblocker_connect_more = /** @type {(inputs: Timeblocker_Connect_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect another account`)
};

export const timeblocker_create_event = /** @type {(inputs: Timeblocker_Create_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

export const timeblocker_date = /** @type {(inputs: Timeblocker_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

export const timeblocker_delete_event = /** @type {(inputs: Timeblocker_Delete_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete event`)
};

export const timeblocker_delete_event_confirm = /** @type {(inputs: Timeblocker_Delete_Event_ConfirmInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.title}" from Google Calendar?`)
};

export const timeblocker_delete_lane = /** @type {(inputs: Timeblocker_Delete_LaneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete lane`)
};

export const timeblocker_detail = /** @type {(inputs: Timeblocker_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Block`)
};

export const timeblocker_did_activity = /** @type {(inputs: Timeblocker_Did_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moved`)
};

export const timeblocker_did_none = /** @type {(inputs: Timeblocker_Did_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing`)
};

export const timeblocker_did_started = /** @type {(inputs: Timeblocker_Did_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Started`)
};

export const timeblocker_did_upcoming = /** @type {(inputs: Timeblocker_Did_UpcomingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming`)
};

export const timeblocker_disconnect = /** @type {(inputs: Timeblocker_DisconnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnect`)
};

export const timeblocker_disconnect_body = /** @type {(inputs: Timeblocker_Disconnect_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Its calendars no longer show in TimeBlocker.`)
};

export const timeblocker_disconnect_failed = /** @type {(inputs: Timeblocker_Disconnect_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Couldn't disconnect "${i?.email}"`)
};

export const timeblocker_disconnect_title = /** @type {(inputs: Timeblocker_Disconnect_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Disconnect "${i?.email}"`)
};

export const timeblocker_done = /** @type {(inputs: Timeblocker_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

export const timeblocker_empty_done = /** @type {(inputs: Timeblocker_Empty_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Actions finished on this day`)
};

export const timeblocker_empty_todo = /** @type {(inputs: Timeblocker_Empty_TodoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Actions planned for this day`)
};

export const timeblocker_end = /** @type {(inputs: Timeblocker_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

export const timeblocker_end_block = /** @type {(inputs: Timeblocker_End_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

export const timeblocker_end_date = /** @type {(inputs: Timeblocker_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End date`)
};

export const timeblocker_event_bad_dates = /** @type {(inputs: Timeblocker_Event_Bad_DatesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The end date must be on or after the start date`)
};

export const timeblocker_event_conflict = /** @type {(inputs: Timeblocker_Event_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The event was changed in the calendar, so the latest is shown`)
};

export const timeblocker_event_detail = /** @type {(inputs: Timeblocker_Event_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event details`)
};

export const timeblocker_event_title = /** @type {(inputs: Timeblocker_Event_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event name`)
};

export const timeblocker_event_too_short = /** @type {(inputs: Timeblocker_Event_Too_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events must be at least 15 minutes long`)
};

export const timeblocker_go = /** @type {(inputs: Timeblocker_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to TimeBlocker`)
};

export const timeblocker_go_today = /** @type {(inputs: Timeblocker_Go_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

export const timeblocker_google_connected = /** @type {(inputs: Timeblocker_Google_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected Google Calendar`)
};

export const timeblocker_google_denied = /** @type {(inputs: Timeblocker_Google_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google didn't grant access, so nothing was connected`)
};

export const timeblocker_google_failed = /** @type {(inputs: Timeblocker_Google_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't connect Google Calendar. Please try again`)
};

export const timeblocker_google_not_granted = /** @type {(inputs: Timeblocker_Google_Not_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access to the calendar wasn't granted. Connect again and check the calendar items on the consent screen`)
};

export const timeblocker_google_unavailable = /** @type {(inputs: Timeblocker_Google_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Calendar isn't available on this server`)
};

export const timeblocker_google_wrong_account = /** @type {(inputs: Timeblocker_Google_Wrong_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A different Google account was chosen on the consent screen. Choose the account to connect again`)
};

export const timeblocker_group_after = /** @type {(inputs: Timeblocker_Group_AfterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`After ${i?.date}`)
};

export const timeblocker_group_after_today = /** @type {(inputs: Timeblocker_Group_After_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow and later`)
};

export const timeblocker_group_before = /** @type {(inputs: Timeblocker_Group_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Before ${i?.date}`)
};

export const timeblocker_group_before_today = /** @type {(inputs: Timeblocker_Group_Before_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before today`)
};

export const timeblocker_group_today = /** @type {(inputs: Timeblocker_Group_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

export const timeblocker_group_undated = /** @type {(inputs: Timeblocker_Group_UndatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No date`)
};

export const timeblocker_item_start = /** @type {(inputs: Timeblocker_Item_StartInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Start “${i?.title}”`)
};

export const timeblocker_item_stop = /** @type {(inputs: Timeblocker_Item_StopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stop “${i?.title}”`)
};

export const timeblocker_item_working = /** @type {(inputs: Timeblocker_Item_WorkingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working`)
};

export const timeblocker_join_here = /** @type {(inputs: Timeblocker_Join_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Put it in this Block`)
};

export const timeblocker_join_meeting = /** @type {(inputs: Timeblocker_Join_MeetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join meeting`)
};

export const timeblocker_kind_action = /** @type {(inputs: Timeblocker_Kind_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action`)
};

export const timeblocker_kind_case = /** @type {(inputs: Timeblocker_Kind_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case`)
};

export const timeblocker_lane_me = /** @type {(inputs: Timeblocker_Lane_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me`)
};

export const timeblocker_lane_name = /** @type {(inputs: Timeblocker_Lane_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lane name`)
};

export const timeblocker_lane_none = /** @type {(inputs: Timeblocker_Lane_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

export const timeblocker_lane_of = /** @type {(inputs: Timeblocker_Lane_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lane for ${i?.name}`)
};

export const timeblocker_lanes = /** @type {(inputs: Timeblocker_LanesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanes`)
};

export const timeblocker_lanes_note = /** @type {(inputs: Timeblocker_Lanes_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"Me" comes first, with the time blocks. Lanes you add sit beside it`)
};

export const timeblocker_link_empty = /** @type {(inputs: Timeblocker_Link_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matches`)
};

export const timeblocker_link_search = /** @type {(inputs: Timeblocker_Link_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a Case or Action to add`)
};

export const timeblocker_lists = /** @type {(inputs: Timeblocker_ListsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases and Actions`)
};

export const timeblocker_load_failed = /** @type {(inputs: Timeblocker_Load_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load`)
};

export const timeblocker_mark_done = /** @type {(inputs: Timeblocker_Mark_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as done`)
};

export const timeblocker_mark_done_of = /** @type {(inputs: Timeblocker_Mark_Done_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mark "${i?.title}" as done`)
};

export const timeblocker_more = /** @type {(inputs: Timeblocker_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} more`)
};

export const timeblocker_new_event = /** @type {(inputs: Timeblocker_New_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New event`)
};

export const timeblocker_next_day = /** @type {(inputs: Timeblocker_Next_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next day`)
};

export const timeblocker_next_week = /** @type {(inputs: Timeblocker_Next_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next week`)
};

export const timeblocker_no_accounts = /** @type {(inputs: Timeblocker_No_AccountsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not connected yet. Google will ask for your permission`)
};

export const timeblocker_no_actions = /** @type {(inputs: Timeblocker_No_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Actions`)
};

export const timeblocker_no_writable = /** @type {(inputs: Timeblocker_No_WritableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No calendar you can write to. Show one of your calendars in a lane in Calendar settings`)
};

export const timeblocker_open_case = /** @type {(inputs: Timeblocker_Open_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Case`)
};

export const timeblocker_open_google = /** @type {(inputs: Timeblocker_Open_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in Google Calendar`)
};

export const timeblocker_pick_action = /** @type {(inputs: Timeblocker_Pick_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an Action`)
};

export const timeblocker_pick_date = /** @type {(inputs: Timeblocker_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date`)
};

export const timeblocker_plan = /** @type {(inputs: Timeblocker_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do on`)
};

export const timeblocker_prev_day = /** @type {(inputs: Timeblocker_Prev_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous day`)
};

export const timeblocker_prev_week = /** @type {(inputs: Timeblocker_Prev_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous week`)
};

export const timeblocker_read_only = /** @type {(inputs: Timeblocker_Read_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View only`)
};

export const timeblocker_recurring_one = /** @type {(inputs: Timeblocker_Recurring_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a recurring event, only this occurrence changes`)
};

export const timeblocker_redo = /** @type {(inputs: Timeblocker_RedoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo`)
};

export const timeblocker_redo_failed = /** @type {(inputs: Timeblocker_Redo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't redo`)
};

export const timeblocker_reopen = /** @type {(inputs: Timeblocker_ReopenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as not done`)
};

export const timeblocker_reset_color = /** @type {(inputs: Timeblocker_Reset_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Google's color`)
};

export const timeblocker_resume_block = /** @type {(inputs: Timeblocker_Resume_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

export const timeblocker_resync = /** @type {(inputs: Timeblocker_ResyncInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh list`)
};

export const timeblocker_review = /** @type {(inputs: Timeblocker_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review`)
};

export const timeblocker_review_actual = /** @type {(inputs: Timeblocker_Review_ActualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

export const timeblocker_review_changes = /** @type {(inputs: Timeblocker_Review_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed after start`)
};

export const timeblocker_review_changes_deferred = /** @type {(inputs: Timeblocker_Review_Changes_DeferredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Put off to another day ${i?.count}`)
};

export const timeblocker_review_changes_moved = /** @type {(inputs: Timeblocker_Review_Changes_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moved ${i?.count}`)
};

export const timeblocker_review_changes_shortened = /** @type {(inputs: Timeblocker_Review_Changes_ShortenedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shortened ${i?.count}`)
};

export const timeblocker_review_deferred_from = /** @type {(inputs: Timeblocker_Review_Deferred_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Put off from ${i?.day} ${i?.time}`)
};

export const timeblocker_review_deferred_to = /** @type {(inputs: Timeblocker_Review_Deferred_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`→ ${i?.day} ${i?.time}`)
};

export const timeblocker_review_done = /** @type {(inputs: Timeblocker_Review_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done`)
};

export const timeblocker_review_done_of = /** @type {(inputs: Timeblocker_Review_Done_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked Cases and Actions`)
};

export const timeblocker_review_empty = /** @type {(inputs: Timeblocker_Review_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Blocks this week`)
};

export const timeblocker_review_link = /** @type {(inputs: Timeblocker_Review_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link`)
};

export const timeblocker_review_linked = /** @type {(inputs: Timeblocker_Review_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linked`)
};

export const timeblocker_review_moved = /** @type {(inputs: Timeblocker_Review_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`What moved ${i?.count}`)
};

export const timeblocker_review_moved_to = /** @type {(inputs: Timeblocker_Review_Moved_ToInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`→ ${i?.time}`)
};

export const timeblocker_review_of = /** @type {(inputs: Timeblocker_Review_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Review of ${i?.range}`)
};

export const timeblocker_review_planned = /** @type {(inputs: Timeblocker_Review_PlannedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned`)
};

export const timeblocker_review_planned_committed = /** @type {(inputs: Timeblocker_Review_Planned_CommittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Committed plans`)
};

export const timeblocker_review_planned_of = /** @type {(inputs: Timeblocker_Review_Planned_OfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Including what is still to come`)
};

export const timeblocker_review_rate = /** @type {(inputs: Timeblocker_Review_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kept`)
};

export const timeblocker_review_rate_of = /** @type {(inputs: Timeblocker_Review_Rate_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.did} of ${i?.all} past Blocks`)
};

export const timeblocker_review_ratio = /** @type {(inputs: Timeblocker_Review_RatioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual ÷ planned`)
};

export const timeblocker_review_ratio_of = /** @type {(inputs: Timeblocker_Review_Ratio_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Of ${i?.planned} past`)
};

export const timeblocker_review_unlinked_block = /** @type {(inputs: Timeblocker_Review_Unlinked_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not linked`)
};

export const timeblocker_review_untitled_chat = /** @type {(inputs: Timeblocker_Review_Untitled_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untitled chat`)
};

export const timeblocker_save_failed = /** @type {(inputs: Timeblocker_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't save`)
};

export const timeblocker_settings_description = /** @type {(inputs: Timeblocker_Settings_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Google accounts and choose which calendars show in which lane of TimeBlocker. Separate from the account you sign in with.`)
};

export const timeblocker_settings_title = /** @type {(inputs: Timeblocker_Settings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Calendar`)
};

export const timeblocker_show_actions = /** @type {(inputs: Timeblocker_Show_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Actions`)
};

export const timeblocker_start = /** @type {(inputs: Timeblocker_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const timeblocker_start_block = /** @type {(inputs: Timeblocker_Start_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const timeblocker_start_date = /** @type {(inputs: Timeblocker_Start_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start date`)
};

export const timeblocker_tabs = /** @type {(inputs: Timeblocker_TabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items to show`)
};

export const timeblocker_this_week = /** @type {(inputs: Timeblocker_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This week`)
};

export const timeblocker_time = /** @type {(inputs: Timeblocker_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

export const timeblocker_timeline = /** @type {(inputs: Timeblocker_TimelineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Timeline for ${i?.date}`)
};

export const timeblocker_title = /** @type {(inputs: Timeblocker_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TimeBlocker`)
};

export const timeblocker_title_label = /** @type {(inputs: Timeblocker_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

export const timeblocker_todo = /** @type {(inputs: Timeblocker_TodoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To do`)
};

export const timeblocker_undated_drop = /** @type {(inputs: Timeblocker_Undated_DropInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop here to make it undated and take it off its Blocks`)
};

export const timeblocker_undo = /** @type {(inputs: Timeblocker_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

export const timeblocker_undo_failed = /** @type {(inputs: Timeblocker_Undo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't undo`)
};

export const timeblocker_unlink = /** @type {(inputs: Timeblocker_UnlinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlink`)
};

export const timeblocker_untitled = /** @type {(inputs: Timeblocker_UntitledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(No title)`)
};

export const timeblocker_week_range = /** @type {(inputs: Timeblocker_Week_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from} – ${i?.to}`)
};

export const timeblocker_work_label = /** @type {(inputs: Timeblocker_Work_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work`)
};

export const timeblocker_work_log = /** @type {(inputs: Timeblocker_Work_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Work log`)
};

export const timeblocker_work_log_delete = /** @type {(inputs: Timeblocker_Work_Log_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

export const timeblocker_work_log_label = /** @type {(inputs: Timeblocker_Work_Log_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Work log ${i?.start}–${i?.end}`)
};

export const timeblocker_work_log_now = /** @type {(inputs: Timeblocker_Work_Log_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`now`)
};

export const timeblocker_work_running = /** @type {(inputs: Timeblocker_Work_RunningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Working ${i?.elapsed}`)
};

export const timeblocker_work_running_of = /** @type {(inputs: Timeblocker_Work_Running_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Working on ${i?.title} (${i?.elapsed})`)
};

export const timeblocker_work_start = /** @type {(inputs: Timeblocker_Work_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start working`)
};

export const timeblocker_work_start_short = /** @type {(inputs: Timeblocker_Work_Start_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const timeblocker_work_stop = /** @type {(inputs: Timeblocker_Work_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop working`)
};

export const timeblocker_work_stop_short = /** @type {(inputs: Timeblocker_Work_Stop_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop`)
};

export const timeblocker_work_total = /** @type {(inputs: Timeblocker_Work_TotalInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} this day`)
};

export const uifence_answer = /** @type {(inputs: Uifence_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answer`)
};

export const uifence_answer_detail = /** @type {(inputs: Uifence_Answer_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The UI in this item wants to send it as your answer. Once sent, the item closes and the agent reads it as your answer.`)
};

export const uifence_answer_title = /** @type {(inputs: Uifence_Answer_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send this as your answer?`)
};

export const uifence_building = /** @type {(inputs: Uifence_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building the UI`)
};

export const uifence_calendar_next_month = /** @type {(inputs: Uifence_Calendar_Next_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next month`)
};

export const uifence_calendar_pick = /** @type {(inputs: Uifence_Calendar_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date`)
};

export const uifence_calendar_prev_month = /** @type {(inputs: Uifence_Calendar_Prev_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous month`)
};

export const uifence_calendar_today = /** @type {(inputs: Uifence_Calendar_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set to today`)
};

export const uifence_chart_others = /** @type {(inputs: Uifence_Chart_OthersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} more`)
};

export const uifence_choose = /** @type {(inputs: Uifence_ChooseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose`)
};

export const uifence_copy_source = /** @type {(inputs: Uifence_Copy_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy source`)
};

export const uifence_count_left = /** @type {(inputs: Uifence_Count_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`← ${i?.count} more`)
};

export const uifence_count_right = /** @type {(inputs: Uifence_Count_RightInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} more →`)
};

export const uifence_data_all_rows = /** @type {(inputs: Uifence_Data_All_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All rows`)
};

export const uifence_data_button = /** @type {(inputs: Uifence_Data_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dataset`)
};

export const uifence_data_not_found = /** @type {(inputs: Uifence_Data_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't open this Dataset`)
};

export const uifence_data_not_found_detail = /** @type {(inputs: Uifence_Data_Not_Found_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It was deleted, or you don't have access to it.`)
};

export const uifence_data_query = /** @type {(inputs: Uifence_Data_QueryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Query`)
};

export const uifence_date = /** @type {(inputs: Uifence_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

export const uifence_end = /** @type {(inputs: Uifence_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End`)
};

export const uifence_failed = /** @type {(inputs: Uifence_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This UI couldn't run`)
};

export const uifence_funnel_from_first = /** @type {(inputs: Uifence_Funnel_From_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From first`)
};

export const uifence_funnel_from_previous = /** @type {(inputs: Uifence_Funnel_From_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From previous`)
};

export const uifence_heatmap = /** @type {(inputs: Uifence_HeatmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heatmap`)
};

export const uifence_hide_source = /** @type {(inputs: Uifence_Hide_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide source`)
};

export const uifence_insert = /** @type {(inputs: Uifence_InsertInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive UI`)
};

export const uifence_label = /** @type {(inputs: Uifence_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interactive UI`)
};

export const uifence_more_left = /** @type {(inputs: Uifence_More_LeftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← More`)
};

export const uifence_more_right = /** @type {(inputs: Uifence_More_RightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More →`)
};

export const uifence_next_image = /** @type {(inputs: Uifence_Next_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next image`)
};

export const uifence_no = /** @type {(inputs: Uifence_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

export const uifence_no_data = /** @type {(inputs: Uifence_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data`)
};

export const uifence_no_events = /** @type {(inputs: Uifence_No_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events`)
};

export const uifence_open_link = /** @type {(inputs: Uifence_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

export const uifence_open_link_detail = /** @type {(inputs: Uifence_Open_Link_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This link is inside the UI. Check that it goes where you expect before opening it. It opens in a new tab.`)
};

export const uifence_open_link_title = /** @type {(inputs: Uifence_Open_Link_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open an external site?`)
};

export const uifence_picker_clear = /** @type {(inputs: Uifence_Picker_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

export const uifence_prev_image = /** @type {(inputs: Uifence_Prev_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous image`)
};

export const uifence_quiz_correct = /** @type {(inputs: Uifence_Quiz_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct`)
};

export const uifence_quiz_hint = /** @type {(inputs: Uifence_Quiz_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an answer to see the correct one`)
};

export const uifence_quiz_hint_explained = /** @type {(inputs: Uifence_Quiz_Hint_ExplainedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose an answer to see the correct one and the explanation`)
};

export const uifence_quiz_picked_wrong = /** @type {(inputs: Uifence_Quiz_Picked_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your answer (incorrect)`)
};

export const uifence_quiz_wrong = /** @type {(inputs: Uifence_Quiz_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorrect`)
};

export const uifence_range_next_day = /** @type {(inputs: Uifence_Range_Next_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`+1`)
};

export const uifence_range_reversed = /** @type {(inputs: Uifence_Range_ReversedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`End is before start`)
};

export const uifence_range_same = /** @type {(inputs: Uifence_Range_SameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start and end are the same`)
};

export const uifence_range_sep = /** @type {(inputs: Uifence_Range_SepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`–`)
};

export const uifence_send = /** @type {(inputs: Uifence_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send`)
};

export const uifence_send_detail = /** @type {(inputs: Uifence_Send_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The UI in the reply wants to send it. Once sent, the agent reads it and replies.`)
};

export const uifence_send_title = /** @type {(inputs: Uifence_Send_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send this message to the conversation as you?`)
};

export const uifence_show_source = /** @type {(inputs: Uifence_Show_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show source`)
};

export const uifence_source = /** @type {(inputs: Uifence_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

export const uifence_spark_range = /** @type {(inputs: Uifence_Spark_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.first} to ${i?.last} (min ${i?.min}, max ${i?.max})`)
};

export const uifence_stale = /** @type {(inputs: Uifence_StaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't apply this action`)
};

export const uifence_start = /** @type {(inputs: Uifence_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start`)
};

export const uifence_time = /** @type {(inputs: Uifence_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

export const uifence_time_hour = /** @type {(inputs: Uifence_Time_HourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hour`)
};

export const uifence_time_minute = /** @type {(inputs: Uifence_Time_MinuteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min`)
};

export const uifence_time_now = /** @type {(inputs: Uifence_Time_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set to now`)
};

export const uifence_time_pick = /** @type {(inputs: Uifence_Time_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a time`)
};

export const uifence_total = /** @type {(inputs: Uifence_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

export const uifence_waterfall_down = /** @type {(inputs: Uifence_Waterfall_DownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decrease`)
};

export const uifence_waterfall_running = /** @type {(inputs: Uifence_Waterfall_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running total`)
};

export const uifence_waterfall_up = /** @type {(inputs: Uifence_Waterfall_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase`)
};

export const uifence_yes = /** @type {(inputs: Uifence_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes`)
};